<template>
  <div class="c1-main" :class="{ 'c1-ham-open': c1HamMenuOpen, 'c1-shift-open': c1ShiftMenuOpen }" @click="c1HamMenuOpen = false; c1ShiftMenuOpen = false; c1ClockOpen = false">

    <!-- SHIFT START MODAL -->
    <transition name="c1-shift-modal-fade">
      <div v-if="c1ShiftModal" class="c1-shift-modal-overlay">
        <div class="c1-shift-modal-card">
          <div class="c1-shift-modal-icon">⏱</div>
          <div class="c1-shift-modal-title">Start Your Shift</div>
          <div class="c1-shift-modal-sub">{{ new Date().toLocaleDateString('en-GB', { weekday:'long', day:'numeric', month:'long' }) }}</div>
          <div class="c1-shift-modal-time">{{ new Date().toLocaleTimeString('en-GB', { hour:'2-digit', minute:'2-digit' }) }}</div>
          <div class="c1-shift-modal-hint">Click to confirm you are starting your shift now. This is recorded.</div>
          <button class="c1-shift-modal-btn" @click="c1ConfirmShiftStart">▶ Start Shift</button>
        </div>
      </div>
    </transition>

    <!-- STICKY TOP ZONE: topbar + drawers — all in flow, pushes content -->
    <div class="c1-sticky-top">

    <!-- TOP BAR -->
    <div class="c1-tib" @click="c1SlideOpen = null">

      <!-- LEFT — Viki face + shift elapsed -->
      <div class="c1-tib-side c1-tib-left" style="padding-left:0;gap:6px;">
        <div class="c1-viki-topface"
          :class="{ 'c1-viki-topface--active': c1PanelActiveContent === 'viki' }"
          @click.stop="c1SelectPanel('viki','')"
        >
          <viki-face :mood="c1VikiMood" :speaking="c1VikiSpeaking" :size="44" style="width:72px;height:44px;display:block;overflow:hidden;border-radius:0;"/>
        </div>
        <div class="c1-shift-wrap" @click.stop="c1ShiftMenuOpen = !c1ShiftMenuOpen; c1HamMenuOpen = false">
          <div class="c1-tib-shift-pill" :class="{ open: c1ShiftMenuOpen }">
            ⏱ {{ c1ShiftElapsed }}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:10px;height:10px;margin-left:3px;transition:transform .2s" :style="{ transform: c1ShiftMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)' }"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
        </div>
      </div>

      <!-- CENTER — clock toggle -->
      <div class="c1-tib-center">
        <div class="c1-clock-pill" :class="{ open: c1ClockOpen }" @click.stop="c1ClockOpen = !c1ClockOpen; c1HamMenuOpen = false; c1ShiftMenuOpen = false">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:11px;height:11px;flex-shrink:0"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          <span class="c1-clock-pill-lbl">{{ c1TzIL }}</span>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:9px;height:9px;flex-shrink:0;transition:transform .2s" :style="{ transform: c1ClockOpen ? 'rotate(180deg)' : '' }"><polyline points="6 9 12 15 18 9"/></svg>
        </div>
      </div>

      <!-- Speaking card — slides out from right edge of Viki's face box -->
      <transition name="c1-vmsg-slide">
        <div v-if="c1VikiVisible" key="msg" class="c1-viki-msgcard" :style="{ backgroundColor: c1VikiCardColor }" @click.stop>
          <div class="c1-vmc-text">
            <span v-html="c1VikiNotifMsg ? c1VikiNotifMsg.m : c1VikiMsgs[c1VikiIdx].m"></span>
          </div>
          <button class="c1-vmc-close" @click="c1VikiVisible=false;c1VikiNotifMsg=null">
            <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
          <div v-if="c1VikiNotifMsg" class="c1-vp-progress-wrap">
            <div class="c1-vp-progress" :key="c1VikiMsgKey"></div>
          </div>
        </div>
      </transition>

      <!-- RIGHT 25% — panel selector + Viki face flush right -->
      <div class="c1-tib-side c1-tib-right">
        <!-- Detail Mode toggle -->
        <button class="c1-tib-icon-btn" :class="{ 'c1-detail-mode-on': c1DetailMode }" @click.stop="c1DetailMode = !c1DetailMode" :title="c1DetailMode ? 'Collapse all' : 'Expand all'">
          <svg v-if="!c1DetailMode" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:15px;height:15px"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="15" y2="12"/><line x1="3" y1="18" x2="18" y2="18"/></svg>
          <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:15px;height:15px"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/><line x1="19" y1="4" x2="19" y2="8"/></svg>
        </button>
        <!-- Hamburger nav menu toggle -->
        <div class="c1-ham-wrap" @click.stop>
          <button class="c1-ham-btn" :class="{ open: c1HamMenuOpen }" @click="c1HamMenuOpen = !c1HamMenuOpen; c1ShiftMenuOpen = false">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:18px;height:18px"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          </button>
        </div>

      </div>

    </div>

    <!-- SHIFT DRAWER — accordion band, pushes content down -->
    <div class="c1-top-drawer c1-shift-drawer" :class="{ open: c1ShiftMenuOpen }" @click.stop>
      <div class="c1-td-inner">
        <!-- Status row -->
        <div class="c1-td-section-lbl">My Shift</div>
        <div class="c1-td-status-row">
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono">{{ c1ShiftStartTime ? new Date(c1ShiftStartTime).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : '—' }}</div>
            <div class="c1-td-stat-lbl">Started</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono" style="color:var(--c1-dp)">{{ c1ShiftElapsed }}</div>
            <div class="c1-td-stat-lbl">Elapsed</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1BathroomCount }}×</div>
            <div class="c1-td-stat-lbl">🚽 Bathroom</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1CoffeeCount }}×</div>
            <div class="c1-td-stat-lbl">☕ Coffee</div>
          </div>
        </div>
        <!-- Action buttons -->
        <div class="c1-td-btn-row">
          <button class="c1-td-btn c1-td-btn-shift"   :class="{ active: c1Status === 'shift' }"   @click.stop="c1SetStatus('shift')">▶ On Shift</button>
          <button class="c1-td-btn c1-td-btn-bathroom" :class="{ active: c1Status === 'bathroom' }" @click.stop="c1SetStatus('bathroom')">🚽 Bathroom</button>
          <button class="c1-td-btn c1-td-btn-coffee"  :class="{ active: c1Status === 'coffee' }"  @click.stop="c1SetStatus('coffee')">☕ Coffee</button>
          <button class="c1-td-btn c1-td-btn-break"   :class="{ active: c1Status === 'break' }"   @click.stop="c1SetStatus('break')">⏸ Break</button>
          <button class="c1-td-btn c1-td-btn-lunch"   :class="{ active: c1Status === 'lunch' }"   @click.stop="c1SetStatus('lunch')">🍽 Lunch</button>
          <button class="c1-td-btn c1-td-btn-end"     @click.stop="c1SetStatus('end')">⏹ End Shift</button>
        </div>
      </div>
    </div>

    <!-- HAM NAV DRAWER — accordion band, pushes content down -->
    <div class="c1-top-drawer c1-ham-drawer" :class="{ open: c1HamMenuOpen }" @click.stop>
      <div class="c1-td-inner c1-td-nav-grid">
        <router-link to="/clients1" class="c1-td-nav-item" :class="{ on: $route.path === '/clients1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-dp)"></span>Clients</router-link>
        <router-link to="/tasks1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-sc)"></span>Tasks</router-link>
        <router-link to="/stats1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-ld)"></span>Statistics</router-link>
        <router-link to="/chat1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-rf)"></span>Chat</router-link>
        <router-link to="/communications1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#3b82f6"></span>Communications</router-link>
        <router-link to="/affiliation1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#8b5cf6"></span>Affiliation</router-link>
        <router-link to="/finance1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#10b981"></span>Finance</router-link>
        <router-link to="/shifts1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#f59e0b"></span>Shifts</router-link>
        <router-link to="/users1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#06b6d4"></span>Users</router-link>
        <router-link to="/brokers1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ec4899"></span>Brokers</router-link>
        <router-link to="/security1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ef4444"></span>Security</router-link>
        <router-link to="/quiz1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#a78bfa"></span>Quiz</router-link>
        <router-link to="/instruction1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#64748b"></span>Instructions</router-link>
        <router-link to="/settings1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#94a3b8"></span>Settings</router-link>
        <router-link to="/profile1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#22d3ee"></span>My Profile</router-link>
      </div>
    </div>

    <!-- CLOCK DRAWER -->
    <div class="c1-top-drawer c1-clock-drawer" :class="{ open: c1ClockOpen }" @click.stop>
      <div class="c1-td-inner" style="display:flex;align-items:center;gap:20px;padding:10px 16px;">
        <div class="c1-tz-item"><span class="c1-tz-flag">🇬🇧</span><span class="c1-tz-lbl">UK</span><span class="c1-tz-val">{{ c1TzUK }}</span></div>
        <div class="c1-tz-sep">·</div>
        <div class="c1-tz-item"><span class="c1-tz-flag">🇮🇱</span><span class="c1-tz-lbl">IL</span><span class="c1-tz-val">{{ c1TzIL }}</span></div>
        <div class="c1-tz-sep">·</div>
        <div class="c1-tz-item"><span class="c1-tz-flag">🏝</span><span class="c1-tz-lbl">CB</span><span class="c1-tz-val">{{ c1TzCB }}</span></div>
        <div v-if="c1LastApiMs !== null" style="margin-left:auto" class="c1-speed-badge c1-speed-badge--live">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:8px;height:8px;flex-shrink:0"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
          <span>{{ c1LastApiMs }}ms</span>
        </div>
      </div>
    </div>
    </div><!-- /c1-sticky-top -->

    <!-- TOP DASHBOARD STRIP -->
    <div class="c1-top-strip">
      <div class="c1-top-strip-body">

        <!-- KPI STRIP — always-visible today's numbers, each is a one-tap filter -->
        <div class="c1-kpi-strip">
          <div class="c1-kpi-pill c1-kpi-pill--dep" @click.stop="filterByDeposit(); c1TopTab = null">
            <span class="c1-kpi-val">{{ c1TodayFull.DEP || c1TodayFull.DP || 0 }}</span>
            <span class="c1-kpi-lbl">Dep</span>
          </div>
          <div class="c1-kpi-sep"></div>
          <div class="c1-kpi-pill c1-kpi-pill--sc" @click.stop="filterByScheduledCalls(); c1TopTab = null">
            <span class="c1-kpi-val">{{ c1TodayFull.CA || 0 }}</span>
            <span class="c1-kpi-lbl">SC</span>
          </div>
          <div class="c1-kpi-sep"></div>
          <div class="c1-kpi-pill c1-kpi-pill--new" @click.stop="filterByNew(); c1TopTab = null">
            <span class="c1-kpi-val">{{ c1TodayFull.NEW || 0 }}</span>
            <span class="c1-kpi-lbl">New</span>
          </div>
          <div class="c1-kpi-sep"></div>
          <div class="c1-kpi-pill c1-kpi-pill--ld" @click.stop="filterByLead(); c1TopTab = null">
            <span class="c1-kpi-val">{{ c1TodayFull.LD || 0 }}</span>
            <span class="c1-kpi-lbl">Lead</span>
          </div>
          <div class="c1-kpi-sep"></div>
          <div class="c1-kpi-pill c1-kpi-pill--na" @click.stop="filterByNoAnswer(0); c1TopTab = null">
            <span class="c1-kpi-val">{{ c1TodayFull.NA || 0 }}</span>
            <span class="c1-kpi-lbl">NA</span>
          </div>
          <div class="c1-kpi-sep"></div>
          <div class="c1-kpi-pill c1-kpi-pill--rf" @click.stop="filterByReferral(); c1TopTab = null">
            <span class="c1-kpi-val">{{ c1TodayFull.RF || 0 }}</span>
            <span class="c1-kpi-lbl">RF</span>
          </div>
          <div style="flex:1"></div>
          <div class="c1-kpi-total">
            <span class="c1-kpi-total-val">{{ pagination.total || 0 }}</span>
            <span class="c1-kpi-lbl">clients</span>
          </div>
        </div>

        <!-- TAB ROW: Agents | Status | Sort -->
        <div class="c1-ts-tab-row">
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'agents'}" @click.stop="c1TopTab = c1TopTab === 'agents' ? null : 'agents'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
            <span>Agents</span>
            <span v-if="filters.assigned && filters.assigned.length" class="c1-ts-badge">{{ filters.assigned.length }}</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='agents' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'status'}" @click.stop="c1TopTab = c1TopTab === 'status' ? null : 'status'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
            <span v-if="c1StatusRange && c1StatusRange.from === c1StatusRange.to">{{ c1StatusRange.from | shortDate }}</span>
            <span v-else-if="c1StatusRange">{{ c1StatusRange.from | shortDate }} – {{ c1StatusRange.to | shortDate }}</span>
            <span v-else>Status</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='status' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'sort'}" @click.stop="c1TopTab = c1TopTab === 'sort' ? null : 'sort'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><line x1="3" y1="6" x2="21" y2="6"/><line x1="6" y1="12" x2="18" y2="12"/><line x1="9" y1="18" x2="15" y2="18"/></svg>
            <span>{{ c1SortLabel }}</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='sort' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
        </div>

        <!-- TEAM ACTIVE CHIP (shown when a team filter is active, agents tab closed) -->
        <div v-if="c1TeamFilter !== null && c1TopTab !== 'agents'" style="display:flex;align-items:center;gap:6px;padding:4px 8px 0">
          <div class="c1-team-active-chip" :style="{ background: c1TeamFilter === 1 ? 'rgba(14,116,144,.12)' : 'rgba(124,58,237,.12)', color: c1TeamFilter === 1 ? '#0e7490' : '#7c3aed', borderColor: c1TeamFilter === 1 ? 'rgba(14,116,144,.3)' : 'rgba(124,58,237,.3)' }" @click.stop="c1TeamFilter = null; debouncedClientsQuery()">
            {{ c1TeamFilter === 1 ? '⚡ Team 1' : '🔥 Team 2' }} ×
          </div>
        </div>

        <!-- AGENTS DROPDOWN — clean list, matches calendar / bulk-assign style -->
        <div v-show="c1TopTab === 'agents'" class="c1-ts-dropdown">
          <!-- Team filter pills inside Agents -->
          <div class="c1-ag-team-pills" @click.stop>
            <div class="c1-ag-team-pill" :class="{on: c1TeamFilter === null}" @click.stop="c1TeamFilter = null; debouncedClientsQuery()">All</div>
            <div class="c1-ag-team-pill c1-ag-team-pill--t1" :class="{on: c1TeamFilter === 1}" @click.stop="c1TeamFilter = 1; debouncedClientsQuery()">⚡ Team 1</div>
            <div class="c1-ag-team-pill c1-ag-team-pill--t2" :class="{on: c1TeamFilter === 2}" @click.stop="c1TeamFilter = 2; debouncedClientsQuery()">🔥 Team 2</div>
          </div>
          <input class="c1-nav-ap-search" v-model="c1NavAgentSearch" placeholder="Search agent…" @click.stop />
          <div v-if="c1AgentRangeLoading" style="padding:10px;text-align:center"><div class="c1-chart-spinner" style="width:14px;height:14px;border-width:2px;display:inline-block"></div></div>
          <div class="c1-ag-list">
            <!-- Incoming leads row (unchanged) -->
            <div class="c1-ag-list-row" :class="{on: filters.unassigned}" @click.stop="c1ToggleUnassigned()">
              <div class="c1-ag-list-av c1-ag-list-av-un">?</div>
              <span class="c1-ag-list-name">Incoming leads</span>
              <svg v-if="filters.unassigned" class="c1-ag-list-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            </div>

            <!-- Agent rows with expand -->
            <template v-for="agent in c1NavFilteredAgents">
              <!-- Main agent row -->
              <div :key="'agr-' + agent.id" class="c1-ag-glance-row" :class="{on: filters.assigned && filters.assigned.some(a => (a.id||a) === agent.id), open: c1AgentGlanceOpen === agent.id}" @click.stop="c1ToggleAgentGlance(agent)">
                <!-- filter button -->
                <button class="c1-sdd-filt-btn" :class="{on: filters.assigned && filters.assigned.some(a => (a.id||a) === agent.id)}" style="--filt-clr:#4a9ff5;flex-shrink:0;" @click.stop="c1FilterByAgent(agent); c1TopTab = null" title="Filter by this agent">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
                </button>
                <!-- avatar -->
                <div class="c1-ag-list-av" style="position:relative;flex-shrink:0;">
                  {{ c1AgentInitials(agent) }}
                  <span v-if="agent.is_online || agent.id === auth.user.id" style="position:absolute;bottom:0;right:0;width:7px;height:7px;background:#22c55e;border-radius:50%;border:1.5px solid #fff"></span>
                </div>
                <!-- name + role -->
                <div style="flex:1;min-width:0;overflow:hidden;display:flex;flex-direction:column;gap:1px">
                  <span class="c1-ag-list-name" style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ agent.full_name || agent.name || agent.username || '—' }}</span>
                  <span style="font-size:9px;color:var(--c1-t3);font-weight:500;letter-spacing:.3px;text-transform:uppercase;">{{ c1RoleName(agent.role) }}</span>
                </div>
                <!-- range stat badges -->
                <template v-if="c1AgentRangeData[agent.id]">
                  <span v-if="c1AgentRangeData[agent.id].na"  class="c1-ag-stat-badge" style="color:var(--c1-na)">{{ c1AgentRangeData[agent.id].na }}NA</span>
                  <span v-if="c1AgentRangeData[agent.id].ld"  class="c1-ag-stat-badge" style="color:var(--c1-ld)">{{ c1AgentRangeData[agent.id].ld }}LD</span>
                  <span v-if="c1AgentRangeData[agent.id].dep" class="c1-ag-stat-badge" style="color:var(--c1-dp)">{{ c1AgentRangeData[agent.id].dep }}DP</span>
                  <span v-if="c1AgentRangeData[agent.id].sc"  class="c1-ag-stat-badge" style="color:var(--c1-sc)">{{ c1AgentRangeData[agent.id].sc }}SC</span>
                </template>
                <!-- expand arrow -->
                <svg class="c1-sdd-arr" style="margin-left:2px;flex-shrink:0;" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1AgentGlanceOpen === agent.id ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
              </div>

              <!-- Expanded glance body -->
              <div :key="'agb-' + agent.id" v-if="c1AgentGlanceOpen === agent.id" class="c1-ag-glance-body">
                <div v-if="c1AgentStatsCache[agent.id] && c1AgentStatsCache[agent.id].loading" style="padding:8px;text-align:center">
                  <div class="c1-chart-spinner" style="width:14px;height:14px;border-width:2px"></div>
                </div>
                <template v-else-if="c1AgentStatsCache[agent.id]">
                  <!-- Status pills -->
                  <div class="c1-ag-glance-pills">
                    <span v-if="agent.is_online || agent.id === auth.user.id" class="c1-ag-glance-pill c1-ag-glance-pill--on">● Live</span>
                    <span v-else class="c1-ag-glance-pill">Offline</span>
                    <span class="c1-ag-glance-pill" style="background:rgba(99,102,241,.12);color:#818cf8;">{{ c1RoleName(agent.role) }}</span>
                    <span v-if="c1AgentRangeData[agent.id]" class="c1-ag-glance-pill">{{ c1AgentRangeData[agent.id].total }} in range</span>
                  </div>
                  <!-- Stat rows -->
                  <div v-for="stat in c1AgentGlanceStats(agent.id)" :key="stat.key" class="c1-glance-hrow c1-glance-hrow--filt" @click.stop="c1FilterByAgentStat(agent, stat)">
                    <span class="c1-glance-hlbl" :style="{color: stat.color}">{{ stat.label }}</span>
                    <div class="c1-glance-track">
                      <div class="c1-glance-fill" :style="{ width: stat.pct + '%', background: stat.color }"></div>
                    </div>
                    <span class="c1-glance-count" :style="{ color: stat.color }">{{ stat.count }}</span>
                    <svg v-if="stat.filterable" class="c1-glance-filt-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
                  </div>
                </template>
              </div>
            </template>
          </div>

          <div v-if="filters.assigned && filters.assigned.length" style="padding:0 8px 6px">
            <div class="c1-fs-all" style="border-radius:7px" @click.stop="filters.assigned = []; debouncedClientsQuery()">
              <span class="c1-fs-all-lbl">Clear agent filter</span>
            </div>
          </div>
        </div>

        <!-- STATUS DROPDOWN -->
        <div v-show="c1TopTab === 'status'" class="c1-ts-dropdown c1-status-dd">

          <!-- Calendar inside status panel -->
          <c1-smart-calendar
            :filter-params="c1NavCalendarParams"
            style="flex-shrink:0;border-bottom:1px solid var(--c1-brd-l)"
            @daySelected="onSmartCalDaySelected"
            @reset="c1StatusRange=null; c1LoadTodayChart()"
          />

          <!-- STATUS rows -->
          <div class="c1-sdd-section-hdr" style="display:flex;align-items:center;justify-content:space-between">
            <span>Status overview</span>
            <span v-if="c1StatusRange" style="font-size:10px;font-weight:600;color:var(--c1-t3);margin-left:6px">
              {{ c1StatusRange.from === c1StatusRange.to ? c1StatusRange.from : c1StatusRange.from + ' – ' + c1StatusRange.to }}
            </span>
          </div>
          <template v-for="row in c1OverviewRows">
            <div :key="'sdd-' + row.key" class="c1-sdd-row" :class="{active: row.active, open: c1GlanceOpen === row.key}">
              <div class="c1-sdd-row-accent" :style="{background: row.color}"></div>
              <div class="c1-sdd-row-inner" @click.stop="c1ToggleGlance(row)">
                <button v-if="row.click !== null" class="c1-sdd-filt-btn c1-sdd-filt-btn--lg" :class="{on: row.active}" :style="{'--filt-clr': row.color}" @click.stop="c1ApplyStatusFilter(row); c1TopTab = null" title="Filter clients by this status">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
                </button>
                <span class="c1-sdd-lbl">{{ row.label }}</span>
                <div style="flex:1"></div>
                <div class="c1-sdd-bar-wrap"><div class="c1-sdd-bar-fill" :style="{width: row.pct + '%', background: row.color}"></div></div>
                <span class="c1-sdd-count" :style="{background: row.color + '22', color: row.color}">{{ row.val }}</span>
                <svg class="c1-sdd-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
              </div>
            </div>
            <div :key="'sdd-body-' + row.key" v-if="row.breakdown && c1GlanceOpen === row.key" class="c1-sdd-breakdown">
              <div v-if="c1GlanceLoading" style="padding:8px;text-align:center"><div class="c1-chart-spinner" style="width:14px;height:14px;border-width:2px"></div></div>
              <template v-else>
                <div class="c1-glance-tabs" style="margin:0 -2px 4px">
                  <div class="c1-glance-tab" :class="{on: c1GlanceTab==='hours'}" @click.stop="c1GlanceTab='hours'">Hours</div>
                  <div class="c1-glance-tab" :class="{on: c1GlanceTab==='agents'}" @click.stop="c1GlanceTab='agents'">Agents</div>
                  <div v-if="c1GlanceBrokers.length" class="c1-glance-tab" :class="{on: c1GlanceTab==='brokers'}" @click.stop="c1GlanceTab='brokers'">Brokers</div>
                </div>
                <template v-if="c1GlanceTab === 'hours'">
                  <div v-if="c1GlanceDaysLoading" style="padding:6px 0;display:flex;justify-content:center"><div class="c1-chart-spinner" style="width:12px;height:12px;border-width:2px"></div></div>
                  <div v-else-if="!Object.keys(c1GlanceHoursAgg).length" style="font-size:10px;color:var(--c1-t3);padding:4px 0">
                    No activity{{ c1GlanceOpenRow && c1GlanceOpenRow.val === 0 ? ' — count is 0 for this date' : '' }}
                  </div>
                  <template v-else>
                    <div v-for="hh in c1GlanceSortedHours" :key="hh" class="c1-glance-hrow c1-glance-hrow--filt" @click.stop="c1FilterByHour(row, hh)">
                      <span class="c1-glance-hlbl">{{ parseInt(hh, 10) }}h</span>
                      <div class="c1-glance-track">
                        <div class="c1-glance-fill" :style="{ width: c1GlanceHourPctByKey(hh) + '%', background: c1GlanceOpenRow ? c1GlanceOpenRow.color : 'var(--c1-dp)' }"></div>
                      </div>
                      <span class="c1-glance-count" :style="{ color: c1GlanceOpenRow ? c1GlanceOpenRow.color : 'var(--c1-dp)' }">{{ c1GlanceHoursAgg[hh] }}</span>
                      <svg class="c1-glance-filt-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
                    </div>
                  </template>
                </template>
                <template v-if="c1GlanceTab === 'agents'">
                  <div v-if="!c1GlanceUsers.length" style="font-size:10px;color:var(--c1-t3);padding:4px 0">No data</div>
                  <div v-else v-for="u in c1GlanceUsers" :key="u.id" class="c1-glance-user-row c1-glance-user-row--filt"
                    @click.stop="row.click && row.click(); c1ToggleAssign(u.id); debouncedClientsQuery(); c1TopTab = null">
                    <div class="c1-glance-user-av">{{ (u.name||'?')[0].toUpperCase() }}</div>
                    <div class="c1-glance-user-name">{{ u.name }}</div>
                    <div class="c1-glance-track"><div class="c1-glance-fill" :style="{ width: c1GlanceBarPct(u) + '%', background: row.color }"></div></div>
                    <div class="c1-glance-count" :style="{ color: row.color }">{{ u.count }}</div>
                    <svg class="c1-glance-filt-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
                  </div>
                </template>
                <template v-if="c1GlanceTab === 'brokers'">
                  <div v-if="!c1GlanceBrokers.length" style="font-size:10px;color:var(--c1-t3);padding:4px 0">No data</div>
                  <div v-else v-for="b in c1GlanceBrokers" :key="b.id" class="c1-glance-user-row c1-glance-user-row--filt"
                    @click.stop="c1FilterByStatusBroker(row, b); c1TopTab = null">
                    <div class="c1-glance-user-av" style="background:var(--c1-acc2)">{{ (b.name||'?')[0].toUpperCase() }}</div>
                    <div class="c1-glance-user-name">{{ b.name }}</div>
                    <div class="c1-glance-track"><div class="c1-glance-fill" :style="{ width: c1BrokerBarPct(b) + '%', background: row.color }"></div></div>
                    <div class="c1-glance-count" :style="{ color: row.color }">{{ b.count }}</div>
                    <svg class="c1-glance-filt-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
                  </div>
                </template>
              </template>
            </div>
          </template>

          <!-- COUNTRIES SECTION (collapsible) -->
          <div class="c1-sdd-row" style="border-top:1px solid var(--c1-brd-l);margin-top:4px" :class="{active: filters.countries && filters.countries.length}">
            <div class="c1-sdd-row-accent" style="background:#3b82f6"></div>
            <div class="c1-sdd-row-inner" @click.stop="c1CountryOpen = !c1CountryOpen">
              <span class="c1-sdd-lbl">Country</span>
              <div style="flex:1"></div>
              <span v-if="filters.countries && filters.countries.length" class="c1-sdd-count" style="background:rgba(59,130,246,.12);color:#3b82f6">{{ filters.countries.length }} selected</span>
              <span v-else class="c1-sdd-count" style="background:rgba(0,0,0,.05);color:var(--c1-t3)">{{ c1StatusCountries.length }}</span>
              <svg class="c1-sdd-arr" :style="{transform: c1CountryOpen ? 'rotate(180deg)' : ''}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
            </div>
          </div>
          <template v-if="c1CountryOpen">
            <div class="c1-sdd-co-search">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px;flex-shrink:0;stroke:var(--c1-t3)"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              <input class="c1-sdd-co-input" v-model.trim="c1CountrySearch" placeholder="Search country…" @click.stop />
              <div v-if="c1CountrySearch" class="c1-sdd-co-clear" @click.stop="c1CountrySearch = ''">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:10px;height:10px"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </div>
            </div>
            <div v-if="filters.countries && filters.countries.length" class="c1-sdd-active-countries">
              <div v-for="co in filters.countries" :key="'selco-' + co.id" class="c1-co-chip c1-co-chip--on"
                @click.stop="filters.countries = filters.countries.filter(c => c.id !== co.id); debouncedClientsQuery()">
                {{ co.name }} ✕
              </div>
            </div>
            <div class="c1-sdd-country-list">
              <div v-if="!c1StatusCountries.length" style="font-size:10px;color:var(--c1-t3);padding:4px 6px">No country data on this page</div>
              <div v-else v-for="co in c1StatusCountries" :key="'sco-' + (co.id || co.name)"
                class="c1-sdd-country-row"
                :class="{on: filters.countries && filters.countries.some(c => c.id === co.id)}"
                @click.stop="c1ToggleCountry(co)">
                <span class="c1-sdd-co-flag">{{ co.flag }}</span>
                <span class="c1-sdd-co-name">{{ co.name }}</span>
                <div class="c1-sdd-mini-bar"><div class="c1-sdd-mini-fill c1-sdd-mini-fill--co" :style="{width: c1StatusCountryPct(co) + '%'}"></div></div>
                <span class="c1-sdd-co-cnt">{{ co.count }}</span>
              </div>
            </div>
          </template>

        </div>

        <!-- SORT DROPDOWN -->
        <div v-show="c1TopTab === 'sort'" class="c1-ts-dropdown c1-sort-dd">
          <div v-for="opt in [{v:'smart',l:'⚡ Smart'},{v:'date_up',l:'Date ↑'},{v:'date_down',l:'Date ↓'},{v:'mod_up',l:'Modified ↑'},{v:'mod_down',l:'Modified ↓'},{v:'az',l:'A → Z'},{v:'za',l:'Z → A'}]"
               :key="opt.v"
               class="c1-sort-row"
               :class="{on: c1SortSelectVal === opt.v}"
               @click.stop="c1ApplySortSelect(opt.v); c1TopTab = null">
            <span class="c1-sort-row-lbl">{{ opt.l }}</span>
            <svg v-if="c1SortSelectVal === opt.v" class="c1-ag-list-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
          </div>
        </div>



      </div><!-- /top-strip-body -->
    </div><!-- /top-strip -->

    <!-- PAGINATION BAR -->
    <div class="c1-pg-bar">
      <div class="c1-pg-btn" :class="{ disabled: pagination.currentPage <= 1 }" @click="goPage(1)">
        <svg viewBox="0 0 24 24"><polyline points="11 17 6 12 11 7"/><polyline points="18 17 13 12 18 7"/></svg>
      </div>
      <div class="c1-pg-btn" :class="{ disabled: pagination.currentPage <= 1 }" @click="goPage(pagination.currentPage - 1)">
        <svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>
      </div>
      <div class="c1-pg-info">{{ pagination.from }}–{{ pagination.to }} of {{ pagination.total }}</div>
      <div class="c1-pg-sep"></div>
      <div class="c1-pg-info">p.{{ pagination.currentPage }}/{{ pagination.lastPage }}</div>
      <div class="c1-hp"></div>
      <div class="c1-pg-btn" :class="{ disabled: pagination.currentPage >= pagination.lastPage }" @click="goPage(pagination.currentPage + 1)">
        <svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
      </div>
      <div class="c1-pg-btn" :class="{ disabled: pagination.currentPage >= pagination.lastPage }" @click="goPage(pagination.lastPage)">
        <svg viewBox="0 0 24 24"><polyline points="13 17 18 12 13 7"/><polyline points="6 17 11 12 6 7"/></svg>
      </div>
    </div>

    <!-- INLINE SEARCH BAR -->
    <div class="c1-inline-search">
      <svg class="c1-is-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
      <input class="c1-is-input" v-model.trim="filters.client" placeholder="Search by name, phone, email, #id…" type="text"
        @input="pagination.currentPage = 1; filters.active = !filters.client; debouncedClientsQuery()" />
      <button v-if="filters.client" class="c1-is-clear" @click.stop="filters.client = ''; filters.active = true; pagination.currentPage = 1; debouncedClientsQuery()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>


    <!-- CLIENT LIST -->
    <div class="c1-leads" v-if="!$store.state.clients.loading">

      <!-- SELECT-ALL ROW -->
      <div v-if="c1CanAssign" class="c1-sel-all-row">
        <div class="c1-ck c1-ck-all" :class="{ on: c1SelectedClients.length === (clients||[]).length && (clients||[]).length > 0 }" @click.stop="c1SelectedClients.length === (clients||[]).length ? c1ClearSelection() : c1SelectAll()">
          <svg v-if="c1SelectedClients.length === (clients||[]).length && (clients||[]).length > 0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
          <svg v-else-if="c1SelectedClients.length > 0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/></svg>
        </div>
        <span class="c1-sel-all-lbl">
          <template v-if="c1SelectedClients.length > 0">{{ c1SelectedClients.length }} selected</template>
          <template v-else>Select all ({{ (clients||[]).length }})</template>
        </span>
        <button v-if="c1SelectedClients.length > 0" class="c1-sel-all-clr" @click.stop="c1ClearSelection()">Clear</button>
      </div>

      <div v-for="client in clients" :key="client.id"
           class="c1-box"
           :class="{
             'c1-row--purple-time': c1IsPurpleTime(client),
             'c1-row--hot': !c1IsPurpleTime(client) && client.is_leading >= 10,
             'c1-row--dep': !c1IsPurpleTime(client) && client.is_leading < 10 && clientStatus(client).t === 'dp',
             'c1-row--sc':  !c1IsPurpleTime(client) && client.is_leading < 10 && clientStatus(client).t === 'sc'
           }"
           @contextmenu.prevent="c1OpenContext($event, client)">
        <div class="c1-box-acc" :style="{ background: c1IsPurpleTime(client) ? '#9c27b0' : clientAccentColor(client) }"></div>

        <!-- ROW 1: avatar + identity + status badge -->
        <div class="c1-box-r1" @click.stop="c1CardSelected === client.id ? (c1CardSelected = null, c1OpenTag = null) : (c1CardSelected = client.id, c1CardExpanded = null, addToHistory(client))">


          <!-- ROW 1: name — chevron toggles client info -->
          <div class="c1-cr c1-cr-name" @click.stop="$set(c1InfoOpen, client.id, !c1InfoOpen[client.id])">
            <div class="c1-cr-ic" :style="{ background: clientAvatarColor(client) }" style="color:#fff;font-size:11px;font-weight:800;letter-spacing:-.3px;position:relative;">
              {{ clientInitials(client) }}
              <div v-if="client.is_online" class="c1-box-on"></div>
            </div>
            <div class="c1-cr-txt" style="flex-direction:row;align-items:center;gap:5px;flex-wrap:nowrap;overflow:hidden;">
              <span class="c1-nm-text">{{ client.first_name }} {{ client.last_name }}</span>
              <span class="c1-mono" style="font-size:9px;color:var(--c1-t3);flex-shrink:0;">#{{ client.id }}</span>
              <span v-if="client.age" class="c1-age">{{ client.age }}y</span>
              <span v-if="client.is_new" class="c1-tag-new" @click.stop="c1OpenNewSlide(client)">NEW</span>
              <span v-if="client.missedScheduledCall" class="c1-tag-missed">MISSED</span>
              <span v-if="client.priority === 1" class="c1-tag-hp">⚡</span>
              <span v-if="client.is_duplicate" class="c1-dup-badge">DUP</span>
            </div>
            <button class="c1-row-edit-btn" @click.stop="c1StartEdit(client.id, 'name', (client.first_name || '') + ' ' + (client.last_name || ''))">✏</button>
            <button class="c1-lead-btn" @click.stop="c1OpenLead(client)" title="Open lead">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
            </button>
            <div class="c1-cr-chv" :class="{ open: c1InfoOpen[client.id] }">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
            </div>
          </div>
          <!-- Name inline edit -->
          <div v-if="c1ContactEdit[client.id + '-name']" class="c1-row-edit-body" @click.stop>
            <input class="c1-ce-input" type="text" :value="c1ContactEdit[client.id + '-name'].val" @input="c1ContactEdit[client.id + '-name'].val = $event.target.value" />
            <button class="c1-ce-save" @click.stop="c1SaveContact(client, 'name')">Save</button>
            <button class="c1-ce-cancel" @click.stop="$delete(c1ContactEdit, client.id + '-name')">✕</button>
            <span v-if="c1ContactEdit[client.id + '-name'].prev" class="c1-ce-prev">was: {{ c1ContactEdit[client.id + '-name'].prev }}</span>
          </div>

          <!-- Name row expand: client info -->
          <div v-if="c1InfoOpen[client.id]" class="c1-more-body">
            <div class="c1-exp-sec">
              <div class="c1-exp-lbl">Client Info</div>
              <div class="c1-exp-grid">

                <!-- Name (editable) -->
                <div class="c1-exp-field c1-exp-full">
                  <div class="c1-exp-fl">Name</div>
                  <div class="c1-exp-fv" style="flex:1">
                    <div v-if="c1ContactEdit[client.id + '-name']" class="c1-ce-row">
                      <input class="c1-ce-input" type="text" :value="c1ContactEdit[client.id + '-name'].val" @input="c1ContactEdit[client.id + '-name'].val = $event.target.value" @click.stop />
                      <button class="c1-ce-save" @click.stop="c1SaveContact(client, 'name')">Save</button>
                      <button class="c1-ce-cancel" @click.stop="$delete(c1ContactEdit, client.id + '-name')">✕</button>
                    </div>
                    <div v-else style="display:flex;align-items:center;gap:6px;">
                      <span style="font-weight:600;">{{ client.first_name }} {{ client.last_name }}</span>
                      <button class="c1-ce-pencil" @click.stop="c1StartEdit(client.id, 'name', (client.first_name || '') + ' ' + (client.last_name || ''))" title="Edit">✏</button>
                    </div>
                    <div v-if="c1ContactEdit[client.id + '-name'] && c1ContactEdit[client.id + '-name'].prev" class="c1-ce-prev">was: {{ c1ContactEdit[client.id + '-name'].prev }}</div>
                  </div>
                </div>

                <!-- Phone (editable) -->
                <div class="c1-exp-field c1-exp-full">
                  <div class="c1-exp-fl">Phone</div>
                  <div class="c1-exp-fv" style="flex:1">
                    <div v-if="c1ContactEdit[client.id + '-phone']" class="c1-ce-row">
                      <input class="c1-ce-input c1-mono" type="text" :value="c1ContactEdit[client.id + '-phone'].val" @input="c1ContactEdit[client.id + '-phone'].val = $event.target.value" @click.stop />
                      <button class="c1-ce-save" @click.stop="c1SaveContact(client, 'phone')">Save</button>
                      <button class="c1-ce-cancel" @click.stop="$delete(c1ContactEdit, client.id + '-phone')">✕</button>
                    </div>
                    <div v-else style="display:flex;align-items:center;gap:6px;">
                      <span class="c1-mono">{{ client.phones && client.phones[0] ? client.phones[0].contact_value : '—' }}</span>
                      <button class="c1-ce-pencil" @click.stop="c1StartEdit(client.id, 'phone', client.phones && client.phones[0] ? client.phones[0].contact_value : '')" title="Edit">✏</button>
                    </div>
                    <div v-if="c1ContactEdit[client.id + '-phone'] && c1ContactEdit[client.id + '-phone'].prev" class="c1-ce-prev">was: {{ c1ContactEdit[client.id + '-phone'].prev }}</div>
                  </div>
                </div>

                <!-- Email (editable) -->
                <div class="c1-exp-field c1-exp-full">
                  <div class="c1-exp-fl">Email</div>
                  <div class="c1-exp-fv" style="flex:1">
                    <div v-if="c1ContactEdit[client.id + '-email']" class="c1-ce-row">
                      <input class="c1-ce-input" type="text" :value="c1ContactEdit[client.id + '-email'].val" @input="c1ContactEdit[client.id + '-email'].val = $event.target.value" @click.stop />
                      <button class="c1-ce-save" @click.stop="c1SaveContact(client, 'email')">Save</button>
                      <button class="c1-ce-cancel" @click.stop="$delete(c1ContactEdit, client.id + '-email')">✕</button>
                    </div>
                    <div v-else style="display:flex;align-items:center;gap:6px;">
                      <span>{{ client.emails && client.emails[0] ? client.emails[0].contact_value : '—' }}</span>
                      <button class="c1-ce-pencil" @click.stop="c1StartEdit(client.id, 'email', client.emails && client.emails[0] ? client.emails[0].contact_value : '')" title="Edit">✏</button>
                    </div>
                    <div v-if="c1ContactEdit[client.id + '-email'] && c1ContactEdit[client.id + '-email'].prev" class="c1-ce-prev">was: {{ c1ContactEdit[client.id + '-email'].prev }}</div>
                  </div>
                </div>

                <!-- City/Location (editable) -->
                <div v-if="client.location || true" class="c1-exp-field c1-exp-full">
                  <div class="c1-exp-fl">City</div>
                  <div class="c1-exp-fv" style="flex:1">
                    <div v-if="c1ContactEdit[client.id + '-location']" class="c1-ce-row">
                      <input class="c1-ce-input" type="text" :value="c1ContactEdit[client.id + '-location'].val" @input="c1ContactEdit[client.id + '-location'].val = $event.target.value" @click.stop />
                      <button class="c1-ce-save" @click.stop="c1SaveContact(client, 'location')">Save</button>
                      <button class="c1-ce-cancel" @click.stop="$delete(c1ContactEdit, client.id + '-location')">✕</button>
                    </div>
                    <div v-else style="display:flex;align-items:center;gap:6px;">
                      <span>{{ client.location || '—' }}</span>
                      <button class="c1-ce-pencil" @click.stop="c1StartEdit(client.id, 'location', client.location || '')" title="Edit">✏</button>
                    </div>
                    <div v-if="c1ContactEdit[client.id + '-location'] && c1ContactEdit[client.id + '-location'].prev" class="c1-ce-prev">was: {{ c1ContactEdit[client.id + '-location'].prev }}</div>
                  </div>
                </div>

                <div v-if="client.registered_on" class="c1-exp-field">
                  <div class="c1-exp-fl">Registered</div><div class="c1-exp-fv c1-mono">{{ fmtShort(client.registered_on) }}</div>
                </div>
                <div v-if="client.language" class="c1-exp-field">
                  <div class="c1-exp-fl">Language</div><div class="c1-exp-fv">{{ client.language.name }}</div>
                </div>
                <div v-if="client.device" class="c1-exp-field">
                  <div class="c1-exp-fl">Device</div><div class="c1-exp-fv">{{ client.device }}</div>
                </div>
                <div v-if="client.last_online" class="c1-exp-field">
                  <div class="c1-exp-fl">Last Online</div><div class="c1-exp-fv c1-mono">{{ fmtShort(client.last_online) }}</div>
                </div>
                <div v-if="client.last_ip" class="c1-exp-field c1-exp-full">
                  <div class="c1-exp-fl">Last IP</div><div class="c1-exp-fv c1-mono" style="font-size:10px">{{ client.last_ip }}</div>
                </div>
                <div v-if="client.is_leading !== undefined && client.is_leading !== 0" class="c1-exp-field c1-exp-full">
                  <div class="c1-exp-fl">Lead Score</div>
                  <div class="c1-exp-fv">
                    <span v-if="client.is_leading >= 10" class="c1-lq-badge c1-lq-hot">🔥 HOT · {{ client.is_leading }}</span>
                    <span v-else-if="client.is_leading >= 1" class="c1-lq-badge c1-lq-warm">✅ WARM · {{ client.is_leading }}</span>
                    <span v-else-if="client.is_leading < 0" class="c1-lq-badge c1-lq-cold">🧊 COLD · {{ client.is_leading }}</span>
                  </div>
                </div>
                <div v-if="client.is_duplicate" class="c1-exp-field">
                  <div class="c1-exp-fl">Flag</div><div class="c1-exp-fv"><span class="c1-exp-badge">Duplicate</span></div>
                </div>
                <div v-if="client.not_interested_state_id && niStates.length" class="c1-exp-field c1-exp-full">
                  <div class="c1-exp-fl">NI Reason</div>
                  <div class="c1-exp-fv" style="color:#7A6000">{{ (niStates.find(s => s.id === client.not_interested_state_id) || {}).name || '—' }}</div>
                </div>
                <div v-if="client.bad_number_state_id && bnStates.length" class="c1-exp-field c1-exp-full">
                  <div class="c1-exp-fl">BN Reason</div>
                  <div class="c1-exp-fv" style="color:var(--c1-bn)">{{ c1BnLabel(bnStates.find(s => s.id === client.bad_number_state_id) || {}) }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- ROW 2: flag · city · country · tod · status — click expands city intel -->
          <div class="c1-cr c1-cr-meta"
               :class="{ 'c1-cr-active': c1Accordion.cid === client.id && c1Accordion.type === 'city' }"
               @click.stop="c1ToggleAccordion(client.id, 'city')">
            <div class="c1-cr-ic" style="background:rgba(0,0,0,.03);font-size:22px;line-height:1;display:flex;align-items:center;justify-content:center;">
              <span>{{ c1ClientFlag(client) || '🌍' }}</span>
            </div>
            <div class="c1-cr-txt" style="flex-direction:row;align-items:center;gap:5px;flex-wrap:nowrap;overflow:hidden;width:100%;">
              <span v-if="client.location" style="font-size:11px;font-weight:600;color:var(--c1-t1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ client.location }}</span>
              <span v-if="client.country" class="c1-mi" style="white-space:nowrap;">{{ clientCountryName(client) }}</span>
              <span v-if="c1ClientTod(client)" class="c1-mi c1-tod" :class="c1ClientTod(client).cls" style="white-space:nowrap;">{{ c1ClientTod(client).label }}</span>
            </div>
            <button class="c1-row-edit-btn" @click.stop="c1StartEdit(client.id, 'location', client.location || '')">✏</button>
            <div class="c1-cr-chv" :class="{ open: c1Accordion.cid === client.id && c1Accordion.type === 'city' }" style="margin-left:auto;">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
            </div>
          </div>
          <!-- Location inline edit -->
          <div v-if="c1ContactEdit[client.id + '-location']" class="c1-loc-edit-panel" @click.stop>
            <!-- OSM Nominatim address search -->
            <div class="c1-loc-section-lbl">🔍 Search address</div>
            <div class="c1-loc-osm-wrap">
              <input class="c1-ce-input c1-loc-gmap"
                type="text"
                :value="c1ContactEdit[client.id + '-osm-q'] || ''"
                @input="$set(c1ContactEdit, client.id + '-osm-q', $event.target.value); c1OsmSearch(client)"
                placeholder="Type city or address..." />
              <div v-if="c1ContactEdit[client.id + '-osm-results'] && c1ContactEdit[client.id + '-osm-results'].length" class="c1-loc-country-list">
                <div v-for="(r, ri) in c1ContactEdit[client.id + '-osm-results']" :key="ri"
                  class="c1-loc-country-opt"
                  @click.stop="c1OsmSelect(client, r)">
                  {{ r.display_name }}
                </div>
              </div>
            </div>
            <div class="c1-loc-divider">— or set manually —</div>
            <!-- City text -->
            <div class="c1-loc-field-row">
              <label class="c1-loc-lbl">City</label>
              <input class="c1-ce-input" type="text" :value="c1ContactEdit[client.id + '-location'].val" @input="c1ContactEdit[client.id + '-location'].val = $event.target.value" placeholder="City name..." />
            </div>
            <!-- Country searchable dropdown -->
            <div class="c1-loc-field-row">
              <label class="c1-loc-lbl">Country</label>
              <div class="c1-loc-country-wrap">
                <input class="c1-ce-input" type="text"
                  :value="c1ContactEdit[client.id + '-country-search'] || ''"
                  @input="$set(c1ContactEdit, client.id + '-country-search', $event.target.value)"
                  placeholder="Search country..." />
                <div v-if="c1ContactEdit[client.id + '-country-search']" class="c1-loc-country-list">
                  <div v-for="co in c1FilteredCountries(c1ContactEdit[client.id + '-country-search'])" :key="co.id"
                    class="c1-loc-country-opt"
                    @click.stop="c1SelectCountry(client, co)">
                    {{ co.name }}
                  </div>
                  <div v-if="!c1FilteredCountries(c1ContactEdit[client.id + '-country-search']).length" class="c1-loc-country-empty">No match</div>
                </div>
              </div>
              <span v-if="c1ContactEdit[client.id + '-country-val']" class="c1-loc-country-sel">✓ {{ c1ContactEdit[client.id + '-country-val'].name }}</span>
            </div>
            <!-- Actions -->
            <div class="c1-loc-actions">
              <button class="c1-ce-save" @click.stop="c1SaveLocation(client)">Save</button>
              <button class="c1-ce-cancel" @click.stop="c1CancelLocation(client)">✕ Cancel</button>
              <span v-if="c1ContactEdit[client.id + '-location'].prev" class="c1-ce-prev">was: {{ c1ContactEdit[client.id + '-location'].prev }}</span>
            </div>
          </div>

          <!-- City intel expand body -->
          <div v-if="c1Accordion.cid === client.id && c1Accordion.type === 'city'" class="c1-more-body c1-city-body">
            <!-- Inline map iframe -->
            <div class="c1-city-map-wrap">
              <iframe
                v-if="client.country"
                :src="'https://maps.google.com/maps?q=' + encodeURIComponent([client.location, clientCountryName(client)].filter(Boolean).join(', ')) + '&z=11&output=embed&hl=en'"
                class="c1-city-map-frame"
                frameborder="0"
                allowfullscreen
                loading="lazy"
                @click.stop
              ></iframe>
              <div v-else class="c1-city-map-empty">No location data</div>
            </div>
            <!-- Hero strip: flag + name + stats inline -->
            <div class="c1-city-hero">
              <div class="c1-city-flag">{{ c1ClientFlag(client) }}</div>
              <div class="c1-city-loc">
                <div class="c1-city-name">{{ client.location || clientCountryName(client) || '—' }}</div>
                <div class="c1-city-country">{{ clientCountryName(client) }} · <span :class="c1ClientTod(client) && c1ClientTod(client).cls">{{ c1ClientTod(client) ? c1ClientTod(client).label : '' }}</span> {{ c1ClientLocalTime(client) }} · {{ c1CityGmt(client) }}</div>
              </div>
            </div>
            <!-- Languages + address -->
            <div class="c1-city-stats">
              <div class="c1-city-stat c1-city-stat-wide">
                <div class="c1-city-stat-lbl">Languages</div>
                <div class="c1-city-stat-val">{{ c1CityLangs(client) || '—' }}</div>
              </div>
              <div v-if="client.str || client.address" class="c1-city-stat c1-city-stat-wide">
                <div class="c1-city-stat-lbl">Address</div>
                <div class="c1-city-stat-val">{{ client.str || client.address }}</div>
              </div>
            </div>
            <!-- Viki talking points — orange face -->
            <div class="c1-city-tips">
              <div class="c1-city-viki-hdr">
                <div class="c1-city-viki-face">
                  <viki-face :mood="'happy'" :speaking="c1Accordion.cid === client.id" :size="32" style="width:46px;height:32px;display:block;overflow:hidden;border-radius:0;"/>
                </div>
                <div class="c1-city-viki-label">
                  <span class="c1-city-viki-name">Viki · Local Intelligence</span>
                  <span class="c1-city-viki-loc">{{ client.location || clientCountryName(client) }}</span>
                </div>
              </div>
              <div v-for="(tip, ti) in c1CityTips(client)" :key="'ct-'+ti" class="c1-city-tip-row">
                <span class="c1-city-tip-dot">▸</span>
                <span v-html="tip"></span>
              </div>
            </div>
          </div>

          <!-- ROW 3: campaign — keyword + device icon, chevron expands campaign details -->
          <div v-if="client.keyword || client.device" class="c1-cr c1-cr-src" :class="{ 'c1-cr-active': c1Accordion.cid === client.id && c1Accordion.type === 'camp' }" @click.stop="c1ToggleAccordion(client.id, 'camp')">
            <div class="c1-cr-ic" style="background:rgba(0,0,0,.04);color:var(--c1-t2);">
              <svg v-if="client.device && client.device.toLowerCase().includes('mobile')" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"/><line x1="12" y1="18" x2="12" y2="18"/></svg>
              <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
            </div>
            <div class="c1-cr-txt">
              <div style="display:flex;align-items:center;gap:5px;flex-wrap:nowrap;overflow:hidden;">
                <span style="font-size:11px;color:var(--c1-t1);font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ client.keyword || '—' }}</span>
                <span v-if="client.lead_loc" style="font-size:9px;color:var(--c1-t3);white-space:nowrap;">{{ client.lead_loc }}</span>
              </div>
            </div>
            <!-- Lead quality badge -->
            <span v-if="client.is_leading >= 10" class="c1-lq-badge c1-lq-hot" style="flex-shrink:0;margin-left:auto;margin-right:4px;">🔥 HOT</span>
            <span v-else-if="client.is_leading >= 1" class="c1-lq-badge c1-lq-warm" style="flex-shrink:0;margin-left:auto;margin-right:4px;">✅ WARM</span>
            <span v-else-if="client.is_leading < 0" class="c1-lq-badge c1-lq-cold" style="flex-shrink:0;margin-left:auto;margin-right:4px;">🧊 COLD</span>
            <div class="c1-cr-chv" :class="{ open: c1Accordion.cid === client.id && c1Accordion.type === 'camp' }">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
            </div>
          </div>
          <!-- Campaign expand body -->
          <div v-if="c1Accordion.cid === client.id && c1Accordion.type === 'camp'" class="c1-more-body">
            <div class="c1-exp-sec">
              <div class="c1-exp-lbl">Campaign Details</div>
              <div class="c1-exp-grid">
                <div v-if="client.keyword" class="c1-exp-field c1-exp-full">
                  <div class="c1-exp-fl">Source</div><div class="c1-exp-fv" style="font-weight:500">{{ client.keyword }}</div>
                </div>
                <div v-if="client.lead_loc" class="c1-exp-field">
                  <div class="c1-exp-fl">Location</div><div class="c1-exp-fv">{{ client.lead_loc }}</div>
                </div>
                <div v-if="client.placement" class="c1-exp-field c1-exp-full">
                  <div class="c1-exp-fl">Placement</div><div class="c1-exp-fv" style="font-size:10px;word-break:break-all">{{ client.placement }}</div>
                </div>
                <div v-if="client.cost_per_lead" class="c1-exp-field">
                  <div class="c1-exp-fl">Cost/Lead</div><div class="c1-exp-fv" style="color:var(--c1-dp);font-weight:700">{{ client.cost_per_lead }}</div>
                </div>
                <div v-if="client.device" class="c1-exp-field">
                  <div class="c1-exp-fl">Device</div><div class="c1-exp-fv">{{ client.device }}</div>
                </div>
                <div v-if="client.last_ip" class="c1-exp-field c1-exp-full">
                  <div class="c1-exp-fl">Last IP</div><div class="c1-exp-fv c1-mono" style="font-size:10px">{{ client.last_ip }}</div>
                </div>
                <div v-if="client.campaign_aaid" class="c1-exp-field c1-exp-full">
                  <div class="c1-exp-fl">AA ID</div><div class="c1-exp-fv c1-mono" style="font-size:10px;word-break:break-all">{{ client.campaign_aaid }}</div>
                </div>
                <div v-if="client.campaign_abid" class="c1-exp-field c1-exp-full">
                  <div class="c1-exp-fl">AB ID</div><div class="c1-exp-fv c1-mono" style="font-size:10px;word-break:break-all">{{ client.campaign_abid }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- ROW 4: agent -->
          <div v-if="client.assignment" class="c1-cr c1-cr-agent"
               :class="{ 'c1-cr-active': c1Accordion.cid === client.id && c1Accordion.type === 'agent' }"
               @click.stop="c1ToggleAccordion(client.id, 'agent')">
            <div class="c1-cr-ic" style="background:#fff;border:1px solid var(--c1-brd);color:var(--c1-t2);font-size:10px;font-weight:800;">
              {{ agentInitials(client) }}
            </div>
            <div class="c1-cr-txt">
              <div style="display:flex;align-items:center;gap:5px;">
                <span class="c1-ag-n">{{ clientAgentName(client) }}</span>
                <span v-if="client.assignment.assigned && client.assignment.assigned.is_online" class="c1-ag-online">● online</span>
                <span v-if="client.assignment.assigned_to && client.assignment.assigned_to.team_id === 1" class="c1-cr-team-tag c1-cr-team-tag--t1">T1</span>
                <span v-else-if="client.assignment.assigned_to && client.assignment.assigned_to.team_id === 2" class="c1-cr-team-tag c1-cr-team-tag--t2">T2</span>
              </div>
              <span v-if="client.assignment.created_at" class="c1-ag-d" style="font-size:9px;color:var(--c1-t3);margin-left:0;">Assigned {{ c1TimeAgo(client.assignment.created_at) }}</span>
            </div>
            <div v-if="c1CanAssign" class="c1-ck" :class="{ on: c1SelectedClients.includes(client.id) }" style="width:20px;height:20px;flex-shrink:0;" @click.stop="c1ToggleSelect(client.id)">
              <svg v-if="c1SelectedClients.includes(client.id)" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            </div>
            <div class="c1-cr-chv" :class="{ open: c1Accordion.cid === client.id && c1Accordion.type === 'agent' }" style="margin-left:4px;">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
            </div>
          </div>
          <!-- Agent expand: shift + today stats -->
          <div v-if="c1Accordion.cid === client.id && c1Accordion.type === 'agent'" class="c1-more-body c1-agent-body">
            <div class="c1-agent-stats-grid">
              <div class="c1-agent-stat">
                <div class="c1-agent-stat-lbl">Status</div>
                <div class="c1-agent-stat-val">
                  <span v-if="client.assignment.assigned && client.assignment.assigned.is_online" style="color:#22c55e;font-weight:700;">● Online</span>
                  <span v-else style="color:var(--c1-t3);">Offline</span>
                </div>
              </div>
              <div class="c1-agent-stat">
                <div class="c1-agent-stat-lbl">Assigned</div>
                <div class="c1-agent-stat-val">{{ c1TimeAgo(client.assignment.created_at) }}</div>
              </div>
              <div v-if="client.assignment.assigned && client.assignment.assigned.calls_today !== undefined" class="c1-agent-stat">
                <div class="c1-agent-stat-lbl">Calls Today</div>
                <div class="c1-agent-stat-val" style="color:var(--c1-sc);">{{ client.assignment.assigned.calls_today }}</div>
              </div>
              <div v-if="client.assignment.assigned && client.assignment.assigned.deposits_today !== undefined" class="c1-agent-stat">
                <div class="c1-agent-stat-lbl">Sales Today</div>
                <div class="c1-agent-stat-val" style="color:var(--c1-dp);">{{ client.assignment.assigned.deposits_today }}</div>
              </div>
              <div v-if="client.assignment.assigned && client.assignment.assigned.shift_start" class="c1-agent-stat c1-agent-stat-wide">
                <div class="c1-agent-stat-lbl">Shift Start</div>
                <div class="c1-agent-stat-val c1-mono">{{ fmtShort(client.assignment.assigned.shift_start) }} · {{ c1TimeAgo(client.assignment.assigned.shift_start) }}</div>
              </div>
              <div class="c1-agent-stat c1-agent-stat-wide">
                <div class="c1-agent-stat-lbl">Total Clients</div>
                <div class="c1-agent-stat-val">{{ client.assignment.assigned && client.assignment.assigned.client_assignments_count || '—' }}</div>
              </div>
            </div>
            <button class="c1-agent-reassign-btn" @click.stop="c1InlineAssignCid = c1InlineAssignCid === client.id ? null : client.id">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:11px;height:11px"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
              {{ c1InlineAssignCid === client.id ? 'Cancel' : 'Reassign' }}
            </button>
            <!-- INLINE AGENT PICKER -->
            <div v-if="c1InlineAssignCid === client.id" class="c1-inline-assign-picker" @click.stop>
              <input class="c1-iap-search" v-model.trim="c1InlineAssignSearch" placeholder="Search agent…" @click.stop />
              <div class="c1-iap-list">
                <div v-for="agent in c1InlineAssignAgents" :key="agent.id"
                     class="c1-iap-row"
                     @click.stop="c1DoInlineAssign(agent, client)">
                  <div class="c1-iap-av">{{ (agent.full_name || agent.name || '?')[0].toUpperCase() }}</div>
                  <div class="c1-iap-info">
                    <span class="c1-iap-name">{{ agent.full_name || agent.name }}</span>
                    <span class="c1-iap-cnt">{{ agent.client_assignments_count || 0 }} clients</span>
                  </div>
                  <span v-if="agent.is_online" class="c1-iap-online">●</span>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="client.is_new" class="c1-cr" style="background:rgba(34,197,94,.04);">
            <div class="c1-cr-ic" style="background:rgba(34,197,94,.1);color:#16a34a;">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
            </div>
            <div class="c1-cr-txt"><span style="font-size:11px;color:#16a34a;font-weight:600;">Needs a call — not assigned</span></div>
          </div>

        </div>

        <!-- NEW CLIENT DETAIL SLIDE (right below header, above phone) -->
        <div v-if="c1CardSelected === client.id && c1OpenTag && c1OpenTag.cid === client.id && c1OpenTag.type === 'new'" class="c1-td-wrap">
          <div class="c1-td-inner" style="border-left:3px solid var(--c1-nw)">
            <div class="c1-td-sec-lbl">Client Info</div>
            <div class="c1-tf"><div class="c1-tf-l">NEW since</div><div class="c1-tf-v c1-tf-ago" style="color:var(--c1-nw)">{{ c1TimeAgo(client.registered_on) }}</div></div>
            <div class="c1-tf"><div class="c1-tf-l">Registered</div><div class="c1-tf-v c1-tf-mono">{{ fmtShort(client.registered_on) }}</div></div>
            <div v-if="client.country" class="c1-tf"><div class="c1-tf-l">Country</div><div class="c1-tf-v">{{ c1ClientFlag(client) }} {{ clientCountryName(client) }}</div></div>
            <div v-if="client.location" class="c1-tf"><div class="c1-tf-l">City</div><div class="c1-tf-v">{{ client.location }}</div></div>
            <div v-if="c1ClientTod(client)" class="c1-tf"><div class="c1-tf-l">Local time</div><div class="c1-tf-v" :class="c1ClientTod(client).cls">{{ c1ClientTod(client).label }} · {{ c1ClientLocalTime(client) }}</div></div>
            <div v-if="client.birth_date" class="c1-tf"><div class="c1-tf-l">Age</div><div class="c1-tf-v">{{ client.age ? client.age + 'y' : client.birth_date }}</div></div>
            <div class="c1-td-sec-lbl" style="margin-top:8px">Assignment</div>
            <div v-if="client.assignment && client.assignment.assigned_to" class="c1-tf"><div class="c1-tf-l">Assigned to</div><div class="c1-tf-v" style="font-weight:700">{{ client.assignment.assigned_to.full_name || (client.assignment.assigned_to.first_name + ' ' + client.assignment.assigned_to.last_name) }}</div></div>
            <div v-if="client.assignment" class="c1-tf"><div class="c1-tf-l">Assigned</div><div class="c1-tf-v c1-tf-ago">{{ c1TimeAgo(client.assignment.created_at) }}</div></div>
            <div v-if="!client.assignment" class="c1-tf"><div class="c1-tf-l">Assigned to</div><div class="c1-tf-v" style="color:var(--c1-na);font-weight:700">Needs a call — not assigned</div></div>
            <div v-if="client.is_leading !== undefined && client.is_leading !== 0" class="c1-tf">
              <div class="c1-tf-l">Lead Score</div>
              <div class="c1-tf-v">
                <span v-if="client.is_leading >= 10" class="c1-lq-badge c1-lq-hot">🔥 HOT · {{ client.is_leading }}</span>
                <span v-else-if="client.is_leading >= 1" class="c1-lq-badge c1-lq-warm">✅ WARM · {{ client.is_leading }}</span>
                <span v-else-if="client.is_leading < 0" class="c1-lq-badge c1-lq-cold">🧊 COLD · {{ client.is_leading }}</span>
              </div>
            </div>
            <div class="c1-td-sec-lbl" style="margin-top:8px">Campaign</div>
            <div v-if="client.keyword" class="c1-tf"><div class="c1-tf-l">Campaign</div><div class="c1-tf-v" style="font-weight:600">{{ client.keyword }}</div></div>
            <div v-if="client.lead_loc" class="c1-tf"><div class="c1-tf-l">Location</div><div class="c1-tf-v">{{ client.lead_loc }}</div></div>
            <div v-if="client.placement" class="c1-tf c1-tf-col"><div class="c1-tf-l">Placement</div><div class="c1-tf-v c1-tf-mono" style="font-size:9px;word-break:break-all">{{ client.placement }}</div></div>
            <div v-if="client.cost_per_lead" class="c1-tf"><div class="c1-tf-l">CPL</div><div class="c1-tf-v" style="color:var(--c1-dp);font-weight:700">{{ client.cost_per_lead }}</div></div>
            <div v-if="client.campaign_aaid" class="c1-tf c1-tf-col"><div class="c1-tf-l">Ad ID (A)</div><div class="c1-tf-v c1-tf-mono" style="font-size:9px;word-break:break-all">{{ client.campaign_aaid }}</div></div>
            <div v-if="client.campaign_abid" class="c1-tf c1-tf-col"><div class="c1-tf-l">Ad ID (B)</div><div class="c1-tf-v c1-tf-mono" style="font-size:9px;word-break:break-all">{{ client.campaign_abid }}</div></div>
            <button class="c1-td-x" @click.stop="c1OpenTag = null"><svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>
          </div>
        </div>

        <!-- LOG ACTIVITY ROW — above tags, identical to phone/email row style -->
        <div v-if="c1CardSelected === client.id || c1DetailMode"
             class="c1-cr c1-cr-add" :class="{ 'c1-cr-active': c1TagPicker.cid === client.id }"
             @click.stop="c1TagPicker.cid === client.id ? c1ClosePicker() : (c1TagPicker = { cid: client.id, type: null, loading: false })">
          <div class="c1-cr-ic c1-cr-ic-add">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          </div>
          <div class="c1-cr-txt">
            <span style="font-size:11px;color:var(--c1-t3)">Log Activity</span>
          </div>
          <div class="c1-cr-chv" :class="{ open: c1TagPicker.cid === client.id }">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
        </div>

        <!-- ROW 4: tag history — shown AFTER picker when picker is open -->
        <div v-if="(c1CardSelected === client.id || c1DetailMode) && !c1TagPicker.cid" class="c1-box-r4">
          <div v-if="client.scheduled_calls && client.scheduled_calls.length"
            class="c1-r4-stat c1-r4-sc c1-r4-sc-first" :class="{ open: c1IsTagOpen(client.id, 'sc', 0), 'c1-r4-late': c1ScIsLate(client) }"
            @click.stop="c1ToggleTag(client.id, 'sc', 0)">
            📅 <strong>{{ client.scheduled_calls.length === 1 ? 'SC' : client.scheduled_calls.length + ' SC' }}</strong>
            <span class="c1-r4-ago">{{ scTimer(client.scheduled_calls[0]) }}</span>
          </div>
          <div v-if="client.scheduled_calls && client.scheduled_calls.length" class="c1-r3s"></div>
          <template v-if="client.deposits && client.deposits.length">
            <div v-for="(dep, di) in client.deposits" :key="'dep-'+dep.id"
              class="c1-r4-stat c1-r4-dp" :class="{ open: c1IsTagOpen(client.id, 'dep', di) }"
              @click.stop="c1ToggleTag(client.id, 'dep', di)">
              <svg viewBox="0 0 24 24" style="width:9px;height:9px;stroke:currentColor;fill:none;stroke-width:2.5"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
              <strong>{{ dep.amount || 'DP' }}</strong>
              <span v-if="dep.status_id" class="c1-r4-ago">· {{ (depositStatuses.find(s => s.id === dep.status_id) || {}).label || '' }}</span>
              <span class="c1-r4-ago">{{ timeAgo(dep.created_at) }}</span>
            </div>
            <div class="c1-r3s"></div>
          </template>
          <div v-if="client.leads && client.leads.length"
            class="c1-r4-stat c1-r4-ld" :class="{ open: c1IsTagOpen(client.id, 'ld', 0) }"
            @click.stop="c1ToggleTag(client.id, 'ld', 0)">
            <strong>{{ client.leads.length }}</strong> LD
            <span class="c1-r4-ago">{{ timeAgo(client.leads[0].created_at) }}</span>
          </div>
          <div v-if="client.na && client.na.length"
            class="c1-r4-stat c1-r4-na" :class="{ open: c1IsTagOpen(client.id, 'na', 0) }"
            @click.stop="c1ToggleTag(client.id, 'na', 0)">
            <strong>{{ client.na.length }}</strong> NA
            <span class="c1-r4-ago">{{ timeAgo(client.na[0].created_at) }}</span>
          </div>
          <div v-if="client.referrals && client.referrals.length"
            class="c1-r4-stat c1-r4-rf" :class="{ open: c1IsTagOpen(client.id, 'rf', 0) }"
            @click.stop="c1ToggleTag(client.id, 'rf', 0)">
            <strong>{{ client.referrals.length }}</strong> RF
            <span class="c1-r4-ago">{{ timeAgo(client.referrals[0].created_at) }}</span>
          </div>
          <div v-if="client.bn && client.bn.length" class="c1-r4-stat c1-r4-bn">BN</div>
          <!-- LAST: full history -->
          <div class="c1-r4-stat c1-r4-last" :class="{ open: c1HistOpen[client.id] }"
               @click.stop="$set(c1HistOpen, client.id, !c1HistOpen[client.id])">
            📋 LAST
          </div>
        </div>
        <!-- Inline history log (below r4, before picker) -->
        <div v-if="(c1CardSelected === client.id || c1DetailMode) && !c1TagPicker.cid && c1HistOpen[client.id]" class="c1-inline-hist">
          <template v-for="(ev, hi) in c1FullActivityLog(client)">
            <div v-if="hi > 0 && ev.gap" :key="'ihg-'+client.id+'-'+hi" class="c1-hist-gap">
              <span class="c1-hist-gap-pill">{{ ev.gap }}</span>
            </div>
            <div :key="'ihe-'+client.id+'-'+hi" class="c1-hist-row">
              <div class="c1-hist-dot" :style="{ background: ev.color }"></div>
              <div class="c1-hist-body">
                <div class="c1-hist-top">
                  <span class="c1-hist-badge" :style="{ background: ev.color + '22', color: ev.color }">{{ ev.type }}</span>
                  <span class="c1-hist-title">{{ ev.label }}</span>
                </div>
                <div class="c1-hist-meta">
                  <span class="c1-mono" style="font-size:9px;color:var(--c1-t3);">{{ ev.date }}</span>
                  <span v-if="ev.agent" style="font-size:9px;color:var(--c1-t3);">· {{ ev.agent }}</span>
                </div>
              </div>
              <span class="c1-hist-ago">{{ ev.ago }}</span>
            </div>
          </template>
          <div v-if="!c1FullActivityLog(client).length" style="font-size:11px;color:var(--c1-t3);padding:8px 14px;text-align:center;">No activity recorded</div>
        </div>

        <!-- INLINE TAG PICKER — directly below + button row -->
        <div v-if="c1TagPicker.cid === client.id" class="c1-itp">
          <!-- Header with close -->
          <div class="c1-itp-hdr">
            <span class="c1-itp-hdr-ttl">Log activity</span>
            <button class="c1-itp-close" @click.stop="c1ClosePicker()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
          <!-- Loading -->
          <div v-if="c1TagPicker.loading" class="c1-itp-spin"><div class="c1-spinner"></div></div>
          <template v-else>
            <!-- Tag type chips row -->
            <div class="c1-itp-chips">
              <div class="c1-itp-chip c1-itp-dp" :class="{on: c1TagPicker.type==='dp'}" @click.stop="c1TpToggle('dp')">Deposit</div>
              <div class="c1-itp-chip c1-itp-sc" :class="{on: c1TagPicker.type==='sc'}" @click.stop="c1TpToggle('sc')">Schedule</div>
              <div class="c1-itp-chip c1-itp-ld" :class="{on: c1TagPicker.type==='ld'}" @click.stop="c1TpToggle('ld')">Lead</div>
              <div class="c1-itp-chip c1-itp-rf" :class="{on: c1TagPicker.type==='rf'}" @click.stop="c1TpToggle('rf')">Referral</div>
              <div class="c1-itp-chip c1-itp-tr" :class="{on: c1TagPicker.type==='tr'}" @click.stop="c1TpToggle('tr')">Transfer</div>
              <div class="c1-itp-chip c1-itp-na" :class="{on: c1TagPicker.type==='na'}" @click.stop="c1TpToggle('na')">No Answer</div>
              <div class="c1-itp-chip c1-itp-bn" :class="{on: c1TagPicker.type==='bn'}" @click.stop="c1TpToggle('bn')">Bad Number</div>
              <div class="c1-itp-chip c1-itp-ni" :class="{on: c1TagPicker.type==='ni'}" @click.stop="c1TpToggle('ni')">Not Interested</div>
              <div class="c1-itp-chip c1-itp-end" :class="{on: c1TagPicker.type==='ended'}" @click.stop="c1TpToggle('ended')">Ended</div>
              <div class="c1-itp-chip c1-itp-wait" :class="{on: c1TagPicker.type==='waiting'}" @click.stop="c1TpToggle('waiting')">Waiting</div>
              <div class="c1-itp-chip c1-itp-ag" :class="{on: c1TagPicker.type==='assign'}" @click.stop="c1TpToggle('assign')">Assign</div>
              <div class="c1-itp-chip c1-itp-hist" :class="{on: c1TagPicker.type==='history'}" @click.stop="c1TpToggle('history')" style="border-color:rgba(139,92,246,.3);color:#a78bfa;">📋 History</div>
            </div>
            <!-- Form expands inline -->
            <template v-if="c1TagPicker.type">
              <!-- NA -->
              <div v-if="c1TagPicker.type === 'na'" class="c1-itp-form">
                <div class="c1-pkf-row2">
                  <button class="c1-pkf-action c1-pkf-na" @click.stop="c1SubmitNA(false)">No Answer</button>
                  <button class="c1-pkf-action c1-pkf-vm" @click.stop="c1SubmitNA(true)">Voicemail</button>
                </div>
              </div>
              <!-- BN -->
              <div v-else-if="c1TagPicker.type === 'bn'" class="c1-itp-form">
                <div class="c1-ni-grid">
                  <button v-for="s in bnStates" :key="s.id" class="c1-ni-opt" style="background:#F2F1F0;color:var(--c1-bn);border-color:rgba(122,112,103,.2)" @click.stop="c1SubmitBN(s.id)">{{ c1BnLabel(s) }}</button>
                </div>
              </div>
              <!-- NI -->
              <div v-else-if="c1TagPicker.type === 'ni'" class="c1-itp-form">
                <button class="c1-pkf-action c1-itp-remove-btn" style="width:100%" @click.stop="c1SubmitRemoveNI()">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:15px;height:15px"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-3.87"/></svg>
                  Remove NI — Bring Back
                </button>
                <div class="c1-pkf-lbl" style="margin-top:4px">Mark as Not Interested</div>
                <div class="c1-ni-grid">
                  <button v-for="s in niStates" :key="s.id" class="c1-ni-opt" @click.stop="c1SubmitNI(s.id)">{{ s.name }}</button>
                </div>
              </div>
              <!-- ENDED -->
              <div v-else-if="c1TagPicker.type === 'ended'" class="c1-itp-form">
                <button class="c1-pkf-action c1-itp-end-btn" style="width:100%" @click.stop="c1SubmitEnded()">Mark as Ended</button>
              </div>
              <!-- WAITING -->
              <div v-else-if="c1TagPicker.type === 'waiting'" class="c1-itp-form">
                <button class="c1-pkf-action c1-itp-wait-btn" style="width:100%" @click.stop="c1SubmitWaiting()">Set Waiting</button>
              </div>
              <!-- SC -->
              <div v-else-if="c1TagPicker.type === 'sc'" class="c1-itp-form">
                <div class="c1-pkf-group">
                  <label class="c1-pkf-lbl">Date &amp; Time</label>
                  <input class="c1-pkf-input" type="datetime-local" v-model="c1PickerForm.sc.call_scheduled_on" />
                </div>
                <div class="c1-pkf-group">
                  <label class="c1-pkf-lbl">Status</label>
                  <div class="c1-pkf-opts">
                    <button v-for="s in scStatuses" :key="s.id" class="c1-pkf-opt c1-pkf-sc-opt" :class="{on: c1PickerForm.sc.status_id === s.id}" @click.stop="c1PickerForm.sc.status_id = s.id">{{ s.type }}</button>
                  </div>
                </div>
                <div class="c1-pkf-group">
                  <label class="c1-pkf-lbl">Comment <span class="c1-pkf-opt-lbl">(optional)</span></label>
                  <textarea class="c1-pkf-input" v-model="c1PickerForm.sc.comment" rows="2" placeholder="Note..."></textarea>
                </div>
                <button class="c1-pkf-submit c1-pkf-submit-sc" @click.stop="c1SubmitSC()" :disabled="!c1PickerForm.sc.call_scheduled_on || !c1PickerForm.sc.status_id">Schedule Call</button>
              </div>
              <!-- DP -->
              <div v-else-if="c1TagPicker.type === 'dp'" class="c1-itp-form">
                <div class="c1-pkf-group">
                  <label class="c1-pkf-lbl">Broker / Campaign</label>
                  <select class="c1-pkf-select" v-model="c1PickerForm.dp.campaign_id">
                    <option :value="null" disabled>Select broker...</option>
                    <option v-for="b in c1ActiveBrokers" :key="b.id" :value="b.id">{{ b.name }}</option>
                  </select>
                </div>
                <div class="c1-pkf-row2">
                  <div class="c1-pkf-group">
                    <label class="c1-pkf-lbl">Amount</label>
                    <input class="c1-pkf-input" type="number" v-model.number="c1PickerForm.dp.amount" min="0" />
                  </div>
                  <div class="c1-pkf-group">
                    <label class="c1-pkf-lbl">Currency</label>
                    <select class="c1-pkf-select" v-model="c1PickerForm.dp.currency_id">
                      <option v-for="c in ((dictionaries && dictionaries.activity && dictionaries.activity.currency_types) || [])" :key="c.id" :value="c.id">{{ c.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="c1-pkf-group">
                  <label class="c1-pkf-lbl">Payment Method</label>
                  <div class="c1-pkf-opts">
                    <button v-for="m in ((dictionaries && dictionaries.activity && dictionaries.activity.deposit_methods) || [])" :key="m.id" class="c1-pkf-opt" :class="{on: c1PickerForm.dp.method_id === m.id}" @click.stop="c1PickerForm.dp.method_id = m.id">{{ m.method }}</button>
                  </div>
                </div>
                <div class="c1-pkf-group">
                  <label class="c1-pkf-lbl">Status</label>
                  <div class="c1-pkf-opts">
                    <button v-for="s in ((dictionaries && dictionaries.activity && dictionaries.activity.client_deposit_types) || [])" :key="s.id" class="c1-pkf-opt c1-pkf-dp-s" :class="{on: c1PickerForm.dp.status_id === s.id}" @click.stop="c1PickerForm.dp.status_id = s.id">{{ s.type }}</button>
                  </div>
                </div>
                <div class="c1-pkf-group">
                  <label class="c1-pkf-lbl">Comment</label>
                  <textarea class="c1-pkf-input" v-model="c1PickerForm.dp.comment" rows="2" placeholder="Deposit note..."></textarea>
                </div>
                <button class="c1-pkf-submit c1-pkf-submit-dp" @click.stop="c1SubmitDP()" :disabled="!c1PickerForm.dp.campaign_id || !c1PickerForm.dp.status_id || !c1PickerForm.dp.method_id">Confirm Deposit</button>
              </div>
              <!-- LD -->
              <div v-else-if="c1TagPicker.type === 'ld'" class="c1-itp-form">
                <div class="c1-pkf-group">
                  <label class="c1-pkf-lbl">Broker / Campaign</label>
                  <!-- Selected broker pill -->
                  <div v-if="c1PickerForm.ld.campaign_id" class="c1-broker-pill">
                    <span>{{ (c1ActiveBrokers.find(b => b.id === c1PickerForm.ld.campaign_id) || {}).name }}</span>
                    <button @click.stop="c1PickerForm.ld.campaign_id = null; c1PickerForm.ld.brokerSearch = ''">✕</button>
                  </div>
                  <!-- Search input when nothing selected -->
                  <template v-else>
                    <input type="text" class="c1-pkf-input c1-broker-search" v-model="c1PickerForm.ld.brokerSearch"
                      placeholder="Search broker..." autocomplete="off" />
                    <div class="c1-broker-list" v-if="c1ActiveBrokers.filter(b => !c1PickerForm.ld.brokerSearch || b.name.toLowerCase().includes(c1PickerForm.ld.brokerSearch.toLowerCase())).length">
                      <div v-for="b in c1ActiveBrokers.filter(b => !c1PickerForm.ld.brokerSearch || b.name.toLowerCase().includes(c1PickerForm.ld.brokerSearch.toLowerCase()))"
                        :key="b.id" class="c1-broker-opt"
                        @click.stop="c1PickerForm.ld.campaign_id = b.id; c1PickerForm.ld.brokerSearch = ''">
                        {{ b.name }}
                      </div>
                    </div>
                    <div v-else class="c1-broker-empty">No brokers match</div>
                  </template>
                </div>
                <div class="c1-pkf-group">
                  <label class="c1-pkf-lbl">Comment <span class="c1-pkf-opt-lbl">(optional)</span></label>
                  <textarea class="c1-pkf-input" v-model="c1PickerForm.ld.comment" rows="2" placeholder="Lead note..."></textarea>
                </div>
                <button class="c1-pkf-submit c1-pkf-submit-ld" @click.stop="c1SubmitLD()" :disabled="!c1PickerForm.ld.campaign_id">Add Lead</button>
              </div>
              <!-- RF -->
              <div v-else-if="c1TagPicker.type === 'rf'" class="c1-itp-form">
                <div class="c1-pkf-group">
                  <label class="c1-pkf-lbl">Broker / Campaign</label>
                  <select class="c1-pkf-select" v-model="c1PickerForm.rf.campaign_id">
                    <option :value="null" disabled>Select broker...</option>
                    <option v-for="b in c1ActiveBrokers" :key="b.id" :value="b.id">{{ b.name }}</option>
                  </select>
                </div>
                <div class="c1-pkf-group">
                  <label class="c1-pkf-lbl">Comment <span class="c1-pkf-opt-lbl">(optional)</span></label>
                  <textarea class="c1-pkf-input" v-model="c1PickerForm.rf.comment" rows="2" placeholder="Referral note..."></textarea>
                </div>
                <button class="c1-pkf-submit c1-pkf-submit-rf" @click.stop="c1SubmitRF()" :disabled="!c1PickerForm.rf.campaign_id">Add Referral</button>
              </div>
              <!-- TR -->
              <div v-else-if="c1TagPicker.type === 'tr'" class="c1-itp-form">
                <div class="c1-pkf-group">
                  <label class="c1-pkf-lbl">Transfer Type</label>
                  <div class="c1-pkf-opts">
                    <button v-for="t in trTypes" :key="t.id" class="c1-pkf-opt" :class="{on: c1PickerForm.tr.type_id === t.id}" @click.stop="c1PickerForm.tr.type_id = t.id">{{ t.name }}</button>
                  </div>
                </div>
                <div class="c1-pkf-group">
                  <label class="c1-pkf-lbl">To Agent</label>
                  <select class="c1-pkf-select" v-model="c1PickerForm.tr.to">
                    <option :value="null" disabled>Select agent...</option>
                    <option v-for="a in ($store.state.clients.salesPersonList || [])" :key="a.id" :value="a.id">{{ a.full_name || a.name }}</option>
                  </select>
                  <button class="c1-ai-suggest-btn" @click="c1LoadViopaScore" :disabled="c1ViopaLoading">
                    {{ c1ViopaLoading ? '...' : '🤖 AI Suggest' }}
                  </button>
                  <div v-if="c1ViopaSuggestions.length" class="c1-viopa-results">
                    <div v-for="agent in c1ViopaSuggestions" :key="agent.agent_id" class="c1-viopa-agent"
                      @click="c1SelectViopaAgent(agent)">
                      <span class="c1-viopa-name">{{ agent.name }}</span>
                      <span class="c1-viopa-score" :class="agent.is_golden_buzzer ? 'golden' : ''">
                        {{ agent.is_golden_buzzer ? '⭐' : '' }} {{ agent.score }}pts
                      </span>
                    </div>
                  </div>
                </div>
                <button class="c1-pkf-submit c1-pkf-submit-tr" @click.stop="c1SubmitTR()" :disabled="!c1PickerForm.tr.type_id || !c1PickerForm.tr.to">Transfer</button>
              </div>
              <!-- ASSIGN to agent -->
              <div v-else-if="c1TagPicker.type === 'assign'" class="c1-itp-form">
                <input class="c1-pkf-input" type="search" v-model="c1AssignSearch" placeholder="Search agent..." style="margin-bottom:6px" />
                <div style="max-height:180px;overflow-y:auto;display:flex;flex-direction:column;gap:3px">
                  <div v-for="agent in c1FilteredAgents" :key="agent.id"
                    class="c1-pkf-opt"
                    style="display:flex;align-items:center;justify-content:space-between;cursor:pointer"
                    @click.stop="c1AssignClient(agent, c1ActiveClient)">
                    <span>{{ agent.full_name || agent.name }}</span>
                    <span style="color:var(--c1-t3);font-size:10px">{{ agent.client_assignments_count || 0 }}</span>
                  </div>
                  <div v-if="!c1FilteredAgents.length" style="color:var(--c1-t3);font-size:11px;padding:4px 0">No agents found</div>
                </div>
              </div>
              <!-- HISTORY — full activity log -->
              <div v-else-if="c1TagPicker.type === 'history'" class="c1-itp-form c1-hist-log">
                <template v-for="(ev, hi) in c1FullActivityLog(client)">
                  <!-- time gap badge between entries -->
                  <div v-if="hi > 0 && ev.gap" :key="'hg-'+hi" class="c1-hist-gap">
                    <span class="c1-hist-gap-pill">{{ ev.gap }}</span>
                  </div>
                  <div :key="'he-'+hi" class="c1-hist-row">
                    <div class="c1-hist-dot" :style="{ background: ev.color }"></div>
                    <div class="c1-hist-body">
                      <div class="c1-hist-top">
                        <span class="c1-hist-badge" :style="{ background: ev.color + '22', color: ev.color }">{{ ev.type }}</span>
                        <span class="c1-hist-title">{{ ev.label }}</span>
                      </div>
                      <div class="c1-hist-meta">
                        <span class="c1-mono" style="font-size:9px;color:var(--c1-t3);">{{ ev.date }}</span>
                        <span v-if="ev.agent" style="font-size:9px;color:var(--c1-t3);">· {{ ev.agent }}</span>
                      </div>
                    </div>
                    <span class="c1-hist-ago">{{ ev.ago }}</span>
                  </div>
                </template>
                <div v-if="!c1FullActivityLog(client).length" style="font-size:11px;color:var(--c1-t3);padding:8px 0;text-align:center;">No activity recorded</div>
              </div>
            </template>
          </template>
        </div>

        <!-- ROW 4: tags shown below picker when picker is open -->
        <div v-if="(c1CardSelected === client.id || c1DetailMode) && c1TagPicker.cid === client.id" class="c1-box-r4">
          <div v-if="client.scheduled_calls && client.scheduled_calls.length"
            class="c1-r4-stat c1-r4-sc c1-r4-sc-first" :class="{ open: c1IsTagOpen(client.id, 'sc', 0), 'c1-r4-late': c1ScIsLate(client) }"
            @click.stop="c1ToggleTag(client.id, 'sc', 0)">
            📅 <strong>{{ client.scheduled_calls.length === 1 ? 'SC' : client.scheduled_calls.length + ' SC' }}</strong>
            <span class="c1-r4-ago">{{ scTimer(client.scheduled_calls[0]) }}</span>
          </div>
          <div v-if="client.scheduled_calls && client.scheduled_calls.length" class="c1-r3s"></div>
          <template v-if="client.deposits && client.deposits.length">
            <div v-for="(dep, di) in client.deposits" :key="'dep-'+dep.id"
              class="c1-r4-stat c1-r4-dp" :class="{ open: c1IsTagOpen(client.id, 'dep', di) }"
              @click.stop="c1ToggleTag(client.id, 'dep', di)">
              <svg viewBox="0 0 24 24" style="width:9px;height:9px;stroke:currentColor;fill:none;stroke-width:2.5"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
              <strong>{{ dep.amount || 'DP' }}</strong>
              <span v-if="dep.status_id" class="c1-r4-ago">· {{ (depositStatuses.find(s => s.id === dep.status_id) || {}).label || '' }}</span>
              <span class="c1-r4-ago">{{ timeAgo(dep.created_at) }}</span>
            </div>
            <div class="c1-r3s"></div>
          </template>
          <div v-if="client.leads && client.leads.length"
            class="c1-r4-stat c1-r4-ld" :class="{ open: c1IsTagOpen(client.id, 'ld', 0) }"
            @click.stop="c1ToggleTag(client.id, 'ld', 0)">
            <strong>{{ client.leads.length }}</strong> LD
            <span class="c1-r4-ago">{{ timeAgo(client.leads[0].created_at) }}</span>
          </div>
          <div v-if="client.na && client.na.length"
            class="c1-r4-stat c1-r4-na" :class="{ open: c1IsTagOpen(client.id, 'na', 0) }"
            @click.stop="c1ToggleTag(client.id, 'na', 0)">
            <strong>{{ client.na.length }}</strong> NA
            <span class="c1-r4-ago">{{ timeAgo(client.na[0].created_at) }}</span>
          </div>
          <div v-if="client.referrals && client.referrals.length"
            class="c1-r4-stat c1-r4-rf" :class="{ open: c1IsTagOpen(client.id, 'rf', 0) }"
            @click.stop="c1ToggleTag(client.id, 'rf', 0)">
            <strong>{{ client.referrals.length }}</strong> RF
            <span class="c1-r4-ago">{{ timeAgo(client.referrals[0].created_at) }}</span>
          </div>
          <div v-if="client.bn && client.bn.length" class="c1-r4-stat c1-r4-bn">BN</div>
          <div class="c1-r4-stat c1-r4-last" :class="{ open: c1HistOpen[client.id] }"
               @click.stop="$set(c1HistOpen, client.id, !c1HistOpen[client.id])">
            📋 LAST
          </div>
        </div>
        <!-- Inline history log (below r4, when picker is open) -->
        <div v-if="(c1CardSelected === client.id || c1DetailMode) && c1TagPicker.cid === client.id && c1HistOpen[client.id]" class="c1-inline-hist">
          <template v-for="(ev, hi) in c1FullActivityLog(client)">
            <div v-if="hi > 0 && ev.gap" :key="'ihgp-'+client.id+'-'+hi" class="c1-hist-gap">
              <span class="c1-hist-gap-pill">{{ ev.gap }}</span>
            </div>
            <div :key="'ihep-'+client.id+'-'+hi" class="c1-hist-row">
              <div class="c1-hist-dot" :style="{ background: ev.color }"></div>
              <div class="c1-hist-body">
                <div class="c1-hist-top">
                  <span class="c1-hist-badge" :style="{ background: ev.color + '22', color: ev.color }">{{ ev.type }}</span>
                  <span class="c1-hist-title">{{ ev.label }}</span>
                </div>
                <div class="c1-hist-meta">
                  <span class="c1-mono" style="font-size:9px;color:var(--c1-t3);">{{ ev.date }}</span>
                  <span v-if="ev.agent" style="font-size:9px;color:var(--c1-t3);">· {{ ev.agent }}</span>
                </div>
              </div>
              <span class="c1-hist-ago">{{ ev.ago }}</span>
            </div>
          </template>
          <div v-if="!c1FullActivityLog(client).length" style="font-size:11px;color:var(--c1-t3);padding:8px 14px;text-align:center;">No activity recorded</div>
        </div>

        <!-- TAG DETAIL SLIDE (shown above phone) -->
        <template v-if="(c1CardSelected === client.id || c1DetailMode) && c1OpenTag && c1OpenTag.cid === client.id">

          <!-- DEPOSIT detail -->
          <div v-if="c1OpenTag.type === 'dep' && client.deposits[c1OpenTag.idx]" class="c1-td-wrap">
            <div class="c1-td-inner c1-tdi-dp">
              <div class="c1-tf"><div class="c1-tf-l">Amount</div><div class="c1-tf-v c1-tf-big" style="color:var(--c1-dp)">{{ client.deposits[c1OpenTag.idx].amount || '—' }}</div></div>
              <div class="c1-tf"><div class="c1-tf-l">Method</div><div class="c1-tf-v">{{ client.deposits[c1OpenTag.idx].payment_method || '—' }}</div></div>
              <div class="c1-tf"><div class="c1-tf-l">Date</div><div class="c1-tf-v c1-tf-mono">{{ fmtShort(client.deposits[c1OpenTag.idx].created_at) }}</div></div>
              <template v-if="c1LocalTime(client.deposits[c1OpenTag.idx].created_at, client.country && client.country.zone_name)">
                <div class="c1-tf"><div class="c1-tf-l">Client time</div><div class="c1-tf-v c1-tf-mono">{{ c1LocalTime(client.deposits[c1OpenTag.idx].created_at, client.country && client.country.zone_name).time }} · {{ c1LocalTime(client.deposits[c1OpenTag.idx].created_at, client.country && client.country.zone_name).weekday }} {{ c1LocalTime(client.deposits[c1OpenTag.idx].created_at, client.country && client.country.zone_name).date }}</div></div>
                <div class="c1-tf"><div class="c1-tf-l">Part of day</div><div class="c1-tf-v">{{ c1LocalTime(client.deposits[c1OpenTag.idx].created_at, client.country && client.country.zone_name).icon }} {{ c1LocalTime(client.deposits[c1OpenTag.idx].created_at, client.country && client.country.zone_name).dayPart }} <span style="opacity:.5;font-size:10px">({{ c1LocalTime(client.deposits[c1OpenTag.idx].created_at, client.country && client.country.zone_name).tzLabel }})</span></div></div>
              </template>
              <div class="c1-tf"><div class="c1-tf-l">Age</div><div class="c1-tf-v c1-tf-ago">{{ c1TimeAgo(client.deposits[c1OpenTag.idx].created_at) }}</div></div>
              <div class="c1-tf"><div class="c1-tf-l">Status</div>
                <div class="c1-tf-v">
                  <div class="c1-td-status-row">
                    <span v-for="s in depositStatuses" :key="s.id"
                      class="c1-td-sopt" :class="{ on: client.deposits[c1OpenTag.idx].status_id === s.id }"
                      @click.stop="c1UpdateDepositStatus(client.deposits[c1OpenTag.idx].id, s.id)">{{ s.label }}</span>
                  </div>
                </div>
              </div>
              <button class="c1-td-x" @click.stop="c1OpenTag = null"><svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>
            </div>
          </div>

          <!-- LEAD detail — full history -->
          <div v-else-if="c1OpenTag.type === 'ld' && client.leads && client.leads.length" class="c1-td-wrap">
            <div class="c1-td-inner c1-tdi-ld">
              <!-- Header -->
              <div class="c1-na-hdr">
                <span class="c1-na-hdr-title" style="--hc:var(--c1-ld)">Lead History · <strong style="color:var(--c1-ld)">{{ client.leads.length }}</strong> lead{{ client.leads.length !== 1 ? 's' : '' }}</span>
                <button class="c1-td-x" @click.stop="c1OpenTag = null"><svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>
              </div>
              <!-- Summary strip -->
              <div class="c1-na-summary" style="background:rgba(212,160,23,.08)">
                <span class="c1-na-sum-item"><span class="c1-na-sum-lbl">Last</span> {{ c1TimeAgo(client.leads[0].created_at) }}</span>
                <span class="c1-na-sum-sep">·</span>
                <span class="c1-na-sum-item"><span class="c1-na-sum-lbl">By</span>
                  {{ c1LeadAgents(client.leads) }}
                </span>
              </div>
              <!-- History rows -->
              <div class="c1-na-history">
                <div v-for="(ld, li) in client.leads" :key="'ldh-' + ld.id" class="c1-na-row">
                  <div class="c1-na-row-left" style="gap:7px">
                    <span class="c1-na-num">#{{ client.leads.length - li }}</span>
                    <span class="c1-na-dot" style="background:var(--c1-ld)"></span>
                    <div style="display:flex;flex-direction:column;gap:1px">
                      <span class="c1-na-type" style="color:var(--c1-ld)">{{ ld.campaign ? ld.campaign.name : (ld.campaign_id ? 'Broker #' + ld.campaign_id : '—') }}</span>
                      <span v-if="ld.comment" class="c1-na-by" style="font-size:10px;color:var(--c1-t2);max-width:160px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">{{ ld.comment }}</span>
                    </div>
                  </div>
                  <div class="c1-na-row-right">
                    <span class="c1-na-dt c1-tf-mono">{{ fmtShort(ld.created_at) }}</span>
                    <span v-if="c1LocalTime(ld.created_at, client.country && client.country.zone_name)" class="c1-na-tod">
                      {{ c1LocalTime(ld.created_at, client.country && client.country.zone_name).icon }} {{ c1LocalTime(ld.created_at, client.country && client.country.zone_name).time }} ({{ c1LocalTime(ld.created_at, client.country && client.country.zone_name).dayPart }})
                    </span>
                    <span class="c1-na-by">{{ ld.user ? (ld.user.full_name || ld.user.first_name + ' ' + ld.user.last_name) : '—' }}</span>
                    <span class="c1-na-by" style="color:var(--c1-t3)">{{ c1TimeAgo(ld.created_at) }}</span>
                  </div>
                </div>
              </div>
              <!-- Actions -->
              <div class="c1-td-actions">
                <button class="c1-td-act c1-td-act-del" @click.stop="c1RemoveTag('lead', client.id)">Remove Lead</button>
              </div>
            </div>
          </div>

          <!-- NA detail — full history log -->
          <div v-else-if="c1OpenTag.type === 'na' && client.na && client.na.length" class="c1-td-wrap">
            <div class="c1-td-inner c1-tdi-na">
              <!-- Header -->
              <div class="c1-na-hdr">
                <span class="c1-na-hdr-title">No Answer History · <strong>{{ client.na.length }}</strong> attempt{{ client.na.length !== 1 ? 's' : '' }}</span>
                <button class="c1-td-x" @click.stop="c1OpenTag = null"><svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>
              </div>
              <!-- Summary strip -->
              <div v-if="c1NaStats(client.na, client)" class="c1-na-summary">
                <span class="c1-na-sum-item"><span class="c1-na-sum-lbl">Last</span> {{ c1NaStats(client.na, client).lastAgo }}</span>
                <span v-if="c1NaStats(client.na, client).avgGap" class="c1-na-sum-sep">·</span>
                <span v-if="c1NaStats(client.na, client).avgGap" class="c1-na-sum-item"><span class="c1-na-sum-lbl">Avg gap</span> {{ c1NaStats(client.na, client).avgGap }}</span>
                <span class="c1-na-sum-sep">·</span>
                <span class="c1-na-sum-item"><span class="c1-na-sum-lbl">By</span> {{ c1NaStats(client.na, client).agentNames.join(', ') }}</span>
              </div>
              <!-- History rows -->
              <div class="c1-na-history">
                <template v-for="(na, ni) in client.na">
                  <!-- Gap badge between entries (gap = time between this and the next older one) -->
                  <div v-if="ni > 0 && c1NaGapLabel(client.na, ni - 1)" :key="'gap-' + ni" class="c1-na-gap">
                    <span class="c1-na-gap-pill">{{ c1NaGapLabel(client.na, ni - 1) }}</span>
                  </div>
                  <div :key="'nah-' + na.id" class="c1-na-row">
                    <!-- Left: number + type -->
                    <div class="c1-na-row-left">
                      <span class="c1-na-num">#{{ client.na.length - ni }}</span>
                      <span class="c1-na-dot" :class="na.is_vm ? 'vm' : 'na'"></span>
                      <span class="c1-na-type">{{ na.is_vm ? 'Voicemail' : 'No Answer' }}</span>
                    </div>
                    <!-- Right: time info + agent -->
                    <div class="c1-na-row-right">
                      <div class="c1-na-times">
                        <span class="c1-na-dt c1-tf-mono">{{ fmtShort(na.created_at) }}</span>
                        <span v-if="c1NaTodAt(na.created_at, client)" class="c1-na-tod" :class="c1NaTodAt(na.created_at, client).cls">
                          {{ c1NaTodAt(na.created_at, client).icon }} {{ c1NaClientTimeAt(na.created_at, client) }} (client)
                        </span>
                      </div>
                      <span class="c1-na-by">{{ na.user ? (na.user.full_name || (na.user.first_name + ' ' + na.user.last_name)) : '—' }}</span>
                    </div>
                  </div>
                </template>
              </div>
              <!-- Actions -->
              <div class="c1-td-actions">
                <button class="c1-td-act c1-td-act-del" @click.stop="c1RemoveTag('na', client.id)">Remove last NA</button>
              </div>
            </div>
          </div>

          <!-- SC detail -->
          <div v-else-if="c1OpenTag.type === 'sc' && client.scheduled_calls[c1OpenTag.idx]" class="c1-td-wrap">
            <div class="c1-td-inner c1-tdi-sc">
              <div class="c1-td-time-hero" :class="client.scheduled_calls[c1OpenTag.idx].ended ? 'ended' : (client.scheduled_calls[c1OpenTag.idx].is_missed ? 'missed' : 'upcoming')">
                <div class="c1-td-time-val">{{ c1ScTimeLabel(client.scheduled_calls[c1OpenTag.idx]) }}</div>
                <div class="c1-td-time-sub">{{ client.scheduled_calls[c1OpenTag.idx].ended ? 'Ended' : (client.scheduled_calls[c1OpenTag.idx].is_missed ? 'Missed call' : 'Until call') }}</div>
              </div>
              <div class="c1-tf"><div class="c1-tf-l">Scheduled for</div><div class="c1-tf-v c1-tf-mono">{{ fmtShort(client.scheduled_calls[c1OpenTag.idx].scheduled_on || client.scheduled_calls[c1OpenTag.idx].call_at) }}</div></div>
              <template v-if="c1LocalTime(client.scheduled_calls[c1OpenTag.idx].scheduled_on || client.scheduled_calls[c1OpenTag.idx].call_at, client.country && client.country.zone_name)">
                <div class="c1-tf"><div class="c1-tf-l">Client time</div><div class="c1-tf-v c1-tf-mono">{{ c1LocalTime(client.scheduled_calls[c1OpenTag.idx].scheduled_on || client.scheduled_calls[c1OpenTag.idx].call_at, client.country && client.country.zone_name).time }} · {{ c1LocalTime(client.scheduled_calls[c1OpenTag.idx].scheduled_on || client.scheduled_calls[c1OpenTag.idx].call_at, client.country && client.country.zone_name).weekday }} {{ c1LocalTime(client.scheduled_calls[c1OpenTag.idx].scheduled_on || client.scheduled_calls[c1OpenTag.idx].call_at, client.country && client.country.zone_name).date }}</div></div>
                <div class="c1-tf"><div class="c1-tf-l">Part of day</div><div class="c1-tf-v">{{ c1LocalTime(client.scheduled_calls[c1OpenTag.idx].scheduled_on || client.scheduled_calls[c1OpenTag.idx].call_at, client.country && client.country.zone_name).icon }} {{ c1LocalTime(client.scheduled_calls[c1OpenTag.idx].scheduled_on || client.scheduled_calls[c1OpenTag.idx].call_at, client.country && client.country.zone_name).dayPart }} <span style="opacity:.5;font-size:10px">({{ c1LocalTime(client.scheduled_calls[c1OpenTag.idx].scheduled_on || client.scheduled_calls[c1OpenTag.idx].call_at, client.country && client.country.zone_name).tzLabel }})</span></div></div>
              </template>
              <div v-if="client.scheduled_calls[c1OpenTag.idx].priority" class="c1-tf"><div class="c1-tf-l">Priority</div><div class="c1-tf-v" :style="client.scheduled_calls[c1OpenTag.idx].priority_id === 1 ? 'color:var(--c1-na);font-weight:700' : ''">{{ client.scheduled_calls[c1OpenTag.idx].priority.name || '—' }}</div></div>
              <div v-if="client.scheduled_calls[c1OpenTag.idx].status" class="c1-tf"><div class="c1-tf-l">Status</div><div class="c1-tf-v">{{ client.scheduled_calls[c1OpenTag.idx].status.name || '—' }}</div></div>
              <div class="c1-tf"><div class="c1-tf-l">By</div><div class="c1-tf-v">{{ client.scheduled_calls[c1OpenTag.idx].user ? (client.scheduled_calls[c1OpenTag.idx].user.full_name || client.scheduled_calls[c1OpenTag.idx].user.first_name + ' ' + client.scheduled_calls[c1OpenTag.idx].user.last_name) : '—' }}</div></div>
              <div v-if="client.scheduled_calls[c1OpenTag.idx].comment" class="c1-tf c1-tf-col"><div class="c1-tf-l">Note</div><div class="c1-tf-v c1-tf-note">{{ client.scheduled_calls[c1OpenTag.idx].comment }}</div></div>
              <div v-if="c1ScEditOpen" class="c1-td-reschedule">
                <div class="c1-pkf-group">
                  <label class="c1-pkf-lbl">New date & time</label>
                  <input type="datetime-local" class="c1-pkf-input" v-model="c1PickerForm.sc.call_scheduled_on" />
                </div>
                <div class="c1-pkf-group">
                  <label class="c1-pkf-lbl">Comment</label>
                  <input type="text" class="c1-pkf-input" v-model="c1PickerForm.sc.comment" placeholder="Optional note..." />
                </div>
                <div class="c1-pkf-group">
                  <label class="c1-pkf-lbl">Priority</label>
                  <div class="c1-pkf-opts">
                    <button v-for="p in scPriorities" :key="p.id" class="c1-pkf-opt" :class="{on: c1PickerForm.sc.priority_id === p.id}" @click.stop="c1PickerForm.sc.priority_id = p.id">{{ p.title }}</button>
                  </div>
                </div>
                <div style="display:flex;gap:8px;margin-top:4px">
                  <button class="c1-pkf-submit c1-pkf-submit-sc" style="flex:1" @click.stop="c1RescheduleSC(client.id)" :disabled="!c1PickerForm.sc.call_scheduled_on">Reschedule</button>
                  <button class="c1-td-act" @click.stop="c1ScEditOpen = false" style="flex:0 0 auto;padding:0 12px">Cancel</button>
                </div>
              </div>
              <div v-else class="c1-td-actions">
                <button class="c1-td-act c1-td-act-sc" @click.stop="c1ScEditOpen = true">Reschedule</button>
                <button class="c1-td-act c1-td-act-del" @click.stop="c1RemoveTag('sc', client.id)">Remove SC</button>
              </div>
              <button class="c1-td-x" @click.stop="c1OpenTag = null; c1ScEditOpen = false"><svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>
            </div>
          </div>

          <!-- RF detail -->
          <div v-else-if="c1OpenTag.type === 'rf' && client.referrals[c1OpenTag.idx]" class="c1-td-wrap">
            <div class="c1-td-inner c1-tdi-rf">
              <div class="c1-tf"><div class="c1-tf-l">Date</div><div class="c1-tf-v c1-tf-mono">{{ fmtShort(client.referrals[c1OpenTag.idx].created_at) }}</div></div>
              <template v-if="c1LocalTime(client.referrals[c1OpenTag.idx].created_at, client.country && client.country.zone_name)">
                <div class="c1-tf"><div class="c1-tf-l">Client time</div><div class="c1-tf-v c1-tf-mono">{{ c1LocalTime(client.referrals[c1OpenTag.idx].created_at, client.country && client.country.zone_name).time }} · {{ c1LocalTime(client.referrals[c1OpenTag.idx].created_at, client.country && client.country.zone_name).weekday }} {{ c1LocalTime(client.referrals[c1OpenTag.idx].created_at, client.country && client.country.zone_name).date }}</div></div>
                <div class="c1-tf"><div class="c1-tf-l">Part of day</div><div class="c1-tf-v">{{ c1LocalTime(client.referrals[c1OpenTag.idx].created_at, client.country && client.country.zone_name).icon }} {{ c1LocalTime(client.referrals[c1OpenTag.idx].created_at, client.country && client.country.zone_name).dayPart }} <span style="opacity:.5;font-size:10px">({{ c1LocalTime(client.referrals[c1OpenTag.idx].created_at, client.country && client.country.zone_name).tzLabel }})</span></div></div>
              </template>
              <div class="c1-tf"><div class="c1-tf-l">Age</div><div class="c1-tf-v c1-tf-ago">{{ c1TimeAgo(client.referrals[c1OpenTag.idx].created_at) }}</div></div>
              <div class="c1-td-actions">
                <button class="c1-td-act c1-td-act-del" @click.stop="c1RemoveTag('referral', client.id)">Remove Referral</button>
              </div>
              <button class="c1-td-x" @click.stop="c1OpenTag = null"><svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>
            </div>
          </div>

        </template>

        <!-- ROW 2: contact accordion rows -->
        <div v-if="c1CardSelected === client.id || c1DetailMode" class="c1-box-r2">
          <!-- Phone row -->
          <div class="c1-cr" :class="{ 'c1-cr-active': c1Accordion.cid === client.id && c1Accordion.type === 'phone' }"
               @click.stop="c1ToggleAccordion(client.id, 'phone')">
            <div class="c1-cr-ic c1-cr-ic-ph">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
            </div>
            <div class="c1-cr-txt">
              <span v-if="client.phones && client.phones.length > 0" class="c1-mono">{{ client.phones[0].contact_value }}</span>
              <span v-else class="c1-cr-empty">No phone</span>
              <span v-if="client.phones && client.phones.length > 1" class="c1-cr-extra">+{{ client.phones.length - 1 }}</span>
            </div>
            <button class="c1-row-edit-btn" @click.stop="c1StartEdit(client.id, 'phone', client.phones && client.phones[0] ? client.phones[0].contact_value : '')">✏</button>
            <div class="c1-cr-chv" :class="{ open: c1Accordion.cid === client.id && c1Accordion.type === 'phone' }">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
            </div>
          </div>
          <!-- Phone inline edit -->
          <div v-if="c1ContactEdit[client.id + '-phone']" class="c1-row-edit-body" @click.stop>
            <input class="c1-ce-input c1-mono" type="text" :value="c1ContactEdit[client.id + '-phone'].val" @input="c1ContactEdit[client.id + '-phone'].val = $event.target.value" />
            <button class="c1-ce-save" @click.stop="c1SaveContact(client, 'phone')">Save</button>
            <button class="c1-ce-cancel" @click.stop="$delete(c1ContactEdit, client.id + '-phone')">✕</button>
            <span v-if="c1ContactEdit[client.id + '-phone'].prev" class="c1-ce-prev">was: {{ c1ContactEdit[client.id + '-phone'].prev }}</span>
          </div>
          <!-- Phone accordion -->
          <div v-if="c1Accordion.cid === client.id && c1Accordion.type === 'phone'" class="c1-acc">
            <a v-if="client.phones && client.phones.length > 0"
               class="c1-acc-btn c1-acc-call" :href="'tel:' + client.phones[0].contact_value" @click.stop>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              Call
            </a>
            <a v-if="client.phones && client.phones.length > 0"
               class="c1-acc-btn c1-acc-wa" :href="'https://wa.me/' + c1PhoneClean(client)" target="_blank" @click.stop>
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/></svg>
              WhatsApp
            </a>
            <div class="c1-acc-btn c1-acc-sms" @click.stop>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
              SMS
            </div>
          <!-- Call history with duration -->
          <div v-if="client.calls_log_latest && client.calls_log_latest.length" class="c1-call-log">
            <div class="c1-call-log-hdr">Recent Calls</div>
            <div v-for="(call, ci) in client.calls_log_latest.slice(0,6)" :key="'cl-'+ci" class="c1-call-log-row">
              <div class="c1-call-dot" :class="call.duration > 0 ? 'c1-call-answered' : 'c1-call-missed'"></div>
              <div class="c1-call-info">
                <span class="c1-call-date c1-mono">{{ fmtShort(call.created_at || call.updated_at) }}</span>
                <span v-if="call.duration && call.duration > 0" class="c1-call-dur">{{ Math.floor(call.duration/60) > 0 ? Math.floor(call.duration/60) + 'm ' : '' }}{{ call.duration % 60 }}s</span>
                <span v-else class="c1-call-dur-miss">No answer</span>
              </div>
              <span class="c1-call-ago">{{ c1TimeAgo(call.created_at || call.updated_at) }}</span>
            </div>
          </div>
          </div>

          <!-- Email row -->
          <div class="c1-cr" :class="{ 'c1-cr-active': c1Accordion.cid === client.id && c1Accordion.type === 'email' }"
               @click.stop="c1ToggleAccordion(client.id, 'email')">
            <div class="c1-cr-ic c1-cr-ic-em">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
            </div>
            <div class="c1-cr-txt">
              <span v-if="client.emails && client.emails.length > 0">{{ client.emails[0].contact_value }}</span>
              <span v-else class="c1-cr-empty">No email</span>
            </div>
            <button class="c1-row-edit-btn" @click.stop="c1StartEdit(client.id, 'email', client.emails && client.emails[0] ? client.emails[0].contact_value : '')">✏</button>
            <div class="c1-cr-chv" :class="{ open: c1Accordion.cid === client.id && c1Accordion.type === 'email' }">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
            </div>
          </div>
          <!-- Email inline edit -->
          <div v-if="c1ContactEdit[client.id + '-email']" class="c1-row-edit-body" @click.stop>
            <input class="c1-ce-input" type="text" :value="c1ContactEdit[client.id + '-email'].val" @input="c1ContactEdit[client.id + '-email'].val = $event.target.value" />
            <button class="c1-ce-save" @click.stop="c1SaveContact(client, 'email')">Save</button>
            <button class="c1-ce-cancel" @click.stop="$delete(c1ContactEdit, client.id + '-email')">✕</button>
            <span v-if="c1ContactEdit[client.id + '-email'].prev" class="c1-ce-prev">was: {{ c1ContactEdit[client.id + '-email'].prev }}</span>
          </div>
          <!-- Email system -->
          <div v-if="c1Accordion.cid === client.id && c1Accordion.type === 'email'" class="c1-email-panel">
            <!-- Tab bar -->
            <div class="c1-email-tabs">
              <div class="c1-email-tab" :class="{ on: (c1EmailTab[client.id] || 'compose') === 'compose' }" @click.stop="$set(c1EmailTab, client.id, 'compose')">✏️ Compose</div>
              <div class="c1-email-tab" :class="{ on: c1EmailTab[client.id] === 'inbox' }" @click.stop="$set(c1EmailTab, client.id, 'inbox')">📥 Inbox</div>
            </div>
            <!-- COMPOSE -->
            <div v-if="(c1EmailTab[client.id] || 'compose') === 'compose'" class="c1-email-compose">
              <div class="c1-email-field">
                <span class="c1-email-field-lbl">To</span>
                <span class="c1-email-field-val c1-mono">{{ client.emails && client.emails[0] ? client.emails[0].contact_value : '—' }}</span>
              </div>
              <div class="c1-email-field">
                <span class="c1-email-field-lbl">Subject</span>
                <input class="c1-email-input" type="text" :value="c1EmailDraft[client.id] && c1EmailDraft[client.id].subject" @input="c1EmailDraftSet(client.id, 'subject', $event.target.value)" placeholder="Subject..." @click.stop />
              </div>
              <textarea class="c1-email-body" rows="5"
                :value="c1EmailDraft[client.id] && c1EmailDraft[client.id].body"
                @input="c1EmailDraftSet(client.id, 'body', $event.target.value)"
                placeholder="Write your message here..."
                @click.stop></textarea>
              <!-- Attach + send row -->
              <div class="c1-email-actions">
                <label class="c1-email-attach" @click.stop>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:13px;height:13px"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>
                  Attach
                  <input type="file" multiple style="display:none" @change.stop="c1EmailAttach(client.id, $event)" />
                </label>
                <div v-if="c1EmailDraft[client.id] && c1EmailDraft[client.id].files && c1EmailDraft[client.id].files.length" class="c1-email-attach-list">
                  <span v-for="(f,fi) in c1EmailDraft[client.id].files" :key="'ef-'+fi" class="c1-email-attach-pill">
                    {{ f.name }}
                    <span @click.stop="c1EmailRemoveFile(client.id, fi)">✕</span>
                  </span>
                </div>
                <button class="c1-email-send" @click.stop="c1SendEmail(client)">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:12px;height:12px"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
                  Send
                </button>
              </div>
            </div>
            <!-- INBOX -->
            <div v-else class="c1-email-inbox">
              <div v-if="client.email_threads && client.email_threads.length">
                <div v-for="(thread, ti) in client.email_threads" :key="'et-'+ti" class="c1-email-thread-row">
                  <div class="c1-email-thread-from">{{ thread.from || thread.sender || 'Client' }}</div>
                  <div class="c1-email-thread-subject">{{ thread.subject || '(no subject)' }}</div>
                  <div class="c1-email-thread-preview">{{ (thread.body || '').slice(0, 80) }}</div>
                  <div class="c1-email-thread-meta">{{ c1TimeAgo(thread.created_at) }}</div>
                </div>
              </div>
              <div v-else class="c1-email-inbox-empty">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="width:28px;height:28px;color:var(--c1-t3)"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                <div style="font-size:11px;color:var(--c1-t3);margin-top:8px;">No emails yet</div>
                <div style="font-size:10px;color:var(--c1-t3);margin-top:3px;">Sent emails will appear here</div>
              </div>
            </div>
          </div>

          <!-- Viki Coach row -->
          <div class="c1-cr c1-cr-viki" :class="{ 'c1-cr-active': c1Accordion.cid === client.id && c1Accordion.type === 'viki' }"
               @click.stop="c1ToggleAccordion(client.id, 'viki')">
            <div class="c1-cr-ic c1-cr-ic-viki">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px"><path d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"/><path d="M12 8v4l3 3"/></svg>
            </div>
            <div class="c1-cr-txt">
              <span style="font-size:11px;color:var(--c1-t3)">Viki AI Coach</span>
              <span v-if="c1Accordion.cid !== client.id || c1Accordion.type !== 'viki'" class="c1-cr-viki-hint">readiness · budget · script</span>
            </div>
            <div class="c1-cr-chv" :class="{ open: c1Accordion.cid === client.id && c1Accordion.type === 'viki' }">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
            </div>
          </div>
          <!-- Viki Coach accordion -->
          <div v-if="c1Accordion.cid === client.id && c1Accordion.type === 'viki'">
            <viki-coach-card :client="client" @call-now="c1CallClient(client)" />
          </div>

          <!-- Game row — last -->
          <div class="c1-cr c1-cr-game" :class="{ 'c1-cr-active': c1Accordion.cid === client.id && c1Accordion.type === 'game' }"
               @click.stop="c1ToggleAccordion(client.id, 'game')">
            <div class="c1-cr-ic c1-cr-ic-game">
              <span style="font-size:14px;line-height:1">🐍</span>
            </div>
            <div class="c1-cr-txt">
              <span style="font-size:11px;color:var(--c1-t3)">Snake — play while on call</span>
            </div>
            <div class="c1-cr-chv" :class="{ open: c1Accordion.cid === client.id && c1Accordion.type === 'game' }">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
            </div>
          </div>
          <!-- Game accordion — inline -->
          <div v-if="c1Accordion.cid === client.id && c1Accordion.type === 'game'" class="c1-game-inline">
            <snake-in-nav :paused="false" />
          </div>
        </div>



      </div>

      <!-- Empty state -->
      <div v-if="clients.length === 0 && !$store.state.clients.loading" class="c1-empty">
        <div class="c1-empty-icon">
          <svg viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
        </div>
        <div class="c1-empty-msg">No clients found</div>
      </div>
    </div>

    <!-- Loading state -->
    <div v-else class="c1-loading">
      <div class="c1-spinner"></div>
      <div style="font-size:11px;color:#A09E98;margin-top:8px">Loading...</div>
    </div>



    <!-- FROZEN / PINNED CLIENTS STRIP -->
    <div class="c1-frozen-strip" v-if="frozenClients.length">
      <div class="c1-frozen-lbl">Pinned:</div>
      <div class="c1-frozen-item"
           v-for="client in frozenClients"
           :key="client.id"
           @click="c1CardSelected = client.id; c1CardExpanded = null">
        <span>{{ client.name }}</span>
        <button class="c1-frozen-x" @click.stop="unfreeze(client.id)">×</button>
      </div>
    </div>

    <!-- ADMIN: EXPORT XLS -->
    <div class="c1-xls-bar">
      <button class="c1-xls-bar-btn" :class="{ loading: c1ExportLoading }" @click.stop="c1ExportXLS()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px;flex-shrink:0"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="10" y1="13" x2="14" y2="17"/><line x1="14" y1="13" x2="10" y2="17"/></svg>
        Export to Excel
      </button>
    </div>

    <!-- KEYBOARD SHORTCUT BAR -->
    <div class="c1-kb-bar">
      <span class="c1-kb-hint">Alt+1=NA</span>
      <span class="c1-kb-sep">·</span>
      <span class="c1-kb-hint">Alt+2=SC</span>
      <span class="c1-kb-sep">·</span>
      <span class="c1-kb-hint">Alt+3=Ref</span>
      <span class="c1-kb-sep">·</span>
      <span class="c1-kb-hint">Alt+4=BN</span>
      <span class="c1-kb-sep">·</span>
      <span class="c1-kb-hint">Alt+5=NI</span>
    </div>

    <!-- RIGHT-CLICK CONTEXT MENU -->
    <div v-if="c1ContextMenu.show"
         class="c1-ctx-menu"
         :style="{ top: c1ContextMenu.y + 'px', left: c1ContextMenu.x + 'px' }"
         @mouseleave="c1ContextMenu.show = false">
      <div class="c1-ctx-item" @click="c1PinFromContext()">Pin to top</div>
      <div class="c1-ctx-item" @click="c1CopyFromContext('name')">Copy name</div>
      <div class="c1-ctx-item" @click="c1CopyFromContext('id')">Copy client ID</div>
    </div>

    <!-- ASSIGN / BULK BACKDROP -->
    <div v-if="c1AssignSlide.open || (c1SelectedClients.length > 0 && c1CanAssign)" class="c1-assign-backdrop" @click.stop="c1CloseAssignSlide(); c1ClearSelection()"></div>

    <!-- ASSIGN PANEL — right-side sliding drawer, for single client reassign -->
    <div class="c1-viki-popup c1-assign-popup" :class="{ show: c1AssignSlide.open }">
      <div class="c1-vp-hdr">
        <div class="c1-vp-av" style="background:none;box-shadow:none;padding:0">
          <viki-face mood="info" :size="42"/>
        </div>
        <div class="c1-vp-info">
          <div class="c1-vp-name">Reassign</div>
          <div v-if="c1AssignSlideClient" class="c1-vp-sub">{{ c1AssignSlideClient.first_name }} {{ c1AssignSlideClient.last_name }} · #{{ c1AssignSlideClient.id }}</div>
        </div>
        <button class="c1-vp-close" @click.stop="c1CloseAssignSlide()">
          <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>
      <!-- Current agent -->
      <div v-if="c1AssignSlideClient && c1AssignSlideClient.assignment" class="c1-ap-current">
        <span class="c1-ap-lbl">Currently → </span>
        <div class="c1-ag-av" style="width:18px;height:18px;font-size:8px;border-radius:4px;display:inline-flex;align-items:center;justify-content:center;background:var(--c1-dp);color:#fff;font-weight:700;vertical-align:middle;margin:0 4px">{{ agentInitials(c1AssignSlideClient) }}</div>
        <span class="c1-ap-agent-name">{{ clientAgentName(c1AssignSlideClient) }}</span>
        <span v-if="c1AssignSlideClient.assignment.created_at" class="c1-ap-ago">{{ c1TimeAgo(c1AssignSlideClient.assignment.created_at) }}</span>
      </div>
      <!-- Search -->
      <div class="c1-ap-search-row">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:13px;height:13px;flex-shrink:0;stroke:var(--c1-t3)"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        <input class="c1-ap-search" type="search" v-model="c1AssignSearch" placeholder="Search agent…" @click.stop />
      </div>
      <!-- Viopa top suggestions -->
      <div class="c1-bulk-viopa" style="border-top:1px solid var(--c1-bdr)">
        <div class="c1-bulk-viopa-hdr">
          <span class="c1-bulk-viopa-title">Viopa · Best Match</span>
          <span v-if="c1ViopaLoadingAssign" class="c1-bulk-viopa-loading">
            <div class="c1-spinner" style="width:10px;height:10px;border-width:2px"></div> scoring…
          </span>
          <span v-else-if="c1SlideProfile" class="c1-bulk-viopa-profile">{{ c1SlideProfile.country || '' }} · exact</span>
        </div>
        <div v-if="!c1ViopaLoadingAssign && c1AssignSlideSuggestions().length" class="c1-bulk-viopa-cards">
          <div v-for="(agent, idx) in c1AssignSlideSuggestions()" :key="agent.id"
               class="c1-bulk-viopa-card"
               @click.stop="c1AssignFromSlide(agent)">
            <div class="c1-bvc-rank">{{ idx + 1 }}</div>
            <div class="c1-bvc-top">
              <div class="c1-bvc-av">{{ (agent.full_name || agent.name || '?')[0].toUpperCase() }}</div>
              <span class="c1-bvc-score">{{ c1ViopaScores[agent.id] ? c1ViopaScores[agent.id].score : '' }}</span>
            </div>
            <div class="c1-bvc-name">
              <span v-if="c1ViopaScores[agent.id] && c1ViopaScores[agent.id].is_golden_buzzer">⭐ </span>{{ agent.full_name || agent.name }}
            </div>
            <div class="c1-bvc-chips">
              <span v-for="chip in c1ViopaReasonChips(agent.id).slice(0,3)" :key="chip.text"
                    class="c1-bvc-chip" :class="'c1-bvc-chip-' + chip.style">{{ chip.icon }} {{ chip.text }}</span>
              <span v-if="!c1ViopaReasonChips(agent.id).length" class="c1-bvc-chip c1-bvc-chip-grey">Top overall</span>
            </div>
          </div>
        </div>
        <div v-else-if="!c1ViopaLoadingAssign && c1SlideProfile && !c1AssignSlideSuggestions().length" class="c1-bulk-viopa-empty">
          No strong match — pick manually below
        </div>
      </div>

      <!-- Agent list -->
      <div class="c1-ap-list">
        <div v-if="c1AssignSlide.loading" style="display:flex;justify-content:center;padding:16px"><div class="c1-spinner"></div></div>
        <div v-if="!c1AssignSlide.loading && c1ViopaLoadingAssign" class="c1-ap-viopa-loading">
          <div class="c1-spinner" style="width:12px;height:12px;border-width:2px"></div>
          <span>Viopa scoring…</span>
        </div>
        <div v-for="agent in c1FilteredAgents" :key="agent.id"
             class="c1-ap-row"
             :class="{
               'c1-ap-row-avoid': c1ViopaAvoidIds.includes(agent.id),
               'c1-ap-row-golden': c1ViopaScores[agent.id] && c1ViopaScores[agent.id].is_golden_buzzer,
               'c1-ap-row-offline': c1ViopaScores[agent.id] && ['OFF','OFF_SHIFT','BLOCKED'].includes(c1ViopaScores[agent.id].availability)
             }"
             @click.stop="c1AssignFromSlide(agent)">
          <div class="c1-ap-av">{{ (agent.full_name || agent.name || '?')[0].toUpperCase() }}</div>
          <div class="c1-ap-info">
            <span class="c1-ap-name">
              <span v-if="c1ViopaScores[agent.id] && c1ViopaScores[agent.id].is_golden_buzzer" class="c1-ap-gb">⭐</span>
              {{ agent.full_name || agent.name }}
              <span v-if="c1ViopaAvoidIds.includes(agent.id)" class="c1-ap-warn">⚠️</span>
            </span>
            <span class="c1-ap-cnt">{{ agent.client_assignments_count || 0 }}</span>
          </div>
          <span v-if="c1ViopaScores[agent.id] && c1ViopaScores[agent.id].availability"
                class="c1-ap-avail"
                :class="{
                  'c1-ap-avail-active':   c1ViopaScores[agent.id].availability === 'ACTIVE',
                  'c1-ap-avail-away':     c1ViopaScores[agent.id].availability === 'AWAY',
                  'c1-ap-avail-busy':     c1ViopaScores[agent.id].availability === 'BUSY_SOON',
                  'c1-ap-avail-off':      ['OFF','OFF_SHIFT','BLOCKED'].includes(c1ViopaScores[agent.id].availability),
                }"
                :title="c1ViopaScores[agent.id].availability_reason">
            {{ c1ViopaScores[agent.id].availability === 'ACTIVE' ? '●' :
               c1ViopaScores[agent.id].availability === 'AWAY' ? '◐' :
               c1ViopaScores[agent.id].availability === 'BUSY_SOON' ? '◑' : '○' }}
          </span>
          <span v-if="c1ViopaScores[agent.id]" class="c1-ap-score"
                :class="c1ViopaAvoidIds.includes(agent.id) ? 'c1-ap-score-bad' : 'c1-ap-score-good'">
            {{ c1ViopaScores[agent.id].score }}
          </span>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="width:12px;height:12px;stroke:var(--c1-t3);flex-shrink:0"><polyline points="9 18 15 12 9 6"/></svg>
        </div>
        <div v-if="!c1FilteredAgents.length" style="text-align:center;padding:16px;font-size:11px;color:var(--c1-t3)">No agents found</div>
      </div>
    </div>

    <!-- BULK POPUP — Viki-styled, bottom-right, for bulk assignment -->
    <div class="c1-viki-popup c1-bulk-popup" :class="{ show: c1SelectedClients.length > 0 && c1CanAssign }">
      <div class="c1-vp-hdr">
        <div class="c1-vp-av" style="background:linear-gradient(135deg,var(--c1-dp),#a78bfa)">
          <span style="color:#fff;font-weight:800;font-size:13px;font-family:'Plus Jakarta Sans',sans-serif">{{ c1SelectedClients.length }}</span>
        </div>
        <div class="c1-vp-info">
          <div class="c1-vp-name" style="color:var(--c1-dp)">Bulk Assign</div>
          <div class="c1-vp-sub">{{ c1SelectedClients.length }} client{{ c1SelectedClients.length !== 1 ? 's' : '' }} selected</div>
        </div>
        <button class="c1-vp-close" @click.stop="c1ClearSelection()">
          <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>
      <!-- Name chips -->
      <div class="c1-ap-chips">
        <div v-for="cid in c1SelectedClients.slice(0,5)" :key="cid" class="c1-ap-chip">
          {{ c1ClientNameById(cid) }}<button @click.stop="c1ToggleSelect(cid)">×</button>
        </div>
        <div v-if="c1SelectedClients.length > 5" class="c1-ap-chip c1-ap-chip-more">+{{ c1SelectedClients.length - 5 }}</div>
      </div>
      <!-- Select all -->
      <div class="c1-ap-sel-row">
        <button class="c1-ap-sel-all" @click.stop="c1SelectAll()">Select all ({{ (clients||[]).length }})</button>
      </div>
      <!-- AI Suggestions strip -->
      <div class="c1-bulk-viopa">
        <!-- Smart Auto-Assign progress bar -->
        <div v-if="c1SmartAssignRunning && c1SmartAssignProgress" class="c1-sa-progress">
          <div class="c1-sa-progress-bar">
            <div class="c1-sa-progress-fill"
                 :style="{ width: Math.round((c1SmartAssignProgress.done / c1SmartAssignProgress.total) * 100) + '%' }"></div>
          </div>
          <span class="c1-sa-progress-lbl">
            ⚡ Assigning {{ c1SmartAssignProgress.done }} / {{ c1SmartAssignProgress.total }}…
          </span>
        </div>

        <div v-else class="c1-bulk-viopa-hdr">
          <span class="c1-bulk-viopa-title">Viopa · Power Score</span>
          <span v-if="c1BulkViopaLoading" class="c1-bulk-viopa-loading">
            <div class="c1-spinner" style="width:10px;height:10px;border-width:2px"></div> scoring…
          </span>
          <span v-else-if="c1BulkViopaProfile" class="c1-bulk-viopa-profile">
            {{ c1BulkViopaProfile.country }}{{ c1SelectedClients.length > 1 ? ' · first client' : ' · exact' }}
          </span>
          <!-- Smart Auto-Assign button -->
          <button class="c1-sa-btn" @click.stop="c1SmartAutoAssign()" :disabled="c1BulkViopaLoading">
            ⚡ Auto-Assign All
          </button>
        </div>
        <div v-if="!c1BulkViopaLoading && c1BulkViopaSuggestions().length" class="c1-bulk-viopa-cards">
          <div v-for="(agent, idx) in c1BulkViopaSuggestions()" :key="agent.id"
               class="c1-bulk-viopa-card"
               @click.stop="c1BulkAssign(agent)">
            <div class="c1-bvc-rank">{{ idx + 1 }}</div>
            <div class="c1-bvc-top">
              <div class="c1-bvc-av">{{ (agent.full_name || agent.name || '?')[0].toUpperCase() }}</div>
              <span class="c1-bvc-score">{{ c1BulkViopaScores[agent.id] ? c1BulkViopaScores[agent.id].score : '' }}</span>
            </div>
            <div class="c1-bvc-name">
              <span v-if="c1BulkViopaScores[agent.id] && c1BulkViopaScores[agent.id].is_golden_buzzer">⭐ </span>{{ agent.full_name || agent.name }}
            </div>
            <div class="c1-bvc-chips">
              <span v-for="chip in c1ViopaReasonChips(agent.id).slice(0,3)" :key="chip.text"
                    class="c1-bvc-chip"
                    :class="'c1-bvc-chip-' + chip.style">{{ chip.icon }} {{ chip.text }}</span>
              <span v-if="!c1ViopaReasonChips(agent.id).length" class="c1-bvc-chip c1-bvc-chip-grey">Top overall</span>
            </div>
          </div>
        </div>
        <div v-else-if="!c1BulkViopaLoading && !c1BulkViopaSuggestions().length && c1BulkViopaProfile" class="c1-bulk-viopa-empty">
          No strong match found — pick manually below
        </div>
      </div>

      <!-- Scrollable body: search + agent list -->
      <div class="c1-bulk-scroll-body">
        <div class="c1-ap-search-row">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:13px;height:13px;flex-shrink:0;stroke:var(--c1-t3)"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          <input class="c1-ap-search" v-model="c1BulkSearch" placeholder="Search agent…" @click.stop />
        </div>
        <div class="c1-ap-list">
          <div v-for="agent in c1FilteredBulkAgents" :key="agent.id"
               class="c1-ap-row"
               :class="{ 'c1-ap-row-avoid': c1BulkViopaAvoidIds.includes(agent.id), 'c1-ap-row-golden': c1BulkViopaScores[agent.id] && c1BulkViopaScores[agent.id].is_golden_buzzer }"
               @click.stop="c1BulkAssign(agent)">
            <div class="c1-ap-av" style="background:linear-gradient(135deg,var(--c1-dp),#a78bfa)">{{ (agent.full_name || agent.name || '?')[0].toUpperCase() }}</div>
            <div class="c1-ap-info">
              <span class="c1-ap-name">
                <span v-if="c1BulkViopaScores[agent.id] && c1BulkViopaScores[agent.id].is_golden_buzzer" class="c1-ap-gb">⭐</span>
                {{ agent.full_name || agent.name }}
                <span v-if="c1BulkViopaAvoidIds.includes(agent.id)" class="c1-ap-warn">⚠️</span>
              </span>
              <span class="c1-ap-cnt">{{ agent.client_assignments_count || 0 }}</span>
            </div>
            <span v-if="c1BulkViopaScores[agent.id]" class="c1-ap-score"
                  :class="c1BulkViopaAvoidIds.includes(agent.id) ? 'c1-ap-score-bad' : 'c1-ap-score-good'">
              {{ c1BulkViopaScores[agent.id].score }}
            </span>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="width:12px;height:12px;stroke:var(--c1-t3);flex-shrink:0"><polyline points="9 18 15 12 9 6"/></svg>
          </div>
          <div v-if="!c1FilteredBulkAgents.length" style="text-align:center;padding:16px;font-size:11px;color:var(--c1-t3)">No agents found</div>
        </div>
      </div>
    </div>



  <!-- RIGHT DRAWER — client detail panel -->
  <transition name="c1-drawer">
    <div v-if="c1CardExpanded !== null && c1DrawerClient" class="c1-drawer-wrap" @click.self="c1CardExpanded = null">
      <div class="c1-drawer">
        <!-- Drawer header -->
        <div class="c1-drawer-head">
          <div class="c1-drawer-av" :style="{ background: clientAvatarColor(c1DrawerClient) }">{{ clientInitials(c1DrawerClient) }}</div>
          <div class="c1-drawer-title">
            <div class="c1-drawer-name">{{ c1DrawerClient.first_name }} {{ c1DrawerClient.last_name }}</div>
            <div class="c1-drawer-sub">#{{ c1DrawerClient.id }}{{ c1DrawerClient.country ? ' · ' + clientCountryName(c1DrawerClient) : '' }}</div>
          </div>
          <button class="c1-drawer-close" @click="c1CardExpanded = null">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>

        <!-- Drawer scrollable body -->
        <div class="c1-drawer-body">

          <!-- CLIENT INFO -->
          <div class="c1-exp-sec">
            <div class="c1-exp-lbl">Client Info</div>
            <div class="c1-exp-grid">
              <div v-if="c1DrawerClient.assignment && c1DrawerClient.assignment.assigned_to" class="c1-exp-field c1-exp-full">
                <div class="c1-exp-fl">Assigned To</div>
                <div class="c1-exp-fv" style="font-weight:600">{{ c1DrawerClient.assignment.assigned_to.full_name || '—' }}</div>
              </div>
              <div v-if="c1DrawerClient.country" class="c1-exp-field">
                <div class="c1-exp-fl">Country</div>
                <div class="c1-exp-fv">{{ clientCountryName(c1DrawerClient) }}</div>
              </div>
              <div v-if="c1DrawerClient.location" class="c1-exp-field">
                <div class="c1-exp-fl">City</div>
                <div class="c1-exp-fv">{{ c1DrawerClient.location }}</div>
              </div>
              <div v-if="c1DrawerClient.language" class="c1-exp-field">
                <div class="c1-exp-fl">Language</div>
                <div class="c1-exp-fv">{{ c1DrawerClient.language.name }}</div>
              </div>
              <div v-if="c1DrawerClient.registered_on" class="c1-exp-field">
                <div class="c1-exp-fl">Registered</div>
                <div class="c1-exp-fv c1-mono">{{ fmtShort(c1DrawerClient.registered_on) }}</div>
              </div>
              <div v-if="c1DrawerClient.last_online" class="c1-exp-field">
                <div class="c1-exp-fl">Last Online</div>
                <div class="c1-exp-fv c1-mono">{{ fmtShort(c1DrawerClient.last_online) }}</div>
              </div>
              <div v-if="c1DrawerClient.device" class="c1-exp-field">
                <div class="c1-exp-fl">Device</div>
                <div class="c1-exp-fv">{{ c1DrawerClient.device }}</div>
              </div>
              <div v-if="c1DrawerClient.last_ip" class="c1-exp-field c1-exp-full">
                <div class="c1-exp-fl">Last IP</div>
                <div class="c1-exp-fv c1-mono" style="font-size:10px">{{ c1DrawerClient.last_ip }}</div>
              </div>
              <div v-if="c1DrawerClient.is_duplicate" class="c1-exp-field">
                <div class="c1-exp-fl">Flag</div>
                <div class="c1-exp-fv"><span class="c1-exp-badge">Duplicate</span></div>
              </div>
              <div v-if="c1DrawerClient.is_repopulated" class="c1-exp-field">
                <div class="c1-exp-fl">Flag</div>
                <div class="c1-exp-fv"><span class="c1-exp-badge">Repopulated</span></div>
              </div>
              <div v-if="c1DrawerClient.not_interested_state_id && niStates.length" class="c1-exp-field c1-exp-full">
                <div class="c1-exp-fl">NI Reason</div>
                <div class="c1-exp-fv" style="color:#7A6000">{{ (niStates.find(s => s.id === c1DrawerClient.not_interested_state_id) || {}).name || '—' }}</div>
              </div>
              <div v-if="c1DrawerClient.bad_number_state_id && bnStates.length" class="c1-exp-field c1-exp-full">
                <div class="c1-exp-fl">BN Reason</div>
                <div class="c1-exp-fv" style="color:var(--c1-bn)">{{ c1BnLabel(bnStates.find(s => s.id === c1DrawerClient.bad_number_state_id) || {}) }}</div>
              </div>
            </div>
          </div>

          <!-- CAMPAIGN -->
          <div v-if="c1DrawerClient.keyword || c1DrawerClient.campaign_aaid || c1DrawerClient.placement || c1DrawerClient.lead_loc" class="c1-exp-sec">
            <div class="c1-exp-lbl">Campaign</div>
            <div class="c1-exp-grid">
              <div v-if="c1DrawerClient.keyword" class="c1-exp-field c1-exp-full">
                <div class="c1-exp-fl">Source</div>
                <div class="c1-exp-fv" style="font-weight:500">{{ c1DrawerClient.keyword }}</div>
              </div>
              <div v-if="c1DrawerClient.lead_loc" class="c1-exp-field">
                <div class="c1-exp-fl">Location</div>
                <div class="c1-exp-fv">{{ c1DrawerClient.lead_loc }}</div>
              </div>
              <div v-if="c1DrawerClient.placement" class="c1-exp-field">
                <div class="c1-exp-fl">Placement</div>
                <div class="c1-exp-fv">{{ c1DrawerClient.placement }}</div>
              </div>
              <div v-if="c1DrawerClient.cost_per_lead" class="c1-exp-field">
                <div class="c1-exp-fl">Cost/Lead</div>
                <div class="c1-exp-fv" style="color:var(--c1-dp);font-weight:700">{{ c1DrawerClient.cost_per_lead }}</div>
              </div>
              <div v-if="c1DrawerClient.campaign_aaid" class="c1-exp-field c1-exp-full">
                <div class="c1-exp-fl">AA ID</div>
                <div class="c1-exp-fv c1-mono" style="font-size:10px;word-break:break-all">{{ c1DrawerClient.campaign_aaid }}</div>
              </div>
              <div v-if="c1DrawerClient.campaign_abid" class="c1-exp-field c1-exp-full">
                <div class="c1-exp-fl">AB ID</div>
                <div class="c1-exp-fv c1-mono" style="font-size:10px;word-break:break-all">{{ c1DrawerClient.campaign_abid }}</div>
              </div>
            </div>
          </div>

          <!-- ALL DEPOSITS -->
          <div v-if="c1DrawerClient.deposits && c1DrawerClient.deposits.length" class="c1-exp-sec">
            <div class="c1-exp-lbl">All Deposits ({{ c1DrawerClient.deposits.length }})</div>
            <div v-for="dep in c1DrawerClient.deposits" :key="'edep-'+dep.id" class="c1-exp-activity-row">
              <div class="c1-exp-a-badge" style="background:#F0ECFF;color:var(--c1-dp)">DP</div>
              <div class="c1-exp-a-body">
                <span style="font-weight:600">{{ dep.amount || '—' }}</span>
                <span class="c1-exp-a-meta">{{ dep.payment_method || '' }}</span>
              </div>
              <div class="c1-exp-a-date c1-mono">{{ fmtShort(dep.created_at) }}</div>
            </div>
          </div>

          <!-- ALL SCHEDULED CALLS -->
          <div v-if="c1DrawerClient.scheduled_calls && c1DrawerClient.scheduled_calls.length" class="c1-exp-sec">
            <div class="c1-exp-lbl">Scheduled Calls ({{ c1DrawerClient.scheduled_calls.length }})</div>
            <div v-for="sc in c1DrawerClient.scheduled_calls" :key="'esc-'+sc.id" class="c1-exp-activity-row">
              <div class="c1-exp-a-badge" :style="sc.ended ? 'background:#F2F1F0;color:var(--c1-t3)' : (sc.is_missed ? 'background:#FFF2EE;color:var(--c1-na)' : 'background:#FFF4E8;color:var(--c1-sc)')">SC</div>
              <div class="c1-exp-a-body">
                <span class="c1-mono">{{ fmtShort(sc.scheduled_on || sc.call_at) }}</span>
                <span class="c1-exp-a-meta">{{ sc.ended ? 'Ended' : (sc.is_missed ? 'Missed' : 'Upcoming') }}{{ sc.status ? ' · ' + sc.status.name : '' }}</span>
              </div>
            </div>
          </div>

          <!-- TRANSFERS -->
          <div v-if="c1DrawerClient.transfers && c1DrawerClient.transfers.length" class="c1-exp-sec">
            <div class="c1-exp-lbl">Transfers ({{ c1DrawerClient.transfers.length }})</div>
            <div v-for="tr in c1DrawerClient.transfers" :key="'etr-'+tr.id" class="c1-exp-activity-row">
              <div class="c1-exp-a-badge" style="background:#F5F3E8;color:#6B5A00">TR</div>
              <div class="c1-exp-a-body">
                <span class="c1-mono">{{ fmtShort(tr.created_at) }}</span>
              </div>
            </div>
          </div>

          <!-- ALL PHONES & EMAILS -->
          <div v-if="(c1DrawerClient.phones && c1DrawerClient.phones.length) || (c1DrawerClient.emails && c1DrawerClient.emails.length)" class="c1-exp-sec">
            <div class="c1-exp-lbl">All Contacts</div>
            <div class="c1-exp-grid">
              <div v-for="ph in c1DrawerClient.phones" :key="'eph-'+ph.id" class="c1-exp-field c1-exp-full">
                <div class="c1-exp-fl">Phone</div>
                <div class="c1-exp-fv c1-mono">{{ ph.contact_value }}</div>
              </div>
              <div v-for="em in c1DrawerClient.emails" :key="'eem-'+em.id" class="c1-exp-field c1-exp-full">
                <div class="c1-exp-fl">Email</div>
                <div class="c1-exp-fv" style="font-size:10px;word-break:break-all">{{ em.contact_value }}</div>
              </div>
            </div>
          </div>

          <!-- FULL ACTIVITY TIMELINE -->
          <div class="c1-exp-sec">
            <div class="c1-exp-lbl">Activity Timeline</div>
            <div class="c1-timeline">
              <div
                v-for="(ev, idx) in c1DrawerTimeline"
                :key="'tl-' + idx"
                class="c1-tl-row"
              >
                <!-- connector line -->
                <div class="c1-tl-left">
                  <div class="c1-tl-dot" :style="{ background: ev.color }"></div>
                  <div v-if="idx < c1DrawerTimeline.length - 1" class="c1-tl-line"></div>
                </div>
                <div class="c1-tl-body">
                  <div class="c1-tl-hdr">
                    <span class="c1-tl-badge" :style="{ background: ev.color + '22', color: ev.color }">{{ ev.badge }}</span>
                    <span class="c1-tl-title">{{ ev.title }}</span>
                  </div>
                  <div v-if="ev.sub" class="c1-tl-sub">{{ ev.sub }}</div>
                  <div class="c1-tl-date c1-mono">{{ ev.date }}</div>
                </div>
              </div>
              <div v-if="!c1DrawerTimeline.length" class="c1-tl-empty">No activity recorded yet</div>
            </div>
          </div>

          <!-- ---- FEATURE: Call Log in Drawer ---- -->
          <div class="c1-exp-sec">
            <div class="c1-exp-lbl c1-exp-lbl-tog" @click="c1DrawerCallsOpen = !c1DrawerCallsOpen">
              Call Log <svg :style="c1DrawerCallsOpen ? 'transform:rotate(90deg)' : ''" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px;margin-left:4px;transition:transform .2s"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div v-if="c1DrawerCallsOpen">
              <div v-if="c1DrawerCallStatus" class="c1-call-status-badge" :class="c1DrawerCallStatus === 'IN_CALL' ? 'active' : 'idle'">
                {{ c1DrawerCallStatus === 'IN_CALL' ? '🟢 Currently in call' : '⚪ Not in call' }}
              </div>
              <div v-if="!c1DrawerCallLog || !c1DrawerCallLog.length" class="c1-exp-empty">No call records</div>
              <div v-for="cl in (c1DrawerCallLog || []).slice(0,10)" :key="cl.id" class="c1-exp-activity-row">
                <div class="c1-exp-av">📞</div>
                <div class="c1-exp-info">
                  <div class="c1-exp-name">{{ cl.status || cl.result || 'Call' }}</div>
                  <div class="c1-exp-sub">{{ cl.created_at ? cl.created_at.slice(0,16).replace('T',' ') : '' }} {{ cl.agent_name || '' }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- ---- FEATURE: Survey / Questions in Drawer ---- -->
          <div class="c1-exp-sec">
            <div class="c1-exp-lbl c1-exp-lbl-tog" @click="c1DrawerSurveyOpen = !c1DrawerSurveyOpen">
              Survey Answers
              <span v-if="c1DrawerClient && c1DrawerClient.questions_status > 0" class="c1-badge-dot" style="background:#00b67a;width:8px;height:8px;border-radius:50%;display:inline-block;margin-left:6px"></span>
              <svg :style="c1DrawerSurveyOpen ? 'transform:rotate(90deg)' : ''" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px;margin-left:4px;transition:transform .2s"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div v-if="c1DrawerSurveyOpen">
              <div v-if="c1DrawerSurveyLoading" class="c1-exp-empty">Loading...</div>
              <div v-else-if="!c1DrawerSurvey || (Array.isArray(c1DrawerSurvey) && c1DrawerSurvey.length === 0)" class="c1-exp-empty">No survey answers recorded</div>
              <div v-else>
                <div v-for="(q, i) in (Array.isArray(c1DrawerSurvey) ? c1DrawerSurvey : [c1DrawerSurvey])" :key="i" class="c1-survey-row">
                  <div class="c1-survey-q">{{ q.question || q.label || q.name || ('Q' + (i+1)) }}</div>
                  <div class="c1-survey-a" :style="(!q.answer && !q.value) ? 'color:#f59e0b' : ''">
                    {{ q.answer || q.value || '— unanswered' }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ---- FEATURE: CMS Platform Actions (Admin only) ---- -->
          <div v-if="!CheckUserPermission([1])" class="c1-exp-sec">
            <div class="c1-exp-lbl c1-exp-lbl-tog" @click="c1DrawerCmsOpen = !c1DrawerCmsOpen">
              Platform Actions <svg :style="c1DrawerCmsOpen ? 'transform:rotate(90deg)' : ''" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px;margin-left:4px;transition:transform .2s"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div v-if="c1DrawerCmsOpen" style="padding: 8px 0; display: flex; flex-direction: column; gap: 8px;">
              <button class="c1-cms-btn" @click="c1ResetPlatformPassword(c1DrawerClient)" :disabled="c1CmsLoading">
                🔑 Reset Platform Password
              </button>
              <div style="display: flex; gap: 6px; align-items: center;">
                <select class="c1-cms-select" v-model="c1CmsPlan">
                  <option value="">Select plan...</option>
                  <option value="standard">Standard</option>
                  <option value="premium">Premium</option>
                  <option value="vip">VIP</option>
                  <option value="demo">Demo</option>
                </select>
                <button class="c1-cms-btn" @click="c1ChangePlatformPlan(c1DrawerClient)" :disabled="!c1CmsPlan || c1CmsLoading">
                  Change Plan
                </button>
              </div>
              <div v-if="c1CmsMsg" class="c1-cms-msg" :class="c1CmsMsg.ok ? 'ok' : 'err'">{{ c1CmsMsg.text }}</div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </transition>

  <!-- ---- FEATURE: SMS Quick-Send Modal ---- -->
  <div v-if="c1SmsModal" class="c1-modal-overlay" @click.self="c1SmsModal = null">
    <div class="c1-modal-box">
      <div class="c1-modal-hdr">
        <span>SMS to {{ c1SmsModal.full_name || (c1SmsModal.first_name + ' ' + c1SmsModal.last_name) }}</span>
        <span class="c1-nav-x-btn" @click="c1SmsModal = null">✕</span>
      </div>
      <div class="c1-modal-body">
        <textarea class="c1-sms-textarea" v-model="c1SmsText" placeholder="Type SMS message..." rows="4" maxlength="160"></textarea>
        <div class="c1-sms-counter">{{ c1SmsText.length }}/160</div>
        <div class="c1-sms-presets">
          <span class="c1-sms-preset" @click="c1SmsText = 'Hi, this is your account manager. Please call us back at your earliest convenience.'">Call back</span>
          <span class="c1-sms-preset" @click="c1SmsText = 'Your account is ready. Login now to start trading.'">Account ready</span>
          <span class="c1-sms-preset" @click="c1SmsText = 'Special offer available for you today. Contact us now.'">Special offer</span>
        </div>
      </div>
      <div class="c1-modal-ftr">
        <button class="c1-btn c1-btn-ghost" @click="c1SmsModal = null">Cancel</button>
        <button class="c1-btn c1-btn-primary" :disabled="!c1SmsText.trim() || c1SmsSending" @click="c1SendSms()">
          {{ c1SmsSending ? 'Sending...' : 'Send SMS' }}
        </button>
      </div>
    </div>
  </div>

  </div>
</template>

<script>
import ClientsTableContainer from "../../company.feature/sub_features.company/clients_table.sub_feature.company/containers/ClientsTableContainer.vue";
import C1SmartCalendar from "../C1SmartCalendar.vue";
import VikiFace from "../VikiFace.vue";
import GraphContainer from "../../company.feature/sub_features.company/graph.sub-feature.company/containers/Graph.container";
import apiClientCreator from "../../../helpers/api/request";
import SnakeMini from '../../games.feature/snake.game/components/SnakeGame.component.vue';
import SnakeInNav from '../SnakeInNav.vue';
import VikiCoachCard from '../VikiCoachCard.vue';
import moment from "moment/moment";
import _ from "lodash";

export default {
  name: "Clients1Container",
  extends: ClientsTableContainer,
  components: { C1SmartCalendar, VikiFace, GraphContainer, 'snake-mini': SnakeMini, 'snake-in-nav': SnakeInNav, VikiCoachCard },

  beforeMount() {
    // Always load activity dictionary (deposit methods, statuses, etc.)
    this.$store.dispatch("clients/getActivityDictionary");
    // Load general + salesPersonList only if not yet loaded
    if (!this.$store.state.clients.salesPersonList || !this.$store.state.clients.salesPersonList.length) {
      this.$store.dispatch("clients/getGeneralDictionary").then(() => {
        this.$store.dispatch("clients/getSalesPersonList");
      });
    }
  },

  data() {
    return {
      c1ShiftModal: false,
      c1Status: 'shift',
      c1StatusSince: 0,
      c1StatusElapsed: '00:00',
      c1StatusMenuOpen: false,
      c1ShiftMenuOpen: false,
      c1ClockOpen: false,
      c1CalendarOpen: typeof window !== 'undefined' && window.innerWidth > 767,
      c1InlineAssignCid: null,
      c1InlineAssignSearch: '',
      c1CountrySearch: '',
      c1CountryOpen: false,
      c1StatusTab: 'status', // 'status' | 'clock'
      _c1StatusInterval: null,
      c1ShiftStartTime: 0,
      c1ShiftElapsed: '00:00',
      c1BathroomCount: 0,
      c1CoffeeCount: 0,
      c1WeekLog: [], // [{date,workedMin,bathroom,coffee}]
      gnmNavOpen: false,
      c1NavLevel: 'root',
      // Nav agent picker
      c1TopStripOpen: true,
      c1TopTab: null,
      c1NavAgentOpen: false,
      c1NavAgentSearch: '',
      // Nav section breakdown tabs (dep/ld/na/sc/rf → agent|broker|chart)
      c1NavBreakdownTab: { dep: 'agent', ld: 'agent', na: 'agent', sc: 'agent', rf: 'agent' },
      // Nav section breakdown data
      c1NavBdAgents:  { dep: [], ld: [], na: [], sc: [], rf: [] },
      c1NavBdBrokers: { dep: [], ld: [], na: [], sc: [], rf: [] },
      c1NavBdChart:   { dep: [], ld: [], na: [], sc: [], rf: [] },
      c1NavBdLoading: { dep: false, ld: false, na: false, sc: false, rf: false },
      c1LiveTab: 'live',
      c1NavMod: { clients: true, tasks: false, stats: false, chat: false, comms: false, affiliation: false, finance: false, shifts: false, users: false, brokers: false, security: false },
      c1NavSec: {},
      c1NavSub: {},
      c1SlideOpen: null,
      c1DateFilter: "all",
      c1Cal: {
        year: new Date().getFullYear(),
        month: new Date().getMonth(),
        start: null,
        end: null,
        hPreset: null
      },
      c1CalMonthNames: ['January','February','March','April','May','June','July','August','September','October','November','December'],
      c1VikiVisible: false,
      c1VikiMood: 'neutral',
      c1VikiSpeaking: false,
      c1OpenTag: null,
      c1TagPicker: { cid: null, type: null, loading: false },
      c1AssignSlide: { open: false, cid: null },
      c1SlideProfile: null,
      c1DetailMode: true,
      c1GlanceOpen: null,
      c1GlanceUsers: [],
      c1GlanceBrokers: [],
      c1GlanceDays: [],
      c1GlanceDaysLoading: false,
      c1GlanceOpenRow: null,
      c1GlanceTab: 'hours',
      c1GlanceLoading: false,
      c1AgentGlanceOpen: null,
      c1AgentStatsCache: {},
      c1AgentStatsDateKey: null,
      c1AgentRangeIds: null,
      c1AgentRangeData: {},
      c1AgentRangeLoading: false,
      c1MyActivity: [],
      c1MyActivityLoading: false,
      c1MyActivityLoaded: false,
      c1AssignSearch: '',
      c1ViopaScores: {},      // keyed by agent_id → { score, is_golden_buzzer }
      c1ViopaAvoidIds: [],    // agent_ids to avoid
      c1ViopaLoadingAssign: false,
      c1AgentFilterSearch: '',
      c1SelectedClients: [],
      c1BulkSearch: '',
      c1BulkAgentOpen: false,
      c1BulkViopaScores: {},     // agent_id → { score, is_golden_buzzer, score_breakdown }
      c1BulkViopaAvoidIds: [],
      c1BulkViopaLoading: false,
      c1BulkViopaProfile: null,  // profile of the reference client used for scoring
      c1BulkViopaTimer: null,
      c1SmartAssignRunning: false,
      c1SmartAssignProgress: null, // { done, total, errors } while running
      c1VikiAvailability: [],      // [{ agent_id, name, status, reason }]
      c1VikiAvailLoading: false,
      c1VikiAvailLoaded: false,
      c1VikiAutoRunning: false,
      c1VikiAutoProgress: null,    // { done, total, errors } while running
      c1VikiAutoResult: null,      // { assigned, skipped } after completion
      c1PickerForm: {
        sc: { call_scheduled_on: "", status_id: null, comment: "", priority_id: 3 },
        dp: { campaign_id: null, amount: 250, currency_id: 1, method_id: null, status_id: null, comment: "" },
        ld: { campaign_id: null, comment: "", brokerSearch: "" },
        rf: { campaign_id: null, comment: "" },
        tr: { type_id: null, to: null }
      },
      c1VikiIdx: 0,
      c1VikiNotifMsg: null,   // single override message shown in popup (null = use computed c1VikiMsgs)
      c1VikiMsgKey: 0,        // incremented each say() to restart the progress bar animation
      c1VikiInitLoaded: false, // suppress narration on initial page load
      c1WeekBars: [
        { label: "Mon", pct: 45, val: 4, op: 0.7 },
        { label: "Tue", pct: 20, val: 1, op: 0.5 },
        { label: "Wed", pct: 60, val: 5, op: 0.75 },
        { label: "Thu", pct: 40, val: 3, op: 0.65 },
        { label: "Fri", pct: 80, val: 7, op: 0.85 },
        { label: "Sat", pct: 100, val: 9, op: 1 }
      ],
      c1DistBars: [
        { label: "NR", h: 10, color: "#A09E98" }, { label: "BN", h: 20, color: "#7A7067" },
        { label: "NA", h: 40, color: "#E05A3A" }, { label: "RF", h: 15, color: "#C75450" },
        { label: "LD", h: 55, color: "#D4A017" }, { label: "DP", h: 70, color: "#7C5CFC" },
        { label: "SC", h: 30, color: "#E8891C" }, { label: "NI", h: 12, color: "#B8960F" }
      ],
      c1AvatarColors: ["#7C5CFC","#C75450","#D4A017","#2D9D5E","#E8891C","#1144bc","#E05A3A","#827717"],
      c1TimeStr: "",
      c1Accordion: { cid: null, type: null },
      c1TagsExpanded: {},
      c1InfoOpen: {},
      c1ContactEdit: {},
      c1HistOpen: {},
      c1EditLog: {},
      c1EmailTab: {},
      c1EmailDraft: {},
      c1CardSelected: null,
      c1AutoSelected: false,
      c1JumpTarget: null,
      c1CardExpanded: null,
      c1ScEditOpen: false,
      c1ChartOpenSections: ['overview'],
      c1ChartsTab: 'overview',
      c1GDRDropOpen: false,
      c1ChartSectionDropOpen: false,
      c1PanelActiveContent: null,
      c1MiniGames: [
        { id: 2, name: 'Snake', emoji: '🐍' },
        { id: 3, name: 'Tetris', emoji: '🧱' },
        { id: 8, name: 'Memory', emoji: '🧠' },
        { id: 9, name: 'Minesweeper', emoji: '💣' },
      ],
      c1MiniActiveGame: null,
      c1MiniCurrentScore: 0,
      c1MiniGameCredits: 0,
      c1CallActive: false,
      c1FilterTab: 'status',
      c1DepSubTab: 'users',
      c1TimelinePoints: [],
      c1DailyGoal: 10,
      c1AgentLeaderboard: [],
      c1ChartDeps: [],
      c1ChartLeads: [],
      c1ChartNA: [],
      c1ChartSC: [],
      c1ChartRF: [],
      c1ChartAKGData: [],
      c1ChartAKGKey: 'DP',
      c1TodayFull: {},
      c1TodayLoaded: false,
      c1ChartLoading: { dep: false, ld: false, na: false, sc: false, tl: false, rf: false, akg: false, today: false },
      c1ChartActiveFilter: null,
      c1ChartActiveId: { dep: null, ld: null, na: null, sc: null, tl: null, rf: null },
      c1ChartDR: { dep: 'TODAY', ld: 'TODAY', na: 'TODAY', sc: 'TODAY', rf: 'TODAY', overview: 'WEEK' },
      c1StatusRange: null, // { from, to } — set when calendar date range is selected
      c1NavSnakeOpen: false,
      c1HamMenuOpen: false,
      c1GlobalDR: 'MONTH',
      c1VikiOpenSections: ['insights'],
      c1VikiCoffeeOrdered: false,
      c1VikiMotivated: false,
      // ---- FEATURE: Live AI Coach ----
      c1CoachData: null,
      c1CoachLoading: false,
      c1CoachClientId: null,
      // ---- FEATURE: Speed Badge ----
      c1LastApiMs: null,
      msApplied: { dp: false, ld: false, na: false, rf: false, sc: false, tr: false },
      // Native sector drill-down state
      c1SectorData: { dp: null, ld: null, na: null, rf: null, sc: null, tr: null },
      c1SectorLoading: { dp: false, ld: false, na: false, rf: false, sc: false, tr: false },
      c1SectorSelected: { dp: [], ld: [], na: [], rf: [], sc: [], tr: [] },
      c1Toast: null,
      c1SmartSort: null,
      // History Channel & Frozen clients
      historyChannel: JSON.parse(localStorage.getItem('c1_history') || '[]'),
      frozenClients: JSON.parse(localStorage.getItem('c1_frozen') || '[]'),
      // Context menu
      c1ContextMenu: { show: false, x: 0, y: 0, client: null },
      // Purple time filter flag
      // (filters.purple_time is handled in the filters object from parent, but we track separately)
      c1PurpleTimeActive: false,
      // VIOPA AI agent suggestion
      c1ViopaSuggestions: [],
      c1ViopaLoading: false,
      // ---- FEATURE: CSV Export ----
      c1ExportLoading: false,
      // ---- FEATURE: SMS Quick-Send ----
      c1SmsModal: null,
      c1SmsText: '',
      c1SmsSending: false,
      // ---- FEATURE: Call Log in Drawer ----
      c1DrawerCallsOpen: false,
      c1DrawerCallLog: null,
      c1DrawerCallStatus: null,
      // ---- FEATURE: CMS Actions in Drawer ----
      c1DrawerCmsOpen: false,
      c1CmsLoading: false,
      c1CmsPlan: '',
      c1CmsMsg: null,
      // ---- FEATURE: Admin Suggestions in Viki panel ----
      c1SuggestOpen: false,
      c1Suggestions: [],
      c1SuggestLoading: false,
      // ---- FEATURE: Survey / Questions in Drawer ----
      c1DrawerSurveyOpen: false,
      c1DrawerSurvey: null,
      c1DrawerSurveyLoading: false,
      // ---- FEATURE: Team Filter ----
      c1TeamFilter: null,   // null=all, 1=Team1, 2=Team2
    };
  },

  watch: {
    c1TopTab(val) {
      console.log('[C1 TAB]', val, 'statusRange=', JSON.stringify(this.c1StatusRange));
      if (val === 'status') this.c1LoadTodayChart();
    },
    '$route.params.leadId': {
      immediate: true,
      handler(id) {
        if (id) {
          const numId = parseInt(id);
          if (this.c1CardExpanded !== numId) this.c1CardExpanded = numId;
        }
      }
    },
    c1CardExpanded(id) {
      if (id !== null) {
        const target = { name: 'ClientLead', params: { leadId: id } };
        if (this.$route.name !== 'ClientLead' || parseInt(this.$route.params.leadId) !== id) {
          this.$router.replace(target).catch(() => {});
        }
      } else if (this.$route.name === 'ClientLead') {
        this.$router.replace({ name: 'Clients1' }).catch(() => {});
      }
    },
    clients(newList) {
      if (!newList || !newList.length) return;

      // 1) Jump target: client was navigated from Recently Viewed and wasn't in current page
      if (this.c1JumpTarget) {
        const target = newList.find(c => c.id === this.c1JumpTarget);
        if (target) {
          this.c1CardSelected = target.id;
          this.addToHistory(target);
          this.c1JumpTarget = null;
          // Do NOT clear filters.client — keep "#id" active so no stray query can reset the list
          // Restore active=true so if anything triggers a future query it returns the normal list
          this.filters.active = true;
          this.$nextTick(() => {
            const el = this.$el && this.$el.querySelector('.c1-box[data-cid="' + target.id + '"]');
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
          return;
        }
      }

      // 2) Auto-refresh stale status badges in "Recently Viewed"
      if (this.historyChannel.length) {
        let changed = false;
        const updated = this.historyChannel.map(h => {
          const fresh = newList.find(c => c.id === h.id);
          if (!fresh) return h;
          const newStatus = this.clientStatus(fresh).c;
          if (h.status === newStatus) return h;
          changed = true;
          return { ...h, status: newStatus };
        });
        if (changed) {
          localStorage.setItem('c1_history', JSON.stringify(updated));
          this.historyChannel = updated;
        }
      }

      // 3) Auto-select first client on initial load
      if (this.c1AutoSelected) return;
      this.c1AutoSelected = true;
      const lastId = parseInt(localStorage.getItem('c1_last_id') || '0');
      const inList = lastId && newList.find(c => c.id === lastId);
      if (inList) { this.c1CardSelected = lastId; return; }
      const newClient = newList.find(c => c.is_new);
      this.c1CardSelected = newClient ? newClient.id : newList[0].id;
    },

    // Viki narrates results after every data fetch — skip the initial load
    'pagination.total'(val, old) {
      if (val === old) return;
      if (!this.c1VikiInitLoaded) { this.c1VikiInitLoaded = true; return; }
      this.c1VikiNarrate();
    },

    c1SelectedClients(ids) {
      clearTimeout(this.c1BulkViopaTimer);
      if (!ids || !ids.length) {
        this.c1BulkViopaScores = {};
        this.c1BulkViopaAvoidIds = [];
        this.c1BulkViopaProfile = null;
        return;
      }
      this.c1BulkViopaTimer = setTimeout(() => this.c1LoadBulkViopaScore(), 600);
    },

    c1SlideOpen(val) {
      // Auto-track which content is active for the two-screen panel
      if (val && val !== 'nav' && val !== 'menu') {
        this.c1PanelActiveContent = val;
      }
      if (val === 'charts' || val === 'live' || val === 'nav') {
        this.c1LoadTodayChart();
      }
      if (val === 'live' || val === 'nav') {
        this.c1LoadLiveLeaderboard();
      }
      if (val === 'filters' && this.c1FilterTab === 'date') {
        this.$nextTick(() => {
          if (this.$refs.smartCal) this.$refs.smartCal.loadWeek();
        });
      }
      // Reset active content and filter tab when panel fully closes
      if (!val) {
        this.c1PanelActiveContent = null;
        if (['dp','ld','na','rf','sc','tr'].includes(this.c1FilterTab)) {
          this.c1FilterTab = 'status';
        }
      }
    },
    c1DepSubTab() {
      if (this.c1IsSectionOpen('deposits')) this.c1LoadChartDeposits();
    },
    c1FilterTab(val) {
      if (['dp','ld','na','rf','sc','tr'].includes(val) && !this.c1SectorData[val]) {
        this.c1LoadSector(val);
      }
      if (val === 'date') {
        this.$nextTick(() => {
          if (this.$refs.smartCal) this.$refs.smartCal.loadWeek();
        });
      }
    },
    getQueryParamsToMs: {
      handler() {
        // Invalidate cached sector data when filter context changes
        ['dp','ld','na','rf','sc','tr'].forEach(k => this.$set(this.c1SectorData, k, null));
        // Reload if currently viewing a sector tab
        const cur = this.c1FilterTab;
        if (['dp','ld','na','rf','sc','tr'].includes(cur)) {
          this.c1LoadSector(cur);
        }
      },
      deep: true
    },

    c1StatusRange(val, old) {
      // Invalidate agent range cache when date changes
      if (!val || !old || val.from !== old.from || val.to !== old.to) {
        this.c1AgentRangeIds = null;
        this.c1AgentRangeData = {};
        this.c1AgentStatsDateKey = null;
        this.c1AgentStatsCache = {};
      }
    },

    c1TopTab(val) {
      if (val === 'agents') {
        this.c1AgentStatsCache = {};
        this.c1AgentGlanceOpen = null;
        this.c1LoadAgentDateRange();
      }
    },

    c1CardSelected(id) {
      if (id) localStorage.setItem('c1_last_id', id);
      // Auto-refresh Live Coach when coach section is open
      if (id && this.c1IsVikiSection('coach') && this.c1PanelActiveContent === 'viki') {
        this.c1LoadCoach(id);
      }
    },

    // ---- FEATURE: Call Log in Drawer ----
    c1DrawerClient(client) {
      if (client) {
        this.c1DrawerCallsOpen = false;
        this.c1DrawerCallLog = null;
        this.c1DrawerCallStatus = null;
        this.c1DrawerCmsOpen = false;
        this.c1CmsMsg = null;
        this.c1CmsPlan = '';
        this.c1DrawerSurveyOpen = false;
        this.c1DrawerSurvey = null;
        this.c1LoadSurvey(client.id);
        apiClientCreator(`client/call_status/${client.id}`).get('').then(res => {
          const raw = res.data;
          if (typeof raw === 'string') {
            this.c1DrawerCallStatus = raw.trim();
          } else if (Array.isArray(raw)) {
            this.c1DrawerCallLog = raw;
          } else if (raw && raw.data) {
            this.c1DrawerCallLog = raw.data;
          }
        }).catch(() => {});
      }
    }
  },

  computed: {
    c1NavFilteredAgents() {
      let list = this.$store.state.clients.salesPersonList || [];
      // Filter to agents active in current date range (when loaded), sorted by activity
      if (this.c1AgentRangeIds !== null) {
        list = list.filter(a => this.c1AgentRangeIds.includes(a.id));
        const rd = this.c1AgentRangeData;
        list = list.slice().sort((a, b) => ((rd[b.id] && rd[b.id].total) || 0) - ((rd[a.id] && rd[a.id].total) || 0));
      }
      if (!this.c1NavAgentSearch) return list;
      const q = this.c1NavAgentSearch.toLowerCase();
      return list.filter(a => (a.full_name || a.name || a.username || '').toLowerCase().includes(q));
    },
    c1InlineAssignAgents() {
      const list = this.$store.state.clients.salesPersonList || [];
      if (!this.c1InlineAssignSearch) return list;
      const q = this.c1InlineAssignSearch.toLowerCase();
      return list.filter(a => (a.full_name || a.name || a.username || '').toLowerCase().includes(q));
    },
    c1NavCountryList() {
      const all = (this.dictionaries && this.dictionaries.general && this.dictionaries.general.countries) || [];
      if (!this.c1CountrySearch) return all;
      const q = this.c1CountrySearch.toLowerCase();
      return all.filter(c => (c.name || '').toLowerCase().includes(q));
    },
    c1StatusAgents() {
      const list = this.$store.state.clients.salesPersonList || [];
      return list
        .filter(a => (a.client_assignments_count || 0) > 0)
        .sort((a, b) => (b.client_assignments_count || 0) - (a.client_assignments_count || 0));
    },
    c1StatusAgentMax() {
      return Math.max(1, ...this.c1StatusAgents.map(a => a.client_assignments_count || 0));
    },
    c1StatusCountries() {
      const flagMap = {
        'United Kingdom':'🇬🇧','UK':'🇬🇧','France':'🇫🇷','Germany':'🇩🇪','Italy':'🇮🇹',
        'Spain':'🇪🇸','Australia':'🇦🇺','Israel':'🇮🇱','India':'🇮🇳','United States':'🇺🇸',
        'USA':'🇺🇸','Netherlands':'🇳🇱','Belgium':'🇧🇪','Portugal':'🇵🇹','Switzerland':'🇨🇭',
        'Austria':'🇦🇹','Sweden':'🇸🇪','Norway':'🇳🇴','Denmark':'🇩🇰','Finland':'🇫🇮',
        'Poland':'🇵🇱','Russia':'🇷🇺','Ukraine':'🇺🇦','Canada':'🇨🇦','Mexico':'🇲🇽',
        'Brazil':'🇧🇷','Japan':'🇯🇵','China':'🇨🇳','South Korea':'🇰🇷','Singapore':'🇸🇬',
        'Thailand':'🇹🇭','New Zealand':'🇳🇿','South Africa':'🇿🇦','Cyprus':'🇨🇾',
        'Malta':'🇲🇹','Turkey':'🇹🇷','Romania':'🇷🇴','Hungary':'🇭🇺',
        'Czech Republic':'🇨🇿','Greece':'🇬🇷','Ireland':'🇮🇪','Nigeria':'🇳🇬'
      };
      const nameCounts = {};
      (this.clients || []).forEach(c => {
        if (!c.country) return;
        const name = typeof c.country === 'object' ? c.country.name : c.country;
        if (name) nameCounts[name] = (nameCounts[name] || 0) + 1;
      });
      const allDicts = (this.dictionaries && this.dictionaries.general && this.dictionaries.general.countries) || [];
      const q = (this.c1CountrySearch || '').toLowerCase();
      return allDicts
        .filter(co => nameCounts[co.name])
        .filter(co => !q || (co.name || '').toLowerCase().includes(q))
        .map(co => ({ ...co, count: nameCounts[co.name] || 0, flag: flagMap[co.name] || '🌍' }))
        .sort((a, b) => b.count - a.count);
    },
    c1StatusCountryMax() {
      return Math.max(1, ...this.c1StatusCountries.map(c => c.count));
    },
    c1SortLabel() {
      if (this.c1SmartSort === 'sc_first')  return '⚡ SC';
      if (this.c1SmartSort === 'new_first') return '🆕 New';
      if (this.c1SmartSort === 'hot_first') return '🔥 Hot';
      if (this.c1SmartSort === 'dep_first') return '💰 Dep';
      if (this.sortActive.cre.up)   return 'Date ↑';
      if (this.sortActive.cre.down) return 'Date ↓';
      if (this.sortActive.mod.up)   return 'Mod ↑';
      if (this.sortActive.mod.down) return 'Mod ↓';
      if (this.sortActive.name.up)  return 'A→Z';
      if (this.sortActive.name.down) return 'Z→A';
      return '🧠 Smart';
    },
    c1SortSelectVal() {
      if (this.sortActive.cre.up)    return 'date_up';
      if (this.sortActive.cre.down)  return 'date_down';
      if (this.sortActive.mod.up)    return 'mod_up';
      if (this.sortActive.mod.down)  return 'mod_down';
      if (this.sortActive.name.up)   return 'az';
      if (this.sortActive.name.down) return 'za';
      return 'smart';
    },
    c1NavCalendarParams() {
      const p = {};
      if (this.filters && this.filters.assigned && this.filters.assigned.length) {
        p.assigned = this.filters.assigned.map(a => a.id || a);
      }
      // Tell the calendar which status types are active so it can show only those
      const statusChipMap = [
        { filterKey: 'deposit',         chipKey: 'DP' },
        { filterKey: 'leads',           chipKey: 'LD' },
        { filterKey: 'na',              chipKey: 'NA' },
        { filterKey: 'scheduled_calls', chipKey: 'SC' },
        { filterKey: 'not_interested',  chipKey: 'NI' },
        { filterKey: 'bad_number',      chipKey: 'BN' },
        { filterKey: 'new',             chipKey: 'REG' },
      ];
      const active = statusChipMap.filter(m => this.filters && this.filters[m.filterKey]).map(m => m.chipKey);
      if (active.length) p.activeTypes = active;
      return p;
    },
    c1NavBdBarPct() {
      return (u, arr) => {
        if (!arr.length) return 0;
        const max = Math.max(1, ...arr.map(x => x.count));
        return Math.round((u.count / max) * 100);
      };
    },
    c1CalFilterParams() {
      const p = {};
      if (this.filters && this.filters.assigned && this.filters.assigned.length) {
        p['assigned[]'] = this.filters.assigned;
      }
      return p;
    },
    c1AnyMsOpen() {
      return this.c1SlideOpen === 'filters' && ['dp','ld','na','rf','sc','tr'].includes(this.c1FilterTab);
    },
    c1VikiMsgs() {
      const dep = (this.stats && this.stats.deposits) || 0;
      const na = (this.stats && this.stats.nac) || 0;
      const leads = (this.stats && this.stats.leads) || 0;
      return [
        { m: `Review today's pipeline — <strong>${dep} deposit${dep !== 1 ? 's' : ''}</strong> confirmed today.`, b: "Review →" },
        { m: `<strong>Check missed calls</strong> — ${na} client${na !== 1 ? 's' : ''} with No Answer today.`, b: "Check →" },
        { m: `<strong>${leads} lead${leads !== 1 ? 's' : ''} in pipeline</strong> — assign and qualify fast.`, b: "Assign →" },
        { m: "Performance looks stable. Keep the momentum going.", b: "Stats →" }
      ];
    },
    c1SectorCfg() {
      return {
        dp: { label: 'Deposits — by Agent',  color: '#ae3ede', endpoint: 'client/stats/multiselect/deposits/users',
              strip: ['deposit_users','deposit_sec_users','deposit_lead_users','deposit_brokers','deposit_statuses','deposit_answers','deposit_brokers_quantity','deposit_to_rem','deposit_from_cc','deposit_from_sup'] },
        ld: { label: 'Leads — by Agent',     color: '#4275ec', endpoint: 'client/stats/multiselect/leads/users',
              strip: ['lead_campaigns_users','lead_campaigns'] },
        na: { label: 'No Answer — by Agent', color: '#F4511E', endpoint: 'client/stats/multiselect/no_answer/users',
              strip: ['na_users'] },
        rf: { label: 'Referral — by Agent',  color: '#af3131', endpoint: 'client/stats/multiselect/referral/users',
              strip: ['referral_users','referral_brokers','referral_campaigns','referral_campaigns_users'] },
        sc: { label: 'Scheduled — by Agent', color: '#fb9324', endpoint: 'client/stats/multiselect/call_again/users',
              strip: ['ca_users','ca_status','ca_auto_status','priority'] },
        tr: { label: 'Transfer — by Agent',  color: '#827717', endpoint: 'client/stats/multiselect/transfer/place',
              strip: ['client_transfers_by','client_transfers_from','client_transfers','client_transfers_type'] }
      };
    },
    c1UserInitials() {
      const u = this.auth && this.auth.user;
      if (!u) return "?";
      return ((u.first_name || "")[0] || "").toUpperCase() + ((u.last_name || "")[0] || "").toUpperCase();
    },
    c1CurrentPageLabel() {
      const map = {
        '/clients1': 'Clients', '/tasks1': 'Tasks', '/stats1': 'Statistics',
        '/chat1': 'Chat', '/communications1': 'Communications', '/affiliation1': 'Affiliation',
        '/finance1': 'Finance', '/shifts1': 'Shifts', '/games1': 'Games',
        '/users1': 'Users', '/brokers1': 'Brokers', '/security1': 'Security',
        '/quiz1': 'Quiz', '/instruction1': 'Instructions', '/settings1': 'Settings', '/profile1': 'My Profile',
      };
      return map[this.$route.path] || 'Menu';
    },
    c1UserFullName() {
      const u = this.auth && this.auth.user;
      if (!u) return "User";
      return ((u.first_name || "") + " " + (u.last_name || "")).trim() || "User";
    },
    c1RoleLabel() {
      const map = { 1: "Owner", 2: "Owner", 3: "Floor Manager", 4: "Shift Manager", 5: "Chat", 6: "Team Leader", 7: "Sales", 8: "Support", 9: "Content", 10: "Office", 11: "Instructor", 12: "Dev", 13: "Finance", 14: "Personal Assistant" };
      return map[(this.auth && this.auth.user && this.auth.user.role)] || "User";
    },
    c1TzUK() { return this.c1TzTime("Europe/London"); },
    c1TimelinePolyline() {
      return this.c1TlBuildLine(false);
    },
    c1TimelineArea() {
      return this.c1TlBuildLine(true);
    },
    c1GlanceHoursAgg() {
      const agg = {};
      this.c1GlanceDays.forEach(d => {
        if (d.hours) {
          Object.entries(d.hours).forEach(([hh, cnt]) => {
            if (cnt > 0) agg[hh] = (agg[hh] || 0) + cnt;
          });
        }
      });
      return agg;
    },
    c1GlanceSortedHours() {
      return Object.keys(this.c1GlanceHoursAgg).sort();
    },
    c1ActiveFilterCount() {
      let n = 0;
      if (this.filters.deposit) n++;
      if (this.filters.leads) n++;
      if (this.filters.na) n++;
      if (this.filters.scheduled_calls) n++;
      if (this.filters.referral) n++;
      if (this.filters.transfer) n++;
      if (this.filters.bad_number) n++;
      if (this.filters.not_interested) n++;
      if (this.filters.is_new) n++;
      if (this.filters.online) n++;
      if (this.filters.waiting) n++;
      if (this.filters.leading_new) n++;
      if (this.filters.loosing_new) n++;
      if (this.filters.coming_calls) n++;
      if (this.filters.missed_calls) n++;
      if (this.filters.today_calls) n++;
      if (this.filters.assigned && this.filters.assigned.length) n += this.filters.assigned.length;
      if (this.filters.client) n++;
      if (this.filters.registered_on_from) n++;
      if (this.c1PurpleTimeActive) n++;
      return n;
    },
    c1OverviewRows() {
      const d = this.c1TodayFull;
      const rows = [
        { key: 'DEP',    label: 'Deposits',       color: 'var(--c1-dp)',  val: d.DEP || d.DP || 0, breakdown: 'dep', active: !!(Array.isArray(this.filters.deposit_at) && this.filters.deposit_at.length),         click: () => { this.filterByDeposit(); this.c1SlideOpen = null; } },
        { key: 'REG',    label: 'Signups',         color: '#3b82f6',       val: d.REG   || 0, breakdown: 'reg', active: !!(Array.isArray(this.filters.registered_on) && this.filters.registered_on.length),    click: () => { this.c1ApplyStatusFilter({ key: 'REG' }); } },
        { key: 'LD',     label: 'Leads',           color: 'var(--c1-ld)',  val: d.LD    || 0, breakdown: 'ld',  active: !!(Array.isArray(this.filters.last_modified_leads) && this.filters.last_modified_leads.length),            click: () => { this.filterByLead(); this.c1SlideOpen = null; } },
        { key: 'NA',     label: 'No Answer',       color: 'var(--c1-na)',  val: d.NA    || 0, breakdown: 'na',  active: !!(Array.isArray(this.filters.last_modified_na) && this.filters.last_modified_na.length),               click: () => { this.filterByNoAnswer(0); this.c1SlideOpen = null; } },
        { key: 'CA',     label: 'Scheduled',       color: 'var(--c1-sc)',  val: d.CA    || 0, breakdown: 'sc',  active: !!(Array.isArray(this.filters.scheduled_call_to) && this.filters.scheduled_call_to.length),  click: () => { this.filterByScheduledCalls(); this.c1SlideOpen = null; } },
        { key: 'NEW',    label: 'New today',       color: 'var(--c1-nw)',  val: d.NEW   || 0, breakdown: 'newl',active: !!this.filters.is_new,                           click: () => { this.filterByNew(); this.c1SlideOpen = null; } },
        { key: 'RF',     label: 'Referrals',       color: 'var(--c1-rf)',  val: d.RF    || 0, breakdown: 'rf',  active: !!(Array.isArray(this.filters.last_referral) && this.filters.last_referral.length),         click: () => { this.filterByReferral(); this.c1SlideOpen = null; } },
        { key: 'TR-LV',  label: 'Transfer Live',   color: '#0ea5e9',       val: d['TR-LV'] || 0, breakdown: 'tr',   active: false, click: () => { this.filterByTransfer(); this.c1SlideOpen = null; } },
        { key: 'TR-ON',  label: 'Transfer Online', color: '#06b6d4',       val: d['TR-ON'] || 0, breakdown: 'tron', active: !!this.filters.transfer, click: () => { this.c1ApplyStatusFilter({ key: 'TR-ON' }); } },
        { key: 'NI',     label: 'Not Interested',  color: '#9ca3af',       val: d.NI    || 0, breakdown: 'ni',    active: !!this.filters.not_interested, click: () => { this.c1ApplyStatusFilter({ key: 'NI' }); } },
        { key: 'BN',     label: 'Bad Number',      color: '#6b7280',       val: d.BN    || 0, breakdown: 'bn',    active: !!(Array.isArray(this.filters.last_modified_bn) && this.filters.last_modified_bn.length),     click: () => { this.c1ApplyStatusFilter({ key: 'BN' }); } },
        { key: 'NR',     label: 'Not Reached',     color: '#d1d5db',       val: d.NR    || 0, breakdown: 'nr',    active: false, click: null },
        { key: 'CC-DEC', label: 'CC Decline',      color: '#ef4444',       val: d['CC-DEC'] || d.DEC || 0, breakdown: 'ccdec', active: !!this.filters.cc_decline_clients, click: () => { this.c1ApplyStatusFilter({ key: 'CC-DEC' }); } },
        { key: 'ENDED',  label: 'Ended',           color: '#dc2626',       val: d.ENDED || 0, breakdown: 'ended', active: !!this.filters.ended, click: () => { this.c1ApplyStatusFilter({ key: 'ENDED' }); } },
        { key: 'NU',     label: 'New Users',       color: '#8b5cf6',       val: d.NU    || 0, breakdown: 'nu',    active: !!(Array.isArray(this.filters.registered_on) && this.filters.registered_on.length) && !!this.filters.is_new, click: () => { this.c1ApplyStatusFilter({ key: 'NU' }); } },
        { key: 'SMS',    label: 'SMS Sent',        color: '#64748b',       val: d.SMS   || 0, breakdown: 'sms',   active: false, click: null },
      ];
      const max = Math.max(1, ...rows.map(r => r.val));
      return rows.map(r => ({ ...r, pct: Math.round((r.val / max) * 100) }));
    },
    c1DRPresets() {
      return [
        { k: 'TODAY',     l: 'Today' },
        { k: 'YESTERDAY', l: 'Yesterday' },
        { k: 'WEEK',      l: 'Week' },
        { k: 'MONTH',     l: 'Month' },
        { k: 'ALL',       l: 'All' },
      ];
    },
    c1DRPresetsWithFuture() {
      return [
        { k: 'TODAY',     l: 'Today' },
        { k: 'YESTERDAY', l: 'Yesterday' },
        { k: 'WEEK',      l: 'Week' },
        { k: 'MONTH',     l: 'Month' },
        { k: 'FUTURE',    l: 'Future' },
        { k: 'ALL',       l: 'All' },
      ];
    },
    c1FilterPanelTitle() {
      const m = { status: 'Status', agents: 'Agents', date: 'Date', sort: 'Sort',
                  dp: 'Deposits', ld: 'Leads', na: 'No Answer', rf: 'Referrals', sc: 'Scheduled', tr: 'Transfer' };
      return m[this.c1FilterTab] || 'Filters';
    },
    c1ChartsPanelTitle() {
      if (this.c1ChartsTab === 'game') return 'Arcade';
      const m = { overview: 'At a Glance', filters: 'Agents', deposits: 'Deposits',
                  leads: 'Leads', na: 'No Answer', sc: 'Scheduled', rf: 'Referrals',
                  akg: '30-Day Trend', timeline: 'Timeline' };
      return m[this.c1ActiveSection] || 'Analytics';
    },
    c1PanelIsOpen() {
      return !!this.c1SlideOpen && this.c1SlideOpen !== 'menu';
    },
    c1PanelAtContent() {
      return this.c1PanelIsOpen && this.c1SlideOpen !== 'nav';
    },
    c1VikiCardColor() {
      const map = { neutral:'rgb(29,184,212)', info:'rgb(29,184,212)', happy:'rgb(232,160,32)', success:'rgb(34,201,122)', error:'rgb(217,68,85)', angry:'rgb(192,32,48)' }
      return map[this.c1VikiMood] || map.neutral
    },
    c1ActivePanelLabel() {
      if (!this.c1PanelIsOpen) return 'Panels';
      if (this.c1SlideOpen === 'nav') return 'Panels';
      if (this.c1PanelActiveContent === 'live') return 'Live';
      if (this.c1PanelActiveContent === 'filters') {
        const m = { status: 'Status', agents: 'Agents', date: 'Date', sort: 'Sort',
                    dp: 'Deposits', ld: 'Leads', na: 'No Answer', rf: 'Referrals', sc: 'Scheduled', tr: 'Transfer' };
        return m[this.c1FilterTab] || 'Filter';
      }
      if (this.c1PanelActiveContent === 'charts') {
        if (this.c1ChartsTab === 'game') return 'Games';
        const m = { overview: 'At a Glance', deposits: 'Deposits', leads: 'Leads',
                    na: 'No Answer', sc: 'Scheduled', rf: 'Referrals',
                    akg: '30-Day Trend', timeline: 'Timeline', filters: 'Agents' };
        return m[this.c1ActiveSection] || 'Charts';
      }
      if (this.c1PanelActiveContent === 'viki') {
        const m = { insights: 'AI Insights', scorecard: 'Scorecard', comms: 'Communications', team: 'Team Pulse', coach: 'Live Coach' };
        return m[this.c1VikiOpenSections[0]] || 'Tex';
      }
      return 'Panels';
    },
    c1ActiveSection() {
      return this.c1ChartOpenSections[0] || 'overview';
    },
    c1SectionMenuList() {
      return [
        { k: 'overview',  l: 'At a Glance',      color: '#6c8ebf' },
        { k: 'filters',   l: 'Filters & Agents',  color: '#888' },
        { k: 'deposits',  l: 'Deposits',          color: 'var(--c1-dp)' },
        { k: 'leads',     l: 'Leads',             color: 'var(--c1-ld)' },
        { k: 'na',        l: 'No Answer',         color: 'var(--c1-na)' },
        { k: 'sc',        l: 'Scheduled Calls',   color: 'var(--c1-sc)' },
        { k: 'rf',        l: 'Referrals',         color: 'var(--c1-rf)' },
        { k: 'akg',       l: '30-Day Trend',      color: '#7c6f9f' },
        { k: 'timeline',  l: 'Deposit Timeline',  color: 'var(--c1-dp)' },
      ];
    },
    c1GDRPills() {
      const today = new Date();
      const pad = n => String(n).padStart(2,'0');
      const fmt = d => pad(d.getDate()) + '/' + pad(d.getMonth()+1);
      const days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
      const todayStr = fmt(today);
      const todayDay = days[today.getDay()];
      const yest = new Date(today); yest.setDate(today.getDate()-1);
      const yestStr = fmt(yest);
      const yestDay = days[yest.getDay()];
      const wkStart = new Date(today); wkStart.setDate(today.getDate()-((today.getDay()+6)%7));
      const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      return [
        { k: 'TODAY',     l: 'Today',     d: todayDay + ' ' + todayStr },
        { k: 'YESTERDAY', l: 'Yesterday', d: yestDay + ' ' + yestStr },
        { k: 'WEEK',      l: 'Week',      d: fmt(wkStart) + '–' + todayStr },
        { k: 'MONTH',     l: 'Month',     d: months[today.getMonth()] + ' ' + today.getFullYear() },
        { k: 'FUTURE',    l: 'Future',    d: 'upcoming' },
        { k: 'ALL',       l: 'All',       d: 'all time' },
      ];
    },
    c1AKGRows() {
      const key = this.c1ChartAKGKey;
      const rows = this.c1ChartAKGData.map(r => ({
        label: r.date || '',
        val: (r.report && r.report[key]) ? r.report[key] : 0
      })).filter(r => r.val > 0);
      const max = Math.max(1, ...rows.map(r => r.val));
      return rows.slice(-14).reverse().map(r => ({ ...r, pct: Math.round((r.val / max) * 100) }));
    },
    c1AKGKeys() {
      return [
        { k: 'DP',    label: 'Deposits',         color: 'var(--c1-dp)' },
        { k: 'REG',   label: 'Signups',           color: '#3b82f6' },
        { k: 'LD',    label: 'Leads',             color: 'var(--c1-ld)' },
        { k: 'NA',    label: 'No Answer',         color: 'var(--c1-na)' },
        { k: 'CA',    label: 'Scheduled Calls',   color: 'var(--c1-sc)' },
        { k: 'RF',    label: 'Referrals',         color: 'var(--c1-rf)' },
        { k: 'TR-LV', label: 'Transfer Live',     color: '#0ea5e9' },
        { k: 'NI',    label: 'Not Interested',    color: '#9ca3af' },
        { k: 'BN',    label: 'Bad Number',        color: '#6b7280' },
      ];
    },
    c1TzIL() { return this.c1TzTime("Asia/Jerusalem"); },
    c1TzCB() { return this.c1TzTime("America/Cayman"); },
    c1CalGrid() {
      const { year, month } = this.c1Cal;
      const firstOfMonth = moment([year, month, 1]);
      const startDow = (firstOfMonth.day() + 6) % 7;
      const cursor = firstOfMonth.clone().subtract(startDow, 'days');
      const todayStr = moment().format('YYYY-MM-DD');
      const weeks = [];
      for (let w = 0; w < 6; w++) {
        const week = [];
        for (let d = 0; d < 7; d++) {
          const dateStr = cursor.format('YYYY-MM-DD');
          const inMonth = cursor.month() === month;
          const isStart = dateStr === this.c1Cal.start;
          const isEnd = this.c1Cal.end ? dateStr === this.c1Cal.end : isStart && !!this.c1Cal.start;
          const inRange = !!(this.c1Cal.start && this.c1Cal.end && dateStr > this.c1Cal.start && dateStr < this.c1Cal.end);
          week.push({ date: dateStr, day: cursor.date(), inMonth, today: dateStr === todayStr, inRange, isStart, isEnd, wk: d === 0 ? cursor.isoWeek() : null });
          cursor.add(1, 'day');
        }
        weeks.push(week);
        if (w >= 3 && cursor.month() !== month) break;
      }
      return weeks;
    },
    c1DrawerClient() {
      if (this.c1CardExpanded === null) return null;
      return (this.clients || []).find(c => c.id === this.c1CardExpanded) || null;
    },
    c1DrawerTimeline() {
      const cl = this.c1DrawerClient;
      if (!cl) return [];
      const events = [];
      const fmt = (d) => {
        if (!d) return '—';
        try {
          const dt = new Date(d);
          return dt.toLocaleDateString('en-GB', { day:'2-digit', month:'short', year:'numeric' })
            + ' ' + dt.toLocaleTimeString('en-GB', { hour:'2-digit', minute:'2-digit' });
        } catch(e) { return d; }
      };
      // Registration
      if (cl.registered_on) {
        events.push({ date: fmt(cl.registered_on), badge: 'REG', title: 'Client registered', sub: cl.keyword ? 'Source: ' + cl.keyword : null, color: '#2D9D5E', ts: new Date(cl.registered_on).getTime() });
      }
      // Assignment
      if (cl.assignment) {
        const agent = cl.assignment.assigned_to ? (cl.assignment.assigned_to.full_name || cl.assignment.assigned_to.first_name) : 'Unknown';
        events.push({ date: fmt(cl.assignment.created_at), badge: 'ASG', title: 'Assigned to ' + agent, sub: null, color: '#4a9ff5', ts: new Date(cl.assignment.created_at || 0).getTime() });
      }
      // Deposits
      (cl.deposits || []).forEach(dep => {
        events.push({ date: fmt(dep.created_at), badge: 'DP', title: 'Deposit — ' + (dep.amount || '?') + (dep.currency ? ' ' + dep.currency : ''), sub: dep.payment_method || null, color: '#7C5CFC', ts: new Date(dep.created_at || 0).getTime() });
      });
      // Scheduled calls
      (cl.scheduled_calls || []).forEach(sc => {
        const when = sc.scheduled_on || sc.call_at;
        const label = sc.is_missed ? 'Missed call' : (sc.ended ? 'Call ended' : 'Call scheduled');
        const color = sc.is_missed ? '#E05A3A' : (sc.ended ? '#7A7067' : '#E8891C');
        events.push({ date: fmt(when), badge: 'SC', title: label, sub: sc.status ? sc.status.name : null, color, ts: new Date(when || 0).getTime() });
      });
      // Transfers
      (cl.transfers || []).forEach(tr => {
        events.push({ date: fmt(tr.created_at), badge: 'TR', title: 'Transfer', sub: null, color: '#9B6000', ts: new Date(tr.created_at || 0).getTime() });
      });
      // No Answer / Voicemail records
      (cl.na || []).forEach(na => {
        events.push({ date: fmt(na.created_at), badge: na.is_vm ? 'VM' : 'NA', title: na.is_vm ? 'Voicemail left' : 'No Answer', sub: na.user ? (na.user.full_name || ((na.user.first_name || '') + ' ' + (na.user.last_name || '')).trim()) : null, color: 'var(--c1-na)', ts: new Date(na.created_at || 0).getTime() });
      });
      // NI / BN status
      if (cl.call_status === 5 && cl.updated_at) {
        events.push({ date: fmt(cl.updated_at), badge: 'NI', title: 'Marked Not Interested', sub: null, color: '#9A6F00', ts: new Date(cl.updated_at).getTime() });
      }
      if (cl.call_status === 6 && cl.updated_at) {
        events.push({ date: fmt(cl.updated_at), badge: 'BN', title: 'Bad Number flagged', sub: null, color: '#C75450', ts: new Date(cl.updated_at).getTime() });
      }
      // Sort newest first
      events.sort((a, b) => b.ts - a.ts);
      return events;
    },
    c1ActiveClient() {
      if (!this.c1TagPicker.cid) return null;
      return (this.clients || []).find(c => c.id === this.c1TagPicker.cid) || null;
    },
    c1AssignSlideClient() {
      if (!this.c1AssignSlide.cid) return null;
      return (this.clients || []).find(c => c.id === this.c1AssignSlide.cid) || null;
    },
    c1FilteredPanelAgents() {
      const list = this.$store.state.clients.salesPersonList || [];
      if (!this.c1AgentFilterSearch) return list;
      const q = this.c1AgentFilterSearch.toLowerCase();
      return list.filter(a => (a.full_name || a.name || a.username || '').toLowerCase().includes(q));
    },
    c1FilteredAgents() {
      const list = this.$store.state.clients.salesPersonList || [];
      const q = this.c1AssignSearch ? this.c1AssignSearch.toLowerCase() : null;
      const filtered = q ? list.filter(a => (a.full_name || a.name || '').toLowerCase().includes(q)) : list;
      const scores = this.c1ViopaScores;
      const avoidSet = new Set(this.c1ViopaAvoidIds);
      if (!Object.keys(scores).length && !avoidSet.size) return filtered;
      return [...filtered].sort((a, b) => {
        const sa = scores[a.id], sb = scores[b.id];
        const avA = avoidSet.has(a.id), avB = avoidSet.has(b.id);
        // avoid → push to bottom
        if (avA && !avB) return 1;
        if (!avA && avB) return -1;
        // golden buzzer → top
        const gbA = sa && sa.is_golden_buzzer, gbB = sb && sb.is_golden_buzzer;
        if (gbA && !gbB) return -1;
        if (!gbA && gbB) return 1;
        // sort by score desc; unscored last (treat as -1)
        const scA = sa ? sa.score : -1, scB = sb ? sb.score : -1;
        return scB - scA;
      });
    },
    c1FilteredBulkAgents() {
      const list = this.$store.state.clients.salesPersonList || [];
      const q = this.c1BulkSearch ? this.c1BulkSearch.toLowerCase() : null;
      const filtered = q ? list.filter(a => (a.full_name || a.name || '').toLowerCase().includes(q)) : list;
      const scores = this.c1BulkViopaScores;
      const avoidSet = new Set(this.c1BulkViopaAvoidIds);
      if (!Object.keys(scores).length && !avoidSet.size) return filtered.slice(0, 25);
      return [...filtered].sort((a, b) => {
        const sa = scores[a.id], sb = scores[b.id];
        const avA = avoidSet.has(a.id), avB = avoidSet.has(b.id);
        if (avA && !avB) return 1;
        if (!avA && avB) return -1;
        const gbA = sa && sa.is_golden_buzzer, gbB = sb && sb.is_golden_buzzer;
        if (gbA && !gbB) return -1;
        if (!gbA && gbB) return 1;
        const scA = sa ? sa.score : -1, scB = sb ? sb.score : -1;
        return scB - scA;
      }).slice(0, 25);
    },
    c1CanAssign() {
      const role = Number(this.auth && this.auth.user && this.auth.user.role);
      return [1, 2, 3, 4, 5, 6, 8, 12].includes(role);
    },
    c1ActiveBrokers() {
      const brokers = (this.dictionaries && this.dictionaries.general && this.dictionaries.general.brokers) || [];
      return brokers.filter(b => b.active !== 0);
    },
    bnStates() {
      return (this.dictionaries && this.dictionaries.activity && this.dictionaries.activity.bad_number_states) || [];
    },
    niStates() {
      return (this.dictionaries && this.dictionaries.activity && this.dictionaries.activity.not_int_states) || [];
    },
    scStatuses() {
      return (this.dictionaries && this.dictionaries.activity && this.dictionaries.activity.scheduled_calls_statuses) || [];
    },
    trTypes() {
      return (this.dictionaries && this.dictionaries.activity && this.dictionaries.activity.transfer_types) || [];
    },
    scPriorities() {
      return (this.dictionaries && this.dictionaries.activity && this.dictionaries.activity.priorities_types) || [
        { id: 1, title: 'High' }, { id: 3, title: 'Normal' }, { id: 2, title: 'Low' }
      ];
    },
    depositStatuses() {
      return [
        { id: 1, label: 'Check' },
        { id: 5, label: 'Approved' },
        { id: 2, label: 'Traded' },
        { id: 3, label: 'Done Sales' },
        { id: 4, label: 'Removed' }
      ];
    }
  },

  mounted() {
    // Restore status timer from localStorage so it survives page refreshes
    const today = new Date().toISOString().slice(0, 10);
    const savedStatus = localStorage.getItem('c1_status');
    const savedSince  = localStorage.getItem('c1_status_since');
    const savedShiftDay = localStorage.getItem('c1_shift_day');
    // Auto-start shift on login (new day resets break counts)
    if (savedShiftDay !== today) {
      // New day — save yesterday's worked time, then show shift start modal
      this.c1SaveTodayToLog();
      this.c1BathroomCount = 0;
      this.c1CoffeeCount = 0;
      localStorage.setItem('c1_bathroom_count', '0');
      localStorage.setItem('c1_coffee_count', '0');
      // Show blocking modal so agent must confirm shift start
      this.c1ShiftModal = true;
    } else {
      if (savedStatus) this.c1Status = savedStatus;
      this.c1ShiftStartTime = parseInt(localStorage.getItem('c1_shift_start') || String(Date.now()), 10);
      this.c1BathroomCount = parseInt(localStorage.getItem('c1_bathroom_count') || '0', 10);
      this.c1CoffeeCount   = parseInt(localStorage.getItem('c1_coffee_count') || '0', 10);
    }
    this.c1StatusSince = savedSince && savedShiftDay === today ? parseInt(savedSince, 10) : Date.now();
    // Load weekly log
    try { this.c1WeekLog = JSON.parse(localStorage.getItem('c1_week_log') || '[]'); } catch(e) { this.c1WeekLog = []; }
    this._c1StatusInterval = setInterval(this.c1TickStatus, 1000);
    document.addEventListener('keydown', this.handleKeyShortcut);
    document.addEventListener('click', this.c1HideContext);
    // No left sidebar — zero out the offset
    document.documentElement.style.setProperty('--gnm-sw', '0px');
    // Default: show nav panel with Clients sub-menu open (this component = /clients1)
    this.$nextTick(() => { this.c1NavLevel = 'clients'; this.c1SlideOpen = 'nav'; });
    // Apply Smart Sort as default so SC = top, NA = bottom on initial load
    this.c1ApplyDefaultSmartSort();
    // Fire the first fetch with today's NA filter (parent's mounted was skipped via _skipInitialFetch)
    const _initToday = moment().format('YYYY-MM-DD');
    this.filters.last_modified_na = [_initToday, _initToday];
    this.filters.na_all = true;
    this.filters.active = false;
    this.filters.order_by   = this.filters.order_by   || 'id';
    this.filters.sort_order = this.filters.sort_order || 'desc';
    this.fetchClients();
  },

  beforeDestroy() {
    clearInterval(this._c1StatusInterval);
    document.removeEventListener('keydown', this.handleKeyShortcut);
    document.removeEventListener('click', this.c1HideContext);
  },

  // Override created to use Clients1 route name for interval check
  created() {
    // Pre-set today's status range so status overview loads correctly when Status tab opens
    const _initToday = moment().format('YYYY-MM-DD');
    this.c1StatusRange = { from: _initToday, to: _initToday };
    // Tell parent not to fire its generic fetchClients() — we will fire our own with today's filter
    this._skipInitialFetch = true;

    const _keepNav = sessionStorage.getItem('c1keepNav'); if (_keepNav) sessionStorage.removeItem('c1keepNav');
    const _openPanel = sessionStorage.getItem('c1openPanel'); if (_openPanel) sessionStorage.removeItem('c1openPanel');
    if (_openPanel) { this.c1FilterTab = 'status'; this.c1SlideOpen = 'filters'; }
    else if (_keepNav) { this.c1SlideOpen = 'nav'; }
    const tick = () => {
      const d = new Date();
      const hh = String(d.getHours()).padStart(2, "0");
      const mm = String(d.getMinutes()).padStart(2, "0");
      const ss = String(d.getSeconds()).padStart(2, "0");
      this.c1TimeStr = hh + ":" + mm + ":" + ss;
    };
    tick();
    setInterval(tick, 1000);

    // Load today chart data for charts panel
    this.c1LoadTodayChart();
    this.$nextTick(() => this.c1LoadLiveLeaderboard());

    // Load game credits
    apiClientCreator('games/my-scores').get('').then(res => {
      this.c1MiniGameCredits = (res.data && res.data.credits) || 0;
    }).catch(() => { /* silent */ });

    if (!this.CheckUserPermission([5])) {
      this.getCaNextCallsClientsStats();
    }
    if (!this.CheckUserPermission([1, 2])) {
      this.c1LoadSuggestions();
    }
    setInterval(() => {
      if (
        (this.$router.currentRoute.name === "Main" ||
         this.$router.currentRoute.name === "Clients1") &&
        this.auth.user.id
      ) {
        this.getOnlineClientsCountStats();
        this.getCaCommingClientsCountStats();
        this.$store.commit("clients/setRefreshGeneralLiveSmallStatsChart", true);
      }
    }, 120000);
    this.checkBlockInStorage();
    this.$nextTick(() => { this.getQueryParamsToMs = this.getQueryParams(); });
  },

  methods: {
    c1NavToggle(obj, key) { this.$set(obj, key, !obj[key]); },

    c1EnterModule(key, route) {
      this.c1NavLevel = key;
      if (route && this.$route.path !== route) {
        this.c1SlideOpen = null;
        this.$router.push(route).catch(() => {});
      }
    },

    c1NavOpenMod(key, route) {
      const isOpen = this.c1NavMod[key];
      // Close all L1 modules
      Object.keys(this.c1NavMod).forEach(k => { this.c1NavMod[k] = false; });
      // Toggle clicked module
      this.c1NavMod[key] = !isOpen;
      // Navigate to module page if not already there
      if (route && this.$route.path !== route) {
        this.c1SlideOpen = null;
        this.$router.push(route).catch(() => {});
      }
    },
    c1ConfirmShiftStart() {
      const today = new Date().toISOString().slice(0, 10);
      this.c1Status = 'shift';
      this.c1ShiftStartTime = Date.now();
      this.c1StatusSince = Date.now();
      localStorage.setItem('c1_status', 'shift');
      localStorage.setItem('c1_status_since', String(Date.now()));
      localStorage.setItem('c1_shift_start', String(Date.now()));
      localStorage.setItem('c1_shift_day', today);
      this.c1ShiftModal = false;
      this.$nextTick(() => {
        setTimeout(() => {
          const u = this.auth && this.auth.user;
          const name = u && u.first_name ? u.first_name : 'pardner';
          this.c1VikiSay(`Howdy, ${name}! 🤠 Draw fast and shoot straight today!`, 'happy');
        }, 600);
      });
    },

    c1SetStatus(s) {
      if (s === 'bathroom') this.c1BathroomCount++;
      if (s === 'coffee')   this.c1CoffeeCount++;
      this.c1Status = s;
      this.c1StatusSince = Date.now();
      this.c1StatusElapsed = '00:00';
      this.c1StatusMenuOpen = false;
      localStorage.setItem('c1_status', s);
      localStorage.setItem('c1_status_since', String(this.c1StatusSince));
      if (s === 'bathroom') localStorage.setItem('c1_bathroom_count', String(this.c1BathroomCount));
      if (s === 'coffee')   localStorage.setItem('c1_coffee_count',   String(this.c1CoffeeCount));
      if (s === 'end') this.c1SaveTodayToLog();
    },

    async c1SetBreak(onBreak, reason = null) {
      try {
        const token = localStorage.getItem('user-token');
        await fetch('/api/admin/viopa/agent-break', {
          method: 'POST',
          headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ on_break: onBreak, reason }),
        });
      } catch (_) { /* non-critical — status is still saved locally */ }
    },

    c1TickStatus() {
      const fmtSec = (sec) => {
        const h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s = sec % 60;
        return h > 0
          ? `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`
          : `${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
      };
      this.c1StatusElapsed = fmtSec(Math.floor((Date.now() - this.c1StatusSince) / 1000));
      this.c1ShiftElapsed  = fmtSec(Math.floor((Date.now() - this.c1ShiftStartTime) / 1000));
    },
    c1SaveTodayToLog() {
      try {
        const today = new Date().toISOString().slice(0, 10);
        const workedMin = Math.floor((Date.now() - this.c1ShiftStartTime) / 60000);
        const log = JSON.parse(localStorage.getItem('c1_week_log') || '[]').filter(r => r.date !== today);
        log.unshift({ date: today, workedMin: Math.max(0, workedMin), bathroom: this.c1BathroomCount, coffee: this.c1CoffeeCount });
        const trimmed = log.slice(0, 14); // keep 2 weeks
        localStorage.setItem('c1_week_log', JSON.stringify(trimmed));
        this.c1WeekLog = trimmed;
      } catch(e) {}
    },
    c1FmtMin(min) {
      const h = Math.floor(min / 60), m = min % 60;
      return h > 0 ? `${h}h ${m}m` : `${m}m`;
    },
    // Close filter panel when a filter chip is tapped (not search input, not multiselect trigger)
    c1IsSectionOpen(key) {
      return this.c1ChartOpenSections.includes(key);
    },

    c1SwitchSection(key) {
      this.c1ChartSectionDropOpen = false;
      this.c1ChartOpenSections = [key];
      if (key === 'deposits') this.c1LoadChartDeposits();
      else if (key === 'leads') this.c1LoadChartLeads();
      else if (key === 'na') this.c1LoadChartNA();
      else if (key === 'sc') this.c1LoadChartSC();
      else if (key === 'rf') this.c1LoadChartRF();
      else if (key === 'akg') this.c1LoadChartAKG();
      else if (key === 'timeline') this.c1LoadTimeline();
      else if (key === 'overview') this.c1LoadTodayChart();
    },

    c1ToggleSection(key) {
      const isOpen = this.c1ChartOpenSections.includes(key);
      if (isOpen) {
        this.c1ChartOpenSections = [];
      } else {
        this.c1ChartOpenSections = [key];
        if (key === 'deposits') this.c1LoadChartDeposits();
        else if (key === 'leads') this.c1LoadChartLeads();
        else if (key === 'na') this.c1LoadChartNA();
        else if (key === 'sc') this.c1LoadChartSC();
        else if (key === 'rf') this.c1LoadChartRF();
        else if (key === 'akg') this.c1LoadChartAKG();
        else if (key === 'timeline') this.c1LoadTimeline();
        this.$nextTick(() => {
          const body = this.$el && this.$el.querySelector('.c1-panel-charts .c1-sl-body');
          const el = body && body.querySelector('[data-section="' + key + '"]');
          if (el && body) body.scrollTop = el.offsetTop - 4;
        });
      }
    },

    c1LoadTodayChart() {
      this.c1ChartLoading.today = true;
      const params = {};
      if (this.c1StatusRange) {
        params.stats_date_at = this.c1StatusRange.from;
        params.stats_date_to = this.c1StatusRange.to;
      } else {
        const dr = this.c1PresetDates(this.c1ChartDR.overview || 'WEEK');
        if (dr.from) { params.stats_date_at = dr.from; params.stats_date_to = dr.to; }
      }
      apiClientCreator("client/stats/today_chart").get("", { params }).then(res => {
        const raw = res.data || {};
        const d = raw.data || raw;
        const dep = d.DEP !== undefined ? d.DEP : d.DP;
        if (dep !== undefined) this.stats.deposits = dep;
        if (d.LD !== undefined) this.stats.leads = d.LD;
        if (d.NA !== undefined) this.stats.nac = d.NA;
        if (d.NEW !== undefined) this.stats.is_new = d.NEW;
        if (d.RF !== undefined) this.stats.referrals = d.RF;
        if (d.CA !== undefined) this.stats.coming_calls = d.CA;
        this.$set(this, 'c1TodayFull', Object.assign({}, d));
        // Also load accurate SC count (call_status=3 clients) for the SC badge
        apiClientCreator("client/stats/clients/scheduled_calls").get("").then(r => {
          if (r.data !== undefined) this.stats.scheduled_calls_count = r.data;
        }).catch(() => {});
        this.c1TodayLoaded = true;
        this.c1ChartLoading.today = false;
      }).catch(() => {
        this.c1TodayLoaded = true;
        this.c1ChartLoading.today = false;
      });
    },

    c1LoadChartRF() {
      this.c1ChartLoading.rf = true;
      const params = this.c1GetQueryParams();
      const dr = this.c1PresetDates(this.c1ChartDR.rf);
      if (dr.from) { params.deposit_at_from = dr.from; params.deposit_at_to = dr.to; }
      apiClientCreator("client/stats/tag/rf_chart").get("", { params })
        .then(res => {
          const list = Array.isArray(res.data) ? res.data : (res.data && res.data.data) || [];
          this.c1ChartRF = list
            .filter(i => (i.count || 0) > 0)
            .sort((a, b) => b.count - a.count)
            .slice(0, 20)
            .map(r => ({ id: r.user_id, name: r.full_name || '—', count: r.count }));
          this.c1ChartLoading.rf = false;
        }).catch(() => { this.c1ChartLoading.rf = false; });
    },

    c1LoadChartAKG() {
      this.c1ChartLoading.akg = true;
      apiClientCreator("client/stats/akg/30").get("")
        .then(res => {
          const reports = (res.data && res.data.reports) ? res.data.reports : (Array.isArray(res.data) ? res.data : []);
          this.c1ChartAKGData = reports.slice(-30);
          this.c1ChartLoading.akg = false;
        }).catch(() => { this.c1ChartLoading.akg = false; });
    },

    c1ClickRFChart(item) {
      if (this.c1ChartActiveId.rf === item.id) {
        this.c1ChartActiveId.rf = null;
        this.c1ChartActiveFilter = null;
        this.filters.lead_campaigns = [];
      } else {
        this.c1ChartActiveId.rf = item.id;
        this.c1ChartActiveFilter = 'rf';
        this.filters.lead_campaigns = [{ id: item.id }];
      }
      this.debouncedClientsQuery();
    },

    c1FilterPanelClick(e) {
      // Panel stays open after selecting a filter option — user uses back (←) or X to navigate/close
    },

    // Close profile panel when a nav box is tapped
    c1ProfNavClick(e) {
      if (e.target.closest(".c1-dnav-card") || e.target.closest(".c1-dnav-logout-btn")) {
        this.c1SlideOpen = null;
      }
    },

    c1TzTime(tz) {
      if (!this.c1TimeStr) return "--:--";
      try {
        return new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: tz });
      } catch(e) { return "--:--"; }
    },

    // Override: parent's debouncedClientsQuery only runs on route "Main" — extend to "Clients1"
    debouncedClientsQuery: _.debounce(function() {
      const name = this.$router.currentRoute.name;
      if (name === "Main" || name === "Clients1") {
        // Switch to "total" tab (removes active=1) when:
        //  - filters.active is falsy (status-based filtering)
        //  - filters.assigned has selections (agent filter — active=1 adds tier+group filters that exclude valid assignments)
        const savedTab = this.clientsTableSelectedMainTab;
        const hasAgentFilter = this.filters.assigned && this.filters.assigned.length > 0;
        const needsTotal = !this.filters.active || hasAgentFilter;
        if (needsTotal) {
          this.$store.commit("clients/setClientsTableSelectedMainTab", "total");
        }
        const paramsObj = this.getQueryParams();
        console.log('[C1 QUERY]', JSON.stringify(paramsObj, null, 2));
        this.pagination.currentPage = 1;
        this.$store.commit("clients/setGeneralQueryObject", paramsObj);
        this.getQueryParamsToMs = paramsObj;
        this.viewHideResetBtn();
        this.fetchClients();
        // Restore tab immediately — fetchClients already captured params synchronously
        if (needsTotal) {
          this.$store.commit("clients/setClientsTableSelectedMainTab", savedTab);
        }
      }
    }, 700),

    // Override: inject team_id filter into parent's getQueryParams
    getQueryParams() {
      const params = ClientsTableContainer.methods.getQueryParams.call(this);
      if (this.c1TeamFilter !== null) params.team_id = this.c1TeamFilter;
      return params;
    },

    // ---- Helpers for new design ----

    clientInitials(client) {
      return (
        (client.first_name ? client.first_name[0].toUpperCase() : "") +
        (client.last_name ? client.last_name[0].toUpperCase() : "")
      );
    },

    agentInitials(client) {
      if (!client.assignment || !client.assignment.assigned_to) return "—";
      const name = client.assignment.assigned_to.full_name || "";
      const parts = name.trim().split(" ");
      return ((parts[0] ? parts[0][0] : "") + (parts[1] ? parts[1][0] : "")).toUpperCase();
    },

    c1AgentInitials(agent) {
      const name = agent.full_name || agent.name || agent.username || "";
      const parts = name.trim().split(" ");
      return ((parts[0] ? parts[0][0] : "") + (parts[1] ? parts[1][0] : "")).toUpperCase() || "?";
    },

    c1AgentShortName(agent) {
      const name = agent.full_name || agent.name || agent.username || "";
      const parts = name.trim().split(" ");
      return parts[0] || name;
    },

    clientAvatarColor(client) {
      return this.c1AvatarColors[client.id % this.c1AvatarColors.length];
    },

    clientAgentName(client) {
      if (!client.assignment || !client.assignment.assigned_to) return "—";
      return client.assignment.assigned_to.full_name || "—";
    },

    clientStatus(client) {
      if (client.deposits && client.deposits.length > 0) {
        const dep = client.deposits[client.deposits.length - 1];
        return { t: "dp", c: "DP", time: this.fmtShort(dep.created_at), color: "#7C5CFC" };
      }
      if ((client.leads && client.leads.length > 0) || client.leading) {
        const ld = client.leads && client.leads.length > 0 ? client.leads[client.leads.length - 1] : null;
        return { t: "ld", c: "LD", time: ld ? this.fmtShort(ld.created_at) : "", color: "#D4A017" };
      }
      if (client.scheduled_calls && client.scheduled_calls.length > 0 && !client.scheduled_calls[0].ended) {
        const sc = client.scheduled_calls[0];
        return { t: "sc", c: "Scheduled Call", time: this.fmtShort(sc.scheduled_on || sc.call_at), color: "#E8891C" };
      }
      if (client.na && client.na.length > 0) {
        const na = client.na[client.na.length - 1];
        return { t: "na", c: "No Answer", time: this.fmtShort(na.created_at), color: "#E05A3A" };
      }
      if (client.referrals && client.referrals.length > 0) {
        const rf = client.referrals[client.referrals.length - 1];
        return { t: "rf", c: "RF", time: this.fmtShort(rf.created_at), color: "#C75450" };
      }
      if (client.bn && client.bn.length > 0) {
        return { t: "bn", c: "BN", time: "", color: "#7A7067" };
      }
      if (client.is_new) {
        return { t: "ac", c: "NEW", time: this.fmtShort(client.registered_on), color: "#2D9D5E" };
      }
      return { t: "ac", c: "ACT", time: "", color: "#2D9D5E" };
    },

    clientAccentColor(client) {
      return this.clientStatus(client).color;
    },

    latestDeposit(client) {
      if (!client.deposits || client.deposits.length === 0) return {};
      return client.deposits[client.deposits.length - 1];
    },

    fmtShort(dateStr) {
      if (!dateStr) return "";
      const m = moment(dateStr);
      return m.isValid() ? m.format("HH:mm DD/MM") : "";
    },

    c1LocalTime(dateStr, tz) {
      if (!dateStr) return null;
      const d = new Date(dateStr);
      if (isNaN(d)) return null;
      try {
        const opts = { timeZone: tz || 'UTC', hour: '2-digit', minute: '2-digit', hour12: false,
                       weekday: 'short', day: '2-digit', month: 'short', year: 'numeric' };
        const parts = new Intl.DateTimeFormat('en-GB', opts).formatToParts(d);
        const get = type => (parts.find(p => p.type === type) || {}).value || '';
        const hh = parseInt(get('hour'));
        let dayPart, icon;
        if (hh >= 5 && hh < 12)  { dayPart = 'Morning';   icon = '🌅'; }
        else if (hh >= 12 && hh < 17) { dayPart = 'Afternoon'; icon = '☀️'; }
        else if (hh >= 17 && hh < 21) { dayPart = 'Evening';   icon = '🌆'; }
        else                          { dayPart = 'Night';     icon = '🌙'; }
        return {
          time: get('hour') + ':' + get('minute'),
          date: get('day') + ' ' + get('month') + ' ' + get('year'),
          weekday: get('weekday'),
          dayPart,
          icon,
          tzLabel: tz ? tz.split('/').pop().replace(/_/g, ' ') : 'UTC'
        };
      } catch(e) { return null; }
    },

    timeAgo(dateStr) {
      if (!dateStr) return "";
      const diff = Date.now() - new Date(dateStr).getTime();
      if (isNaN(diff)) return "";
      const abs = Math.abs(diff);
      const m = Math.floor(abs / 60000);
      const h = Math.floor(abs / 3600000);
      const d = Math.floor(abs / 86400000);
      const mo = Math.floor(d / 30);
      const yr = Math.floor(d / 365);
      if (yr >= 1) return yr + 'y ago';
      if (mo >= 1) return mo + 'mo ago';
      if (d >= 1) return d + 'd ago';
      if (h >= 1) return h + 'h ago';
      if (m >= 1) return m + 'm ago';
      return 'just now';
    },

    scTimer(sc) {
      const dateStr = sc.scheduled_on || sc.call_at;
      if (!dateStr) return "";
      const d = new Date(dateStr);
      const now = new Date();
      const diff = d.getTime() - now.getTime();
      const abs = Math.abs(diff);
      const hhmm = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
      if (diff < 0) {
        const h = Math.floor(abs / 3600000);
        const m = Math.floor(abs / 60000);
        if (h >= 1) return '⚠ ' + h + 'h late';
        return '⚠ ' + m + 'm late';
      }
      const todayStart = new Date(now); todayStart.setHours(0, 0, 0, 0);
      const tomorrowStart = new Date(todayStart); tomorrowStart.setDate(tomorrowStart.getDate() + 1);
      const afterTomorrow = new Date(tomorrowStart); afterTomorrow.setDate(afterTomorrow.getDate() + 1);
      // relative part
      const diffH = Math.floor(diff / 3600000);
      const diffD = Math.floor(diff / 86400000);
      let rel;
      if (diffH < 1) rel = Math.floor(diff / 60000) + 'm';
      else if (diffH < 24) rel = diffH + 'h';
      else rel = diffD + 'd';
      // date label
      let label;
      if (d >= todayStart && d < tomorrowStart) label = 'Today ' + hhmm;
      else if (d >= tomorrowStart && d < afterTomorrow) label = 'Tomorrow ' + hhmm;
      else {
        const daysBetween = Math.floor(diff / 86400000);
        const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        if (daysBetween < 7) label = dayNames[d.getDay()] + ' ' + hhmm;
        else label = d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }) + ' ' + hhmm;
      }
      return label + ' · ' + rel;
    },

    clientCountryName(client) {
      if (!client.country) return "";
      if (typeof client.country === "object") return client.country.name || "";
      try {
        const parsed = JSON.parse(client.country);
        return parsed.name || client.country;
      } catch (e) {
        return client.country;
      }
    },

    donArc(val, total) {
      if (!total || !val) return 0;
      return Math.round((val / total) * 88);
    },

    pct(val, total) {
      if (!total || !val) return 0;
      return Math.round((val / total) * 100);
    },

    goPage(page) {
      if (page < 1 || page > this.pagination.lastPage) return;
      this.pagination.currentPage = page;
      this.fetchClients();
    },

    // Quick filter helpers
    filterByNew() {
      this.resetFiltersOnly();
      this.filters.is_new = true;
      this.debouncedClientsQuery();
    },
    filterByOnline() {
      this.resetFiltersOnly();
      this.filters.online = true;
      this.debouncedClientsQuery();
    },
    filterByScheduledCalls() {
      this.resetFiltersOnly();
      this.filters.scheduled_calls = true;
      this.debouncedClientsQuery();
    },
    c1ApplyStatusFilter(row) {
      // Use the same date range the KPI counter uses
      let from, to;
      if (this.c1StatusRange && this.c1StatusRange.from) {
        from = this.c1StatusRange.from;
        to   = this.c1StatusRange.to || this.c1StatusRange.from;
      } else {
        const dr = this.c1PresetDates('WEEK');
        from = dr.from;
        to   = dr.to;
      }
      // Reset all current filters (no spurious query — we fire debouncedClientsQuery below)
      this.resetFiltersOnly();
      // Use date-range params — these use whereHas(relation, date range) on the backend,
      // which is the same logic the counter uses. Boolean flags (na=1, leads=1, etc.) use
      // strict exclusion rules that don't match the counter.
      const filterMap = {
        DEP:   () => { this.filters.deposit_at          = [from, to]; },
        LD:    () => { this.filters.last_modified_leads = [from, to]; },
        NA:    () => { this.filters.last_modified_na    = [from, to]; },
        CA:    () => { this.filters.scheduled_call_to   = [from, to]; },
        RF:    () => { this.filters.last_referral       = [from, to]; },
        BN:    () => { this.filters.last_modified_bn    = [from, to]; },
        NI:    () => { this.filters.not_interested      = true; },
        NEW:   () => { this.filters.is_new              = true; this.filters.registered_on = [from, to]; },
        REG:   () => { this.filters.registered_on       = [from, to]; },
        'TR-LV': () => { this.filters.transfer          = true; },
        'TR-ON': () => { this.filters.transfer          = true; },
        'CC-DEC': () => { this.filters.cc_decline_clients = true; this.filters.deposit_at = [from, to]; },
        'ENDED': () => { this.filters.ended             = true; },
        'NU':    () => { this.filters.is_new = true; this.filters.registered_on = [from, to]; },
      };
      if (filterMap[row.key]) filterMap[row.key]();
      // Don't send active=1 — status filters include all clients of that type
      this.filters.active = false;
      // Backend applySort crashes on empty order_by/sort_order when date-range-only params
      // are sent (no boolean flag to trigger a specific sort branch). Always provide valid values.
      this.filters.order_by = 'id';
      this.filters.sort_order = 'desc';
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
      this.c1SlideOpen = null;
      this.c1TopTab = null;
    },
    resetAllFilters() {
      Object.keys(this.filters).forEach(k => {
        const v = this.filters[k];
        if (typeof v === "boolean") this.filters[k] = false;
        else if (Array.isArray(v)) this.filters[k] = [];
        else if (v !== null && typeof v === "object") { /* skip */ }
        else if (typeof v === "string") this.filters[k] = "";
        else this.filters[k] = null;
      });
      this.filters.active = true;
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
    },
    resetFiltersOnly() {
      // Save agent selection — agents persist across status/date/type filter changes
      const savedAssigned = this.filters.assigned ? [...this.filters.assigned] : [];
      Object.keys(this.filters).forEach(k => {
        const v = this.filters[k];
        if (typeof v === "boolean") this.filters[k] = false;
        else if (Array.isArray(v)) this.filters[k] = [];
        else if (v !== null && typeof v === "object") { /* skip */ }
        else if (typeof v === "string") this.filters[k] = "";
        else this.filters[k] = null;
      });
      this.filters.active = true;
      this.filters.assigned = savedAssigned;
      this.pagination.currentPage = 1;
      // NOTE: does NOT call debouncedClientsQuery — caller is responsible
    },

    c1FullReset() {
      this.resetAllFilters();
      this.c1DateFilter = 'all';
      this.c1PurpleTimeActive = false;
      this.resetSorting();
      this.c1StatusRange = null;
      this.c1LoadTodayChart();
      // Re-apply Smart Sort as default so NA/inactive clients sink to bottom
      this.c1ApplyDefaultSmartSort();
    },

    c1ApplyDefaultSmartSort() {
      this.c1SmartSort = 'sc_first';
      this.filters.order_by = 'call_status';
      this.filters.sort_order = 'asc';
      this.filters.secondary_order = 'last_scheduled_on';
    },

    c1ApplySortSelect(val) {
      switch (val) {
        case 'smart':     this.resetAllFilters(); this.c1ApplyDefaultSmartSort(); break;
        case 'date_up':   this.c1SmartSort = null; this.applyAmountSorting('up'); break;
        case 'date_down': this.c1SmartSort = null; this.applyAmountSorting('down'); break;
        case 'mod_up':    this.c1SmartSort = null; this.applyModifiedSorting('up'); break;
        case 'mod_down':  this.c1SmartSort = null; this.applyModifiedSorting('down'); break;
        case 'az':        this.c1SmartSort = null; this.applyAlphaSorting('up'); break;
        case 'za':        this.c1SmartSort = null; this.applyAlphaSorting('down'); break;
      }
    },

    c1OpenLive() {
      this.c1SlideOpen = 'charts';
      this.c1ChartOpenSections = ['live'];
    },

    c1ToggleUnassigned() {
      this.$set(this.filters, 'unassigned', !this.filters.unassigned);
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
    },

    onSmartCalDaySelected({ date, dateTo, type, fromParam }) {
      console.log('[C1 CAL]', { date, dateTo, type, fromParam });
      const from = date;
      const to   = dateTo || date;
      // Sync status numbers to the selected range (always)
      this.c1StatusRange = { from, to };
      this.c1LoadTodayChart();
      // When fromParam=null (view switch / prev-next navigation), only update status counts.
      // Do NOT reset filters or re-query the client list — the user's current filter must stay.
      if (!fromParam) return;
      // Map calendar chip fromParam → filters array key (getQueryParams serializes arrays, not flat keys)
      const paramToArrayKey = {
        last_modified_na_from:   'last_modified_na',
        last_modified_lead_from: 'last_modified_leads',
        deposit_at_from:         'deposit_at',
        scheduled_call_to_from:  'scheduled_call_to',
        registered_on_from:      'registered_on',
        last_modified_bn_from:   'last_modified_bn',
        last_modified_ni_from:   'last_modified_ni',
        last_referral_from:      'last_referral',
      };
      // Reset filters without firing a spurious query
      this.resetFiltersOnly();
      const arrayKey = paramToArrayKey[fromParam];
      if (arrayKey) this.filters[arrayKey] = [from, to];
      // For NA filter: use na_all=true so backend uses whereDate (not the broken whereLatest path)
      // This lets any role's NAs appear in the calendar view — admin logging on agent's client shows up
      if (fromParam === 'last_modified_na_from') this.filters.na_all = true;
      // Don't restrict to active=1 — calendar filters should include all clients
      this.filters.active = false;
      // Provide valid sort to prevent backend applySort crash on empty sort_order
      this.filters.order_by   = 'id';
      this.filters.sort_order = 'desc';
      this.debouncedClientsQuery();
      this.c1SlideOpen = null;
    },

    c1ToggleTag(cid, type, idx) {
      const t = this.c1OpenTag;
      if (t && t.cid === cid && t.type === type && t.idx === idx) {
        this.c1OpenTag = null;
      } else {
        this.c1OpenTag = { cid, type, idx };
      }
    },

    c1IsTagOpen(cid, type, idx) {
      const t = this.c1OpenTag;
      return t && t.cid === cid && t.type === type && t.idx === idx;
    },

    // ---- Main-tab quick filters (BN, NI) ----
    c1FilterBN() {
      this.resetFiltersOnly();
      this.filters.bad_number = true;
      this.filters.active     = false;
      this.filters.order_by   = 'id';
      this.filters.sort_order = 'desc';
      this.debouncedClientsQuery();
    },

    c1FilterNI() {
      this.resetFiltersOnly();
      this.filters.not_interested = true;
      this.filters.active         = false;
      this.filters.order_by       = 'id';
      this.filters.sort_order     = 'desc';
      this.debouncedClientsQuery();
    },

    c1FilterByHour(row, hh) {
      const h = parseInt(hh, 10);
      this.c1ApplyStatusFilter(row); // applies date-range filter for this row type
      const hourMap = {
        'DEP': () => { this.filters.deposit_at_hour = h; },
        'NA':  () => { this.filters.last_na_hour = h; },
        'LD':  () => { this.filters.last_lead_hour = h; },
      };
      if (hourMap[row.key]) {
        hourMap[row.key]();
        this.debouncedClientsQuery(); // re-trigger with hour set
      }
    },

    // ---- Filter slide helpers ----
    c1ToggleFilter(key) {
      this.filters[key] = !this.filters[key];
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
    },

    c1OpenLead(client) {
      this.c1CardExpanded = client.id;
    },

    c1ToggleCountry(country) {
      if (!this.filters.countries) this.filters.countries = [];
      const idx = this.filters.countries.findIndex(c => c.id === country.id);
      if (idx >= 0) {
        this.filters.countries.splice(idx, 1);
      } else {
        this.filters.countries.push(country);
      }
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
    },

    c1StatusAgentPct(ag) {
      return Math.round(((ag.client_assignments_count || 0) / this.c1StatusAgentMax) * 100);
    },

    c1StatusCountryPct(co) {
      return Math.round((co.count / this.c1StatusCountryMax) * 100);
    },

    c1ToggleAssign(agentId) {
      if (!this.filters.assigned) this.filters.assigned = [];
      const idx = this.filters.assigned.findIndex(a => (a.id || a) === agentId);
      if (idx > -1) {
        this.filters.assigned.splice(idx, 1);
      } else {
        this.filters.assigned.push({ id: agentId });
      }
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
    },

    c1ToggleComingCalls() {
      this.resetFiltersOnly();
      this.filters.coming_calls = true;
      this.filters.scheduled_calls = true;
      this.debouncedClientsQuery();
    },

    c1ToggleMissedCalls() {
      this.resetFiltersOnly();
      this.filters.missed_calls = true;
      this.filters.scheduled_calls = true;
      this.debouncedClientsQuery();
    },

    c1ToggleTodayCalls() {
      this.resetFiltersOnly();
      this.filters.today_calls = true;
      this.filters.scheduled_calls = true;
      this.debouncedClientsQuery();
    },

    c1OpenPicker(event, clientId) {
      if (this.c1TagPicker.cid === clientId) {
        this.c1TagPicker = { cid: null, type: null, loading: false };
      } else {
        this.c1TagPicker = { cid: clientId, type: null, loading: false };
      }
    },

    c1RoleName(roleId) {
      const roles = {
        1: 'Owner', 2: 'Owner', 3: 'Floor Manager', 4: 'Shift Manager',
        5: 'Chat', 6: 'Team Leader', 7: 'Sales', 8: 'Support',
        9: 'Content', 10: 'Office', 11: 'Instructor', 12: 'Dev',
        13: 'Finance', 14: 'Personal Assistant',
      };
      return roles[roleId] || (roleId ? 'Role ' + roleId : '');
    },

    c1BnLabel(s) {
      const map = { 1: "Disconnected", 2: "Wrong Number", 3: "Not Dialing", 4: "Missing Prefix", 5: "Incorrect Number", 6: "Invalid Number", 7: "Number Disconnected" };
      return map[s.id] || s.name;
    },

    c1TpToggle(type) {
      this.c1TagPicker.type = this.c1TagPicker.type === type ? null : type;
    },

    c1ClosePicker() {
      this.c1TagPicker = { cid: null, type: null, loading: false };
      this.c1AssignSearch = '';
    },

    c1ViopaTimeSlot(createdAt) {
      if (!createdAt) return '';
      try {
        const h = new Date(createdAt).getHours();
        if (h >= 5  && h < 12) return 'morning';
        if (h >= 12 && h < 17) return 'afternoon';
        if (h >= 17 && h < 21) return 'evening';
        return 'night';
      } catch(e) { return ''; }
    },

    c1OpenAssignSlide(client) {
      this.c1AssignSearch = '';
      this.c1ViopaScores = {};
      this.c1ViopaAvoidIds = [];
      this.c1ViopaLoadingAssign = true;
      this.c1AssignSlide = { open: true, cid: client.id, loading: false };
      this.c1SlideProfile = null;

      const country     = (client.country && client.country.alpha2) || client.country_code || '';
      const campaign    = client.campaign_aaid || '';
      const keyword     = client.keyword || '';
      const device      = client.device || '';
      const timeSlot    = this.c1ViopaTimeSlot(client.created_at);
      const languageId  = (client.language && client.language.id) || client.language_id || 0;
      const abid        = client.campaign_abid || '';
      const placement   = client.placement || '';
      const hasReferral = !!(client.referrals && client.referrals.length);
      const _days       = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
      const dayOfWeek   = client.created_at ? _days[new Date(client.created_at).getDay()] : '';

      const params = new URLSearchParams({
        country,
        ...(campaign    ? { campaign }                    : {}),
        ...(keyword     ? { keyword }                     : {}),
        ...(device      ? { device }                      : {}),
        ...(timeSlot    ? { time_slot: timeSlot }          : {}),
        ...(languageId  ? { language_id: languageId }      : {}),
        ...(abid        ? { abid }                        : {}),
        ...(placement   ? { placement }                   : {}),
        ...(hasReferral ? { has_referral: 1 }             : {}),
        ...(dayOfWeek   ? { day_of_week: dayOfWeek }      : {}),
      });

      fetch('/api/admin/viopa/transfer-score?' + params.toString(), {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') }
      })
        .then(r => r.json())
        .then(d => {
          const data = d.data || d;
          const scores = {};
          (data.all || data.top || []).forEach(a => {
            scores[a.agent_id] = {
              score: a.combined_score_pct !== undefined ? a.combined_score_pct : a.score,
              is_golden_buzzer: !!a.is_golden_buzzer,
              availability: a.availability || null,
              availability_reason: a.availability_reason || null,
              score_breakdown: a.score_breakdown || {},
            };
          });
          this.c1ViopaScores = scores;
          this.c1ViopaAvoidIds = (data.avoid || []).map(a => a.agent_id);
          this.c1SlideProfile = { country, campaign, keyword, device, time_slot: timeSlot, language_id: languageId };
        })
        .catch(() => {})
        .finally(() => { this.c1ViopaLoadingAssign = false; });
    },

    c1CloseAssignSlide() {
      this.c1AssignSlide = { open: false, cid: null, loading: false };
      this.c1AssignSearch = '';
    },

    c1LoadBulkViopaScore() {
      const ids = this.c1SelectedClients;
      if (!ids || !ids.length) return;
      // Use the first selected client as the reference profile
      const client = (this.clients || []).find(c => c.id === ids[0]);
      if (!client) return;
      this.c1BulkViopaLoading = true;
      const country     = (client.country && client.country.alpha2) || client.country_code || '';
      const campaign    = client.campaign_aaid || '';
      const keyword     = client.keyword || '';
      const device      = client.device || '';
      const timeSlot    = this.c1ViopaTimeSlot(client.created_at);
      const languageId  = (client.language && client.language.id) || client.language_id || 0;
      const abid        = client.campaign_abid || '';
      const placement   = client.placement || '';
      const hasReferral = !!(client.referrals && client.referrals.length);
      const _days2      = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
      const dayOfWeek   = client.created_at ? _days2[new Date(client.created_at).getDay()] : '';
      this.c1BulkViopaProfile = { country, campaign, keyword, device, time_slot: timeSlot, language_id: languageId };
      const params = new URLSearchParams({
        country,
        ...(campaign    ? { campaign }                    : {}),
        ...(keyword     ? { keyword }                     : {}),
        ...(device      ? { device }                      : {}),
        ...(timeSlot    ? { time_slot: timeSlot }          : {}),
        ...(languageId  ? { language_id: languageId }      : {}),
        ...(abid        ? { abid }                        : {}),
        ...(placement   ? { placement }                   : {}),
        ...(hasReferral ? { has_referral: 1 }             : {}),
        ...(dayOfWeek   ? { day_of_week: dayOfWeek }      : {}),
      });
      fetch('/api/admin/viopa/score?' + params.toString(), {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') }
      })
        .then(r => r.json())
        .then(d => {
          const data = d.data || d;
          const scores = {};
          (data.all || data.top || []).forEach(a => {
            scores[a.agent_id] = {
              score: a.score,
              is_golden_buzzer: !!a.is_golden_buzzer,
              score_breakdown: a.score_breakdown || {},
            };
          });
          this.c1BulkViopaScores = scores;
          this.c1BulkViopaAvoidIds = (data.avoid || []).map(a => a.agent_id);
        })
        .catch(() => {})
        .finally(() => { this.c1BulkViopaLoading = false; });
    },

    // Generate human-readable "why" chips for a given agent in context of current bulk profile
    c1ViopaReasonChips(agentId) {
      const entry   = this.c1BulkViopaScores[agentId] || this.c1ViopaScores[agentId];
      if (!entry) return [];
      const bd      = entry.score_breakdown || {};
      const profile = this.c1BulkViopaProfile || this.c1SlideProfile || {};
      const chips   = [];
      if (entry.is_golden_buzzer) {
        chips.push({ icon: '⭐', text: 'Golden Buzzer', style: 'gold' });
      }
      const countryPts = (bd.country || 0) + (bd.country_agent || 0);
      if (countryPts >= 6) chips.push({ icon: '🌍', text: profile.country || 'Country', style: 'blue' });
      const campPts = (bd.campaign || 0) + (bd.campaign_agent || 0);
      if (campPts >= 4)   chips.push({ icon: '📊', text: 'Campaign', style: 'green' });
      if ((bd.device || 0) >= 4) {
        const isM = profile.device && profile.device.toLowerCase().includes('mobile');
        chips.push({ icon: isM ? '📱' : '💻', text: isM ? 'Mobile' : 'Desktop', style: 'purple' });
      }
      if ((bd.time_slot || 0) >= 4) {
        const slotIcon = { morning: '🌅', afternoon: '☀️', evening: '🌆', night: '🌙' }[profile.time_slot] || '⏰';
        chips.push({ icon: slotIcon, text: profile.time_slot || 'Time', style: 'orange' });
      }
      if ((bd.keyword || 0) >= 4 && profile.keyword) {
        chips.push({ icon: '🔑', text: profile.keyword.slice(0, 10), style: 'teal' });
      }
      if ((bd.language || 0) >= 4) {
        chips.push({ icon: '🗣️', text: 'Language', style: 'indigo' });
      }
      return chips;
    },

    // Top-3 scored agents for the single-lead reassign popup
    c1AssignSlideSuggestions() {
      const scores  = this.c1ViopaScores;
      const avoidSet = new Set(this.c1ViopaAvoidIds);
      const list = this.$store.state.clients.salesPersonList || [];
      return list
        .filter(a => scores[a.id] && !avoidSet.has(a.id) && scores[a.id].availability !== 'OFF' && scores[a.id].availability !== 'OFF_SHIFT' && scores[a.id].availability !== 'BLOCKED')
        .sort((a, b) => {
          const sa = scores[a.id], sb = scores[b.id];
          if (sa.is_golden_buzzer && !sb.is_golden_buzzer) return -1;
          if (!sa.is_golden_buzzer && sb.is_golden_buzzer) return 1;
          return sb.score - sa.score;
        })
        .slice(0, 3);
    },

    // Top-3 scored agents for the bulk suggestions strip
    c1BulkViopaSuggestions() {
      const scores = this.c1BulkViopaScores;
      const avoidSet = new Set(this.c1BulkViopaAvoidIds);
      const list = this.$store.state.clients.salesPersonList || [];
      return list
        .filter(a => scores[a.id] && !avoidSet.has(a.id))
        .sort((a, b) => {
          const sa = scores[a.id], sb = scores[b.id];
          if (sa.is_golden_buzzer && !sb.is_golden_buzzer) return -1;
          if (!sa.is_golden_buzzer && sb.is_golden_buzzer) return 1;
          return sb.score - sa.score;
        })
        .slice(0, 3);
    },

    async c1DoInlineAssign(agent, client) {
      if (!agent || !client) return;
      try {
        const req = apiClientCreator(`client/assign/${agent.id}`);
        await req.put('', { client_id: client.id, from_group: 'clients' });
        this.c1InlineAssignCid = null;
        this.c1InlineAssignSearch = '';
        this.c1VikiSay('✓ Assigned to ' + (agent.full_name || agent.name));
        this.fetchClients();
      } catch (e) {
        this.c1VikiSay('Assignment failed', 'error');
      }
    },

    async c1AssignFromSlide(agent) {
      const client = this.c1AssignSlideClient;
      if (!agent || !client) return;
      this.c1AssignSlide.loading = true;
      try {
        const req = apiClientCreator(`client/assign/${agent.id}`);
        await req.put('', { client_id: client.id, from_group: 'clients' });
        this.c1CloseAssignSlide();
        this.c1VikiSay('✓ Assigned to ' + (agent.full_name || agent.name));
        this.fetchClients();
      } catch (e) {
        this.c1VikiSay('Assignment failed', 'error');
        this.c1AssignSlide.loading = false;
      }
    },

    async c1AssignClient(agent, client) {
      if (!agent || !client) return;
      this.c1TagPicker.loading = true;
      try {
        const req = apiClientCreator(`client/assign/${agent.id}`);
        await req.put('', { client_id: client.id, from_group: 'clients' });
        this.c1ClosePicker();
        this.c1ShowToast('✓ Assigned to ' + (agent.full_name || agent.name));
        this.fetchClients();
      } catch (e) {
        this.c1ShowToast('Assignment failed', 'var(--c1-na)');
        this.c1TagPicker.loading = false;
      }
    },

    c1ToggleSelect(clientId) {
      const idx = this.c1SelectedClients.indexOf(clientId);
      if (idx === -1) this.c1SelectedClients.push(clientId);
      else this.c1SelectedClients.splice(idx, 1);
    },
    c1SelectAll() {
      this.c1SelectedClients = (this.clients || []).map(c => c.id);
    },
    c1ClearSelection() {
      this.c1SelectedClients = [];
      this.c1BulkSearch = '';
      this.c1BulkAgentOpen = false;
    },
    c1BulkBlur() {
      setTimeout(() => { this.c1BulkAgentOpen = false; }, 200);
    },
    async c1BulkAssign(agent) {
      if (!agent || !this.c1SelectedClients.length) return;
      const count = this.c1SelectedClients.length;
      try {
        const req = apiClientCreator(`client/assign/bulk/${agent.id}`);
        await req.post('', { clients: this.c1SelectedClients, from_group: 'clients' });
        this.c1ClearSelection();
        this.c1VikiSay(`✓ ${count} clients assigned to ${agent.full_name || agent.name}`);
        this.fetchClients();
      } catch(e) {
        this.c1VikiSay('Bulk assignment failed', 'error');
      }
    },

    // Smart Auto-Assign: score each selected lead individually, assign to its own best agent
    async c1SmartAutoAssign() {
      const ids = [...this.c1SelectedClients];
      if (!ids.length || this.c1SmartAssignRunning) return;

      this.c1SmartAssignRunning = true;
      this.c1SmartAssignProgress = { done: 0, total: ids.length, errors: 0 };

      const allClients = this.clients || [];
      const token = localStorage.getItem('user-token') || '';

      for (const clientId of ids) {
        const client = allClients.find(c => c.id === clientId);
        if (!client) {
          this.c1SmartAssignProgress.done++;
          continue;
        }

        try {
          // Build this lead's exact signal profile
          const country     = (client.country && client.country.alpha2) || client.country_code || 'XX';
          const campaign    = client.campaign_aaid || '';
          const keyword     = client.keyword || '';
          const device      = client.device || '';
          const timeSlot    = this.c1ViopaTimeSlot(client.created_at);
          const languageId  = (client.language && client.language.id) || client.language_id || 0;
          const abid        = client.campaign_abid || '';
          const placement   = client.placement || '';
          const hasReferral = !!(client.referrals && client.referrals.length);
          const _days3      = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
          const dayOfWeek   = client.created_at ? _days3[new Date(client.created_at).getDay()] : '';

          const params = new URLSearchParams({ country });
          if (campaign)    params.append('campaign', campaign);
          if (keyword)     params.append('keyword', keyword);
          if (device)      params.append('device', device);
          if (timeSlot)    params.append('time_slot', timeSlot);
          if (languageId)  params.append('language_id', languageId);
          if (abid)        params.append('abid', abid);
          if (placement)   params.append('placement', placement);
          if (hasReferral) params.append('has_referral', 1);
          if (dayOfWeek)   params.append('day_of_week', dayOfWeek);

          // Score this individual lead
          const resp = await fetch('/api/admin/viopa/score?' + params.toString(), {
            headers: { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
          });
          const json = await resp.json();

          let bestAgentId = null;
          if (json.success && json.data && json.data.top && json.data.top.length) {
            bestAgentId = json.data.top[0].agent_id;
          }

          if (bestAgentId) {
            const req = apiClientCreator(`client/assign/${bestAgentId}`);
            await req.put('', { client_id: clientId, from_group: 'clients' });
          } else {
            // No Viopa match — count as skipped (not an error)
            this.c1SmartAssignProgress.errors++;
          }

        } catch (e) {
          this.c1SmartAssignProgress.errors++;
        }

        this.c1SmartAssignProgress.done++;
      }

      const { done, total, errors } = this.c1SmartAssignProgress;
      const assigned = total - errors;
      this.c1SmartAssignRunning = false;
      this.c1SmartAssignProgress = null;
      this.c1ClearSelection();
      this.c1VikiSay(
        errors === 0
          ? `⚡ ${assigned} leads smart-assigned by Viopa`
          : `⚡ ${assigned} assigned · ${errors} skipped (no match)`
      );
      this.fetchClients();
    },

    c1LoadNavSection(type) {
      if (this.c1NavBdLoading[type]) return;
      this.$set(this.c1NavBdLoading, type, true);
      const token = localStorage.getItem('user-token') || '';
      const headers = { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
      const dr = this.c1PresetDates(this.c1GlobalDR || 'ALL');
      const from = dr.from || '2000-01-01';
      const to   = dr.to   || new Date().toISOString().slice(0, 10);
      const parseList = res => {
        const raw = Array.isArray(res) ? res : (res.data || []);
        return raw.map(r => ({ id: r.id, name: r.title || '—', count: Array.isArray(r.count) ? r.count[0] : (r.count || 0) }))
          .filter(u => u.count > 0).sort((a,b) => b.count - a.count).slice(0, 20);
      };
      const cfg = {
        dep: {
          agent:  `client/stats/multiselect/deposits/users?deposit_at_from=${from}&deposit_at_to=${to}`,
          broker: `client/stats/multiselect/deposits/brokers?deposit_at_from=${from}&deposit_at_to=${to}`,
          chart:  `client/stats/calendar/dep/days?deposit_at_from=${from}&deposit_at_to=${to}`,
        },
        ld: {
          agent:  `client/stats/multiselect/leads/users?registered_on_from=${from}&registered_on_to=${to}`,
          broker: `client/stats/multiselect/leads/brokers?registered_on_from=${from}&registered_on_to=${to}`,
          chart:  `client/stats/calendar/lead_tag/days?last_modified_lead_from=${from}&last_modified_lead_to=${to}`,
        },
        na: {
          agent:  `client/stats/multiselect/no_answer/users?registered_on_from=${from}&registered_on_to=${to}`,
          broker: null,
          chart:  `client/stats/calendar/na_tag/days?last_modified_na_from=${from}&last_modified_na_to=${to}`,
        },
        sc: {
          agent:  `client/stats/multiselect/call_again/users?registered_on_from=${from}&registered_on_to=${to}`,
          broker: null,
          chart:  `client/stats/calendar/sc_tag/days?last_modified_sc_from=${from}&last_modified_sc_to=${to}`,
        },
        rf: {
          agent:  `client/stats/multiselect/referral/users?last_referral_from=${from}&last_referral_to=${to}`,
          broker: `client/stats/multiselect/referral/brokers?last_referral_from=${from}&last_referral_to=${to}`,
          chart:  `client/stats/calendar/rf_tag/days?last_referral_from=${from}&last_referral_to=${to}`,
        },
      }[type];
      if (!cfg) { this.$set(this.c1NavBdLoading, type, false); return; }
      const fetchJ = url => url ? fetch('/api/' + url, { headers }).then(r => r.json()).catch(() => null) : Promise.resolve(null);
      Promise.all([
        fetchJ(cfg.agent).then(r => r ? parseList(r) : []),
        fetchJ(cfg.broker).then(r => r ? parseList(r) : []),
        fetchJ(cfg.chart).then(res => {
          if (!res) return [];
          const arr = Array.isArray(res) ? res : (res.data || []);
          return arr.map(d => ({ label: (d.date || '').slice(5), val: d.count || 0 })).filter(d => d.label).slice(-30);
        }),
      ]).then(([agents, brokers, chart]) => {
        this.$set(this.c1NavBdAgents,  type, agents);
        this.$set(this.c1NavBdBrokers, type, brokers);
        this.$set(this.c1NavBdChart,   type, chart);
        this.$set(this.c1NavBdLoading, type, false);
      });
    },

    c1GlanceBarPct(u) {
      if (!this.c1GlanceUsers.length) return 0;
      const max = Math.max(1, ...this.c1GlanceUsers.map(x => x.count));
      return Math.round((u.count / max) * 100);
    },
    c1BrokerBarPct(u) {
      if (!this.c1GlanceBrokers.length) return 0;
      const max = Math.max(1, ...this.c1GlanceBrokers.map(x => x.count));
      return Math.round((u.count / max) * 100);
    },
    c1GlanceDayHourPct(day, h) {
      if (!day.hours) return 0;
      const vals = Object.values(day.hours);
      const max = Math.max(1, ...vals);
      const hh = String(h).padStart(2, '0');
      return Math.round(((day.hours[hh] || 0) / max) * 100);
    },
    c1GlanceHourPct(h) {
      const agg = this.c1GlanceHoursAgg;
      const vals = Object.values(agg);
      const max = Math.max(1, ...vals);
      const hh = String(h).padStart(2, '0');
      return Math.round(((agg[hh] || 0) / max) * 100);
    },
    c1GlanceHourPctByKey(hh) {
      const agg = this.c1GlanceHoursAgg;
      const vals = Object.values(agg);
      const max = Math.max(1, ...vals);
      return Math.round(((agg[hh] || 0) / max) * 100);
    },

    c1ToggleGlance(row) {
      if (!row.breakdown) { row.click && row.click(); return; }
      if (this.c1GlanceOpen === row.key) { this.c1GlanceOpen = null; return; }
      this.c1GlanceOpen = row.key;
      this.c1GlanceOpenRow = row;
      this.c1GlanceUsers = [];
      this.c1GlanceBrokers = [];
      this.c1GlanceDays = [];
      this.c1GlanceTab = 'hours';
      this.c1GlanceLoading = true;
      this.c1GlanceDaysLoading = true;
      const token = localStorage.getItem('user-token') || '';
      let from, to;
      if (this.c1StatusRange && this.c1StatusRange.from) {
        from = this.c1StatusRange.from;
        to   = this.c1StatusRange.to || this.c1StatusRange.from;
      } else {
        const dr = this.c1PresetDates(this.c1ChartDR.overview || this.c1GlobalDR || 'WEEK');
        from = dr.from || '2000-01-01';
        to   = dr.to   || new Date().toISOString().slice(0, 10);
      }
      const headers = { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
      const parseList = res => {
        const raw = Array.isArray(res) ? res : (res.data || []);
        return raw
          .map(r => ({ id: r.id, name: r.title || '—', count: Array.isArray(r.count) ? r.count[0] : (r.count || 0) }))
          .filter(u => u.count > 0)
          .sort((a, b) => b.count - a.count)
          .slice(0, 20);
      };
      // agent endpoint for each breakdown key — use correct date field per status type
      const agentCfgs = {
        dep: { url: 'client/stats/multiselect/deposits/users',   params: `deposit_at_from=${from}&deposit_at_to=${to}` },
        ld:  { url: 'client/stats/multiselect/leads/users',      params: `last_modified_lead_from=${from}&last_modified_lead_to=${to}` },
        na:  { url: 'client/stats/multiselect/no_answer/users',  params: `last_modified_na_from=${from}&last_modified_na_to=${to}` },
        sc:  { url: 'client/stats/multiselect/call_again/users', params: `scheduled_call_to_from=${from}&scheduled_call_to_to=${to}` },
        rf:  { url: 'client/stats/multiselect/referral/users',   params: `last_referral_from=${from}&last_referral_to=${to}` },
        tr:    { url: 'client/stats/multiselect/transfer/users/0',       params: `registered_on_from=${from}&registered_on_to=${to}` },
        tron:  { url: 'client/stats/multiselect/transfer/users/1',       params: `registered_on_from=${from}&registered_on_to=${to}` },
        bn:    { url: 'client/stats/multiselect/bad_number',              params: `last_modified_bn_from=${from}&last_modified_bn_to=${to}` },
        ni:    { url: 'client/stats/multiselect/not_interested',          params: `last_modified_ni_from=${from}&last_modified_ni_to=${to}` },
        reg:   { url: 'client/stats/multiselect/assignments/assignments', params: `registered_on_from=${from}&registered_on_to=${to}` },
        newl:  { url: 'client/stats/multiselect/assignments/assignments', params: `registered_on_from=${from}&registered_on_to=${to}` },
        nr:    { url: 'client/stats/multiselect/no_answer/users',         params: `last_modified_na_from=${from}&last_modified_na_to=${to}` },
        ccdec: { url: 'client/stats/multiselect/deposits/status',         params: `deposit_at_from=${from}&deposit_at_to=${to}` },
        ended: { url: 'client/stats/multiselect/assignments/assignments', params: `registered_on_from=${from}&registered_on_to=${to}` },
        nu:    { url: 'client/stats/multiselect/assignments/assignments', params: `registered_on_from=${from}&registered_on_to=${to}` },
        sms:   { url: 'client/stats/multiselect/sms/status',             params: `registered_on_from=${from}&registered_on_to=${to}` },
      };
      // broker endpoint (only for dep, ld, rf)
      const brokerCfgs = {
        dep: { url: 'client/stats/multiselect/deposits/brokers', params: `deposit_at_from=${from}&deposit_at_to=${to}` },
        ld:  { url: 'client/stats/multiselect/leads/brokers',    params: `last_modified_lead_from=${from}&last_modified_lead_to=${to}` },
        rf:  { url: 'client/stats/multiselect/referral/brokers', params: `last_referral_from=${from}&last_referral_to=${to}` },
      };
      const agentCfg = agentCfgs[row.breakdown];
      if (!agentCfg) { this.c1GlanceLoading = false; this.c1GlanceDaysLoading = false; return; }
      const brokerCfg = brokerCfgs[row.breakdown];
      const fetchAgent = fetch(`/api/${agentCfg.url}?${agentCfg.params}`, { headers })
        .then(r => r.json()).then(parseList).catch(() => []);
      const fetchBroker = brokerCfg
        ? fetch(`/api/${brokerCfg.url}?${brokerCfg.params}`, { headers }).then(r => r.json()).then(parseList).catch(() => [])
        : Promise.resolve([]);
      Promise.all([fetchAgent, fetchBroker])
        .then(([agents, brokers]) => {
          this.c1GlanceUsers = agents;
          this.c1GlanceBrokers = brokers;
        })
        .finally(() => { this.c1GlanceLoading = false; });

      // Fetch daily hours per day in range for the "Days" tab
      const hoursEndpointMap = {
        dep:  { ep: 'dep',       fp: 'deposit_at_from',        tp: 'deposit_at_to' },
        ld:   { ep: 'lead_tag',  fp: 'last_modified_lead_from', tp: 'last_modified_lead_to' },
        na:   { ep: 'na_tag',    fp: 'last_modified_na_from',   tp: 'last_modified_na_to' },
        sc:   { ep: 'ca_f',      fp: 'scheduled_call_to_from',  tp: 'scheduled_call_to_to' },
        bn:   { ep: 'bn_tag',    fp: 'last_modified_bn_from',   tp: 'last_modified_bn_to' },
        ni:   { ep: 'ni_tag',    fp: 'last_modified_ni_from',   tp: 'last_modified_ni_to' },
        reg:  { ep: 'reg',       fp: 'registered_on_from',      tp: 'registered_on_to' },
        newl: { ep: 'reg',       fp: 'registered_on_from',      tp: 'registered_on_to' },
        rf:   { ep: 'lead_tag',  fp: 'last_referral_from',      tp: 'last_referral_to' },
      };
      const hCfg = hoursEndpointMap[row.breakdown];
      if (hCfg) {
        const days = [];
        const momentFn = window.moment;
        if (momentFn) {
          let d = momentFn(from);
          const endM = momentFn(to);
          while (d.isSameOrBefore(endM, 'day') && days.length < 14) {
            days.push(d.format('YYYY-MM-DD'));
            d = d.clone().add(1, 'day');
          }
        } else {
          days.push(from);
        }
        Promise.all(days.map(date =>
          fetch(`/api/client/stats/calendar/hours_stats/${hCfg.ep}?${hCfg.fp}=${date}&${hCfg.tp}=${date}`, { headers })
            .then(r => r.json())
            .then(data => {
              const arr = Array.isArray(data) ? data : (data.data || []);
              const hours = {};
              let total = 0;
              arr.forEach(item => {
                let hh = null;
                if (item.hour !== undefined) {
                  hh = String(Math.floor(Number(item.hour))).padStart(2, '0');
                } else if (item.date) {
                  const timeStr = item.date.includes('T') ? item.date.split('T')[1]
                                : item.date.includes(' ') ? item.date.split(' ')[1]
                                : item.date;
                  if (timeStr) hh = String(parseInt(timeStr.split(':')[0], 10)).padStart(2, '0');
                }
                if (hh !== null) {
                  hours[hh] = (hours[hh] || 0) + (item.count || 0);
                  total += (item.count || 0);
                }
              });
              return { date, hours, total };
            })
            .catch(() => ({ date, hours: {}, total: 0 }))
        )).then(results => {
          this.c1GlanceDays = results.filter(d => d.total > 0);
        }).finally(() => { this.c1GlanceDaysLoading = false; });
      } else {
        this.c1GlanceDaysLoading = false;
      }
    },

    // Agent glance panel
    c1LoadAgentDateRange() {
      const from = this.c1StatusRange ? this.c1StatusRange.from : moment().format('YYYY-MM-DD');
      const to   = this.c1StatusRange ? this.c1StatusRange.to   : from;
      const dateKey = from + '|' + to;
      if (this.c1AgentRangeLoading) return; // prevent double-fetch
      this.c1AgentRangeLoading = true;
      this.c1AgentRangeIds = null;
      const token = localStorage.getItem('user-token') || '';
      const headers = { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
      // Returns { agentId: count } map for a given endpoint
      const getData = url => fetch('/api/' + url, { headers })
        .then(r => r.json())
        .then(res => {
          const arr = Array.isArray(res) ? res : (res.data || []);
          const map = {};
          arr.forEach(r => {
            const cnt = Array.isArray(r.count) ? r.count[0] : (r.count || 0);
            if (cnt > 0) map[r.id] = parseInt(cnt, 10) || 0;
          });
          return map;
        })
        .catch(() => ({}));
      Promise.all([
        getData(`client/stats/multiselect/no_answer/users?last_modified_na_from=${from}&last_modified_na_to=${to}`),
        getData(`client/stats/multiselect/leads/users?last_modified_lead_from=${from}&last_modified_lead_to=${to}`),
        getData(`client/stats/multiselect/deposits/users?deposit_at_from=${from}&deposit_at_to=${to}`),
        getData(`client/stats/multiselect/call_again/users?scheduled_call_to_from=${from}&scheduled_call_to_to=${to}`),
      ]).then(([naMap, ldMap, depMap, scMap]) => {
        const allIds = [...new Set([
          ...Object.keys(naMap), ...Object.keys(ldMap),
          ...Object.keys(depMap), ...Object.keys(scMap),
        ].map(Number))];
        const perAgent = {};
        allIds.forEach(id => {
          const na = naMap[id] || 0, ld = ldMap[id] || 0, dep = depMap[id] || 0, sc = scMap[id] || 0;
          perAgent[id] = { na, ld, dep, sc, total: na + ld + dep + sc };
        });
        this.c1AgentRangeData = perAgent;
        this.c1AgentRangeIds  = allIds;
        this.c1AgentStatsDateKey = dateKey;
        this.c1AgentRangeLoading = false;
      });
    },

    c1FilterByAgent(agent) {
      this.resetFiltersOnly();
      this.filters.assigned = [agent.id];
      const from = this.c1StatusRange ? this.c1StatusRange.from : moment().format('YYYY-MM-DD');
      const to   = this.c1StatusRange ? this.c1StatusRange.to   : from;
      this.filters.last_modified_na = [from, to];
      this.filters.active = false;
      this.filters.order_by   = 'id';
      this.filters.sort_order = 'desc';
      this.debouncedClientsQuery();
    },

    c1ToggleAgentGlance(agent) {
      if (this.c1AgentGlanceOpen === agent.id) {
        this.c1AgentGlanceOpen = null;
        return;
      }
      this.c1AgentGlanceOpen = agent.id;
      const rd = this.c1AgentRangeData[agent.id];
      const from = this.c1StatusRange ? this.c1StatusRange.from : moment().format('YYYY-MM-DD');
      const to   = this.c1StatusRange ? this.c1StatusRange.to   : from;
      const dateKey = from + '|' + to;
      if (rd && !this.c1AgentStatsCache[agent.id]) {
        this.$set(this.c1AgentStatsCache, agent.id, { loading: false, dateKey, na: rd.na, ld: rd.ld, dep: rd.dep, sc: rd.sc, reg: 0 });
      }
      this.c1LoadAgentStats(agent);
    },

    c1LoadAgentStats(agent) {
      const id = agent.id;
      const dateKey = this.c1StatusRange ? (this.c1StatusRange.from + '|' + this.c1StatusRange.to) : 'all';
      // Return cached data if date range hasn't changed
      if (this.c1AgentStatsCache[id] && this.c1AgentStatsCache[id].dateKey === dateKey && !this.c1AgentStatsCache[id].loading) return;
      this.$set(this.c1AgentStatsCache, id, { loading: true, dateKey, na: 0, ld: 0, dep: 0, sc: 0, reg: 0 });
      const from = this.c1StatusRange ? this.c1StatusRange.from : moment().format('YYYY-MM-DD');
      const to   = this.c1StatusRange ? this.c1StatusRange.to   : from;
      const token = localStorage.getItem('user-token') || '';
      const headers = { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
      const getCount = url => fetch('/api/' + url, { headers })
        .then(r => r.json())
        .then(res => {
          const arr = Array.isArray(res) ? res : (res.data || []);
          const entry = arr.find(r => r.id === id);
          const raw = entry ? (Array.isArray(entry.count) ? entry.count[0] : (entry.count || 0)) : 0;
          return parseInt(raw, 10) || 0;
        })
        .catch(() => 0);
      Promise.all([
        getCount(`client/stats/multiselect/no_answer/users?last_modified_na_from=${from}&last_modified_na_to=${to}`),
        getCount(`client/stats/multiselect/leads/users?last_modified_lead_from=${from}&last_modified_lead_to=${to}`),
        getCount(`client/stats/multiselect/deposits/users?deposit_at_from=${from}&deposit_at_to=${to}`),
        getCount(`client/stats/multiselect/call_again/users?scheduled_call_to_from=${from}&scheduled_call_to_to=${to}`),
        getCount(`client/stats/multiselect/assignments/assignments?registered_on_from=${from}&registered_on_to=${to}`),
      ]).then(([na, ld, dep, sc, reg]) => {
        this.$set(this.c1AgentStatsCache, id, { loading: false, dateKey, na, ld, dep, sc, reg });
      });
    },

    c1AgentGlanceStats(agentId) {
      const d = this.c1AgentStatsCache[agentId];
      if (!d) return [];
      const max = Math.max(1, d.na, d.ld, d.dep, d.sc, d.reg);
      return [
        { key: 'na',  label: 'NA',    count: d.na,  pct: Math.round(d.na  / max * 100), color: 'var(--c1-na)',  filterable: true,  filterKey: 'last_modified_na',    fpKey: 'last_modified_na_from',    tpKey: 'last_modified_na_to' },
        { key: 'ld',  label: 'Lead',  count: d.ld,  pct: Math.round(d.ld  / max * 100), color: 'var(--c1-ld)',  filterable: true,  filterKey: 'last_modified_leads',  fpKey: 'last_modified_lead_from',  tpKey: 'last_modified_lead_to' },
        { key: 'dep', label: 'DEP',   count: d.dep, pct: Math.round(d.dep / max * 100), color: 'var(--c1-dp)',  filterable: true,  filterKey: 'deposit_at',           fpKey: 'deposit_at_from',          tpKey: 'deposit_at_to' },
        { key: 'sc',  label: 'SC',    count: d.sc,  pct: Math.round(d.sc  / max * 100), color: 'var(--c1-sc)',  filterable: true,  filterKey: 'scheduled_call_to',    fpKey: 'scheduled_call_to_from',   tpKey: 'scheduled_call_to_to' },
        { key: 'reg', label: 'REG',   count: d.reg, pct: Math.round(d.reg / max * 100), color: '#6b7280',       filterable: false },
      ];
    },

    c1FilterByAgentStat(agent, stat) {
      if (!stat.filterable) return;
      this.resetFiltersOnly();
      this.filters.assigned = [agent.id];
      const from = this.c1StatusRange ? this.c1StatusRange.from : moment().format('YYYY-MM-DD');
      const to   = this.c1StatusRange ? this.c1StatusRange.to   : from;
      this.filters[stat.filterKey] = [from, to];
      this.filters.active = false;
      this.filters.order_by   = 'id';
      this.filters.sort_order = 'desc';
      this.debouncedClientsQuery();
      this.c1TopTab = null;
    },

    // Load recent activity for the logged-in user
    c1LoadMyActivity(force = false) {
      if (this.c1MyActivityLoading) return;
      if (this.c1MyActivityLoaded && !force) return;
      this.c1MyActivityLoading = true;
      const token = localStorage.getItem('user-token') || '';
      fetch('/api/admin/my-activity', {
        headers: { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(r => r.json())
        .then(json => {
          if (json.success) {
            this.c1MyActivity = json.data || [];
            this.c1MyActivityLoaded = true;
          }
        })
        .catch(() => {})
        .finally(() => { this.c1MyActivityLoading = false; });
    },

    c1ActivityIcon(asset) {
      if (!asset) return '📋';
      if (asset.includes('ASSIGN'))       return '👤';
      if (asset.includes('DEPOSIT'))      return '💰';
      if (asset.includes('SCHEDULED'))    return '📅';
      if (asset.includes('TRANSFER'))     return '🔀';
      if (asset.includes('BAD_NUMBER'))   return '🚫';
      if (asset.includes('NOT_INT'))      return '👎';
      if (asset.includes('NA'))           return '⛔';
      if (asset.includes('LEAD'))         return '🎯';
      if (asset.includes('COMMUNICATION')) return '💬';
      if (asset.includes('NEW'))          return '🆕';
      return '📋';
    },

    c1ActivityLabel(asset, from, to) {
      if (!asset) return to || '—';
      if (asset === 'ASSIGNMENT' || asset === 'MANUAL_CLIENT_NEW') return to || asset;
      if (asset.includes('DEPOSIT'))  return 'Deposit · ' + (to || '');
      if (asset.includes('SCHEDULED')) return 'Scheduled call · ' + (to || '');
      if (asset.includes('TRANSFER')) return 'Transfer · ' + (to || '');
      if (from && to) return from + ' → ' + to;
      return to || asset.replace(/_/g,' ').toLowerCase();
    },

    // Load agent availability from Viopa backend (shift, vacation, illness, call load)
    c1LoadAgentAvailability() {
      if (this.c1VikiAvailLoading) return;
      this.c1VikiAvailLoading = true;
      const token = localStorage.getItem('user-token') || '';
      fetch('/api/admin/viopa/agent-availability', {
        headers: { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(r => r.json())
        .then(json => {
          if (json.success) {
            this.c1VikiAvailability = json.data || [];
            this.c1VikiAvailLoaded = true;
          }
        })
        .catch(() => {})
        .finally(() => { this.c1VikiAvailLoading = false; });
    },

    // Viki Auto-Assign: score every unassigned lead individually, assign only to ACTIVE agents
    async c1VikiAutoAssign() {
      if (this.c1VikiAutoRunning) return;

      // Build set of available agent IDs
      const availableIds = new Set(
        this.c1VikiAvailability.filter(a => a.status === 'ACTIVE').map(a => a.agent_id)
      );
      if (!availableIds.size) {
        this.c1VikiSay('No agents available right now — check shift schedule');
        return;
      }

      // Find all unassigned clients in the current view
      const unassigned = (this.clients || []).filter(c => !c.assignment);
      if (!unassigned.length) {
        this.c1VikiSay('All leads are already assigned');
        return;
      }

      this.c1VikiAutoRunning = true;
      this.c1VikiAutoResult = null;
      this.c1VikiAutoProgress = { done: 0, total: unassigned.length, errors: 0 };

      const token = localStorage.getItem('user-token') || '';

      for (const client of unassigned) {
        try {
          const country     = (client.country && client.country.alpha2) || client.country_code || 'XX';
          const campaign    = client.campaign_aaid || '';
          const keyword     = client.keyword || '';
          const device      = client.device || '';
          const timeSlot    = this.c1ViopaTimeSlot(client.created_at);
          const languageId  = (client.language && client.language.id) || client.language_id || 0;
          const abid        = client.campaign_abid || '';
          const placement   = client.placement || '';
          const hasReferral = !!(client.referrals && client.referrals.length);
          const _days4      = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
          const dayOfWeek   = client.created_at ? _days4[new Date(client.created_at).getDay()] : '';

          const params = new URLSearchParams({ country });
          if (campaign)    params.append('campaign', campaign);
          if (keyword)     params.append('keyword', keyword);
          if (device)      params.append('device', device);
          if (timeSlot)    params.append('time_slot', timeSlot);
          if (languageId)  params.append('language_id', languageId);
          if (abid)        params.append('abid', abid);
          if (placement)   params.append('placement', placement);
          if (hasReferral) params.append('has_referral', 1);
          if (dayOfWeek)   params.append('day_of_week', dayOfWeek);

          const resp = await fetch('/api/admin/viopa/score?' + params.toString(), {
            headers: { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
          });
          const json = await resp.json();

          // Pick the top-scoring ACTIVE agent
          let bestAgentId = null;
          if (json.success && json.data && json.data.all) {
            for (const entry of json.data.all) {
              if (availableIds.has(entry.agent_id) && entry.score >= 0) {
                bestAgentId = entry.agent_id;
                break;
              }
            }
          }

          if (bestAgentId) {
            const req = apiClientCreator(`client/assign/${bestAgentId}`);
            await req.put('', { client_id: client.id, from_group: 'clients' });
          } else {
            this.c1VikiAutoProgress.errors++;
          }
        } catch (e) {
          this.c1VikiAutoProgress.errors++;
        }
        this.c1VikiAutoProgress.done++;
      }

      const { total, errors } = this.c1VikiAutoProgress;
      const assigned = total - errors;
      this.c1VikiAutoResult = { assigned, skipped: errors };
      this.c1VikiAutoRunning = false;
      this.c1VikiAutoProgress = null;
      // Refresh availability counts after assigning
      this.c1LoadAgentAvailability();
      this.fetchClients();
      this.c1VikiSay(
        errors === 0
          ? `⚡ Done — ${assigned} leads assigned by Viopa`
          : `⚡ ${assigned} assigned · ${errors} skipped (no available match)`
      );
    },

    c1ClientNameById(id) {
      const c = (this.clients || []).find(x => x.id === id);
      if (!c) return '#' + id;
      return (c.first_name || '') + ' ' + (c.last_name || '');
    },

    c1ApplySmartSort(type) {
      this.c1SmartSort = type;
      // Reset manual sort flags
      Object.keys(this.sortActive).forEach(k => {
        this.sortActive[k].up = false;
        this.sortActive[k].down = false;
      });
      if (type === 'sc_first') {
        this.filters.order_by = 'call_status';
        this.filters.sort_order = 'asc';
        this.filters.secondary_order = 'last_scheduled_on';
      } else if (type === 'new_first') {
        this.filters.order_by = 'is_new';
        this.filters.sort_order = 'desc';
      } else if (type === 'hot_first') {
        this.filters.order_by = 'is_leading';
        this.filters.sort_order = 'desc';
      }
      this.debouncedClientsQuery();
      this.c1SlideOpen = null;
      this.c1FilterTab = 'status';
    },

    c1FilterByStatusBroker(row, broker) {
      // Apply the status filter for this row
      row.click && row.click();
      // For deposits, also narrow by broker
      if (row.key === 'DEP') {
        this.filters.deposit_brokers = [{ id: broker.id }];
        this.filters.deposit_users = [];
      }
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
    },

    c1ApplyQuickFilter(type) {
      this.resetAllFilters();
      Object.keys(this.sortActive).forEach(k => { this.sortActive[k].up = false; this.sortActive[k].down = false; });
      if (type === 'sc') {
        this.c1SmartSort = 'sc_first';
        this.filters.scheduled_calls = true;
        this.filters.order_by = 'call_status';
        this.filters.sort_order = 'asc';
        this.filters.secondary_order = 'last_scheduled_on';
      } else if (type === 'new') {
        this.c1SmartSort = 'new_first';
        this.filters.is_new = true;
        this.filters.order_by = 'is_new';
        this.filters.sort_order = 'desc';
      } else if (type === 'hot') {
        this.c1SmartSort = 'hot_first';
        this.filters.leading_new = true;
        this.filters.order_by = 'is_leading';
        this.filters.sort_order = 'desc';
      } else if (type === 'dep') {
        this.c1SmartSort = 'dep_first';
        this.filters.deposit = true;
        this.filters.order_by = 'created_at';
        this.filters.sort_order = 'desc';
      }
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
      this.c1TopTab = null;
    },

    c1Logout() {
      this.$store.dispatch('user/logOut');
    },

    c1ShowToast(msg, color) {
      // Route all notifications through Viki
      const isError = color && (color.includes('na') || color.includes('E0') || color.includes('red'));
      this.c1VikiSay(msg, isError ? 'error' : 'success');
    },

    c1VikiSay(msg, type = 'success') {
      if (this._vikiTimer)    clearTimeout(this._vikiTimer);
      if (this._vikiSpeakTimer) clearTimeout(this._vikiSpeakTimer);
      // Map type → mood
      const moodMap = { success: 'success', error: 'error', angry: 'angry', info: 'info', happy: 'happy' };
      this.c1VikiMood     = moodMap[type] || 'neutral';
      this.c1VikiSpeaking = true;
      this.c1VikiNotifMsg = { m: msg, b: 'Got it' };
      this.c1VikiMsgKey++;
      this.c1VikiIdx      = 0;
      this.c1VikiVisible  = true;
      // Stop speaking animation after 2s
      this._vikiSpeakTimer = setTimeout(() => { this.c1VikiSpeaking = false; }, 2000);
      this._vikiTimer = setTimeout(() => {
        this.c1VikiVisible  = false;
        this.c1VikiNotifMsg = null;
        this.c1VikiMood     = 'neutral';
      }, 5000);
    },

    c1VikiNarrate() {
      const total   = this.pagination.total || 0;
      const agents  = this.filters.assigned || [];
      const list    = this.$store.state.clients.salesPersonList || [];

      // Build context parts
      const parts = [];

      // Agent context
      if (agents.length === 1) {
        const id    = agents[0].id || agents[0];
        const agent = list.find(a => a.id === id);
        const name  = agent ? (agent.full_name || agent.name || 'Agent') : 'Agent';
        parts.push(name);
      } else if (agents.length > 1) {
        parts.push(agents.length + ' agents');
      }

      // Date filter context
      const dateLabels = { today: 'today', week: 'this week', month: 'this month', lastmonth: 'last month', all: 'all time' };
      if (this.c1DateFilter && this.c1DateFilter !== 'all' && dateLabels[this.c1DateFilter]) {
        parts.push(dateLabels[this.c1DateFilter]);
      }

      // Build message
      let msg;
      if (total === 0) {
        msg = parts.length ? `No clients for ${parts.join(' · ')}` : 'No clients found';
        this.c1VikiSay(msg, 'error');
      } else {
        const ctx = parts.length ? ` · ${parts.join(' · ')}` : '';
        msg = `Viewing ${total} client${total !== 1 ? 's' : ''}${ctx}`;
        this.c1VikiSay(msg, 'info');
      }
    },

    c1OnTagAdded(label) {
      this.c1ClosePicker();
      this.c1OpenTag = null;
      this.c1ScEditOpen = false;
      if (label) this.c1ShowToast('✓ ' + label + ' added');
      // Update "Recently Viewed" history whenever a tag is added
      const labelToStatus = { 'Lead': 'LD', 'Deposit': 'DP', 'No Answer': 'NA', 'Scheduled Call': 'SC', 'Referral': 'RF', 'Bad Number': 'BN', 'Not Interested': 'NI' };
      const touchedId = this.c1TagPicker && this.c1TagPicker.cid ? this.c1TagPicker.cid : this.c1CardSelected;
      if (touchedId) {
        const touched = (this.clients || []).find(c => c.id === touchedId);
        if (touched) this.addToHistory(touched, labelToStatus[label] || null);
      }
      // After NA/VM/BN/NI — deselect the client so it is no longer pinned to the top
      if (label === 'No Answer' || label === 'Bad Number' || label === 'Not Interested') {
        this.c1CardSelected = null;
        this.c1CardExpanded = null;
      }
      this.fetchClients();
      // Refresh charts if the charts panel is open
      if (this.c1SlideOpen === 'charts') {
        const sections = this.c1ChartOpenSections || [];
        if (label === 'Deposit' || sections.includes('deposits')) this.c1LoadChartDeposits();
        if (label === 'Lead'    || sections.includes('leads'))    this.c1LoadChartLeads();
        if (label === 'No Answer' || sections.includes('na'))     this.c1LoadChartNA();
        if (label === 'Scheduled Call' || sections.includes('sc')) this.c1LoadChartSC();
        if (label === 'Referral' || sections.includes('rf'))      this.c1LoadChartRF();
        this.c1LoadTodayChart();
      }
    },

    // Time helpers
    c1TimeAgo(ts) {
      if (!ts) return '—';
      const diff = Date.now() - new Date(ts).getTime();
      const m = Math.floor(diff / 60000);
      if (m < 1) return 'just now';
      if (m < 60) return m + 'm ago';
      const h = Math.floor(m / 60);
      if (h < 24) return h + 'h ago';
      const d = Math.floor(h / 24);
      if (d < 30) return d + 'd ago';
      const mo = Math.floor(d / 30);
      return mo + 'mo ago';
    },
    c1ScTimeLabel(sc) {
      const date = sc.scheduled_on || sc.call_at;
      if (!date) return '—';
      if (sc.ended) return 'Ended';
      const diff = new Date(date).getTime() - Date.now();
      const absDiff = Math.abs(diff);
      const m = Math.floor(absDiff / 60000);
      const h = Math.floor(m / 60);
      const d = Math.floor(h / 24);
      if (diff < 0) {
        // Past = missed
        if (m < 60) return m + 'm overdue';
        if (h < 24) return h + 'h overdue';
        return d + 'd overdue';
      }
      // Future = upcoming
      if (m < 60) return 'in ' + m + 'm';
      if (h < 24) return 'in ' + h + 'h';
      return 'in ' + d + 'd';
    },

    // Remove tag actions
    async c1RemoveTag(type, clientId) {
      const endpoints = {
        na: `client/na/${clientId}`,
        sc: `client/schedule-call/${clientId}`,
        lead: `client/lead/${clientId}`,
        referral: `client/referral/${clientId}`,
        bn: `client/bad-number/${clientId}`,
        transfer: `client/transfer/${clientId}`
      };
      if (!endpoints[type]) return;
      try {
        await apiClientCreator(endpoints[type]).delete('');
        this.c1OnTagAdded();
      } catch(e) { console.error(e); }
    },

    // Update deposit status
    async c1UpdateDepositStatus(depositId, statusId) {
      try {
        await apiClientCreator(`client/deposit-status/${depositId}`).put('', { status_id: statusId });
        this.fetchClients();
      } catch(e) { console.error(e); }
    },

    // Reschedule SC
    async c1RescheduleSC(clientId) {
      const f = this.c1PickerForm.sc;
      try {
        await apiClientCreator(`client/schedule-call/${clientId}`).post('', {
          call_scheduled_on: f.call_scheduled_on,
          status_id: f.status_id || 1,
          comment: f.comment,
          priority_id: f.priority_id || 3,
          is_rescheduled: 1
        });
        this.c1OnTagAdded();
      } catch(e) { console.error(e); }
    },

    async c1SubmitNA(isVm) {
      this.c1TagPicker.loading = true;
      try {
        await apiClientCreator(`client/na/${this.c1TagPicker.cid}`).post("", { tag_id: 0, is_vm: isVm });
        this.c1OnTagAdded('No Answer');
      } catch(e) { this.c1TagPicker.loading = false; }
    },

    async c1SubmitBN(stateId) {
      this.c1TagPicker.loading = true;
      try {
        await apiClientCreator(`client/bad-number/${this.c1TagPicker.cid}`).post("", { tag_id: stateId });
        this.c1OnTagAdded('Bad Number');
      } catch(e) { this.c1TagPicker.loading = false; }
    },

    async c1SubmitNI(stateId) {
      this.c1TagPicker.loading = true;
      try {
        await apiClientCreator(`client/not-interested/${this.c1TagPicker.cid}`).post("", { tag_id: stateId });
        this.c1OnTagAdded('Not Interested');
      } catch(e) { this.c1TagPicker.loading = false; }
    },

    async c1SubmitRemoveNI() {
      this.c1TagPicker.loading = true;
      try {
        await apiClientCreator(`client/not-interested/${this.c1TagPicker.cid}`).delete("");
        this.c1OnTagAdded();
      } catch(e) { this.c1TagPicker.loading = false; }
    },

    async c1SubmitSC() {
      const f = this.c1PickerForm.sc;
      if (!f.call_scheduled_on || !f.status_id) return;
      this.c1TagPicker.loading = true;
      try {
        await apiClientCreator(`client/schedule-call/${this.c1TagPicker.cid}`).post("", {
          call_scheduled_on: f.call_scheduled_on,
          status_id: f.status_id,
          comment: f.comment,
          priority_id: f.priority_id
        });
        this.c1PickerForm.sc = { call_scheduled_on: "", status_id: null, comment: "", priority_id: 3 };
        this.c1OnTagAdded('Scheduled Call');
      } catch(e) { this.c1TagPicker.loading = false; }
    },

    async c1SubmitDP() {
      const f = this.c1PickerForm.dp;
      if (!f.campaign_id || !f.status_id || !f.method_id) return;
      this.c1TagPicker.loading = true;
      const client = this.clients.find(c => c.id === this.c1TagPicker.cid);
      try {
        await apiClientCreator(`client/deposit/${this.c1TagPicker.cid}`).post("", {
          campaign_id: f.campaign_id,
          amount: f.amount,
          currency_id: f.currency_id,
          method_id: f.method_id,
          status_id: f.status_id,
          comment: f.comment
        });
        // Broadcast deposit to all online agents via Viki
        if (this.msgSocket) {
          const brokers = (this.dictionaries && this.dictionaries.general && this.dictionaries.general.brokers) || [];
          const broker = brokers.find(b => b.id === f.campaign_id);
          const brokerName = broker ? broker.name : `Broker #${f.campaign_id}`;
          const u = this.auth && this.auth.user;
          const agentName = u ? `${u.first_name} ${u.last_name}` : 'Agent';
          const countryAlpha = (client && client.country) ? client.country.alpha2 : '';
          this.msgSocket.emit("receive_message", {
            message_from: u ? u.id : null,
            message: `Dep in ${brokerName},\nby ${agentName}`,
            priority: 9,
            type: "USER_DEPOSITED",
            op: { clientId: this.c1TagPicker.cid },
            options: { countryAlpha }
          });
        }
        this.c1PickerForm.dp = { campaign_id: null, amount: 250, currency_id: 1, method_id: null, status_id: null, comment: "" };
        this.c1OnTagAdded('Deposit');
      } catch(e) { this.c1TagPicker.loading = false; }
    },

    async c1SubmitLD() {
      const f = this.c1PickerForm.ld;
      if (!f.campaign_id) return;
      this.c1TagPicker.loading = true;
      try {
        await apiClientCreator(`client/lead/${this.c1TagPicker.cid}`).post("", {
          campaign_id: f.campaign_id,
          comment: f.comment
        });
        this.c1PickerForm.ld = { campaign_id: null, comment: "", brokerSearch: "" };
        this.c1OnTagAdded('Lead');
      } catch(e) { this.c1TagPicker.loading = false; }
    },

    async c1SubmitRF() {
      const f = this.c1PickerForm.rf;
      if (!f.campaign_id) return;
      this.c1TagPicker.loading = true;
      try {
        await apiClientCreator(`client/referral/${this.c1TagPicker.cid}`).post("", {
          campaign_id: f.campaign_id,
          comment: f.comment
        });
        this.c1PickerForm.rf = { campaign_id: null, comment: "" };
        this.c1OnTagAdded('Referral');
      } catch(e) { this.c1TagPicker.loading = false; }
    },

    async c1SubmitTR() {
      const f = this.c1PickerForm.tr;
      if (!f.type_id || !f.to) return;
      this.c1TagPicker.loading = true;
      const client = this.clients.find(c => c.id === this.c1TagPicker.cid);
      const fromId = (client && client.assignment) ? client.assignment.assigned_id : null;
      try {
        await apiClientCreator(`client/transfer/${this.c1TagPicker.cid}`).post("", {
          trans_type_id: f.type_id,
          trans_to_id: f.to,
          trans_from_id: fromId
        });
        this.c1PickerForm.tr = { type_id: null, to: null };
        this.c1OnTagAdded('Transfer');
      } catch(e) { this.c1TagPicker.loading = false; }
    },

    async c1SubmitEnded() {
      this.c1TagPicker.loading = true;
      try {
        await apiClientCreator(`client/ended/${this.c1TagPicker.cid}`).put("", {});
        this.c1OnTagAdded('Ended');
      } catch(e) { this.c1TagPicker.loading = false; }
    },

    async c1SubmitWaiting() {
      this.c1TagPicker.loading = true;
      try {
        await apiClientCreator(`client/waiting/${this.c1TagPicker.cid}`).put("", {});
        this.c1OnTagAdded('Waiting');
      } catch(e) { this.c1TagPicker.loading = false; }
    },

    c1TagsHidden(client) {
      let count = 0;
      if (client.scheduled_calls && client.scheduled_calls.length) count++;
      if (client.referrals && client.referrals.length) count++;
      if (client.bn && client.bn.length) count++;
      return count;
    },

    c1ToggleAccordion(cid, type) {
      if (this.c1Accordion.cid === cid && this.c1Accordion.type === type) {
        this.c1Accordion = { cid: null, type: null };
      } else {
        this.c1Accordion = { cid, type };
      }
    },

    c1PhoneClean(client) {
      if (!client.phones || !client.phones.length) return "";
      return client.phones[0].contact_value.replace(/\D/g, "");
    },

    c1CopyEmail(client) {
      if (!client.emails || !client.emails.length) return;
      const val = client.emails[0].contact_value;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(val).catch(() => {});
      }
      this.c1Accordion = { cid: null, type: null };
    },

    c1PanelBtnClick() {
      this.c1SlideOpen = this.c1PanelIsOpen ? null : 'nav';
    },

    c1GoBackToNav() {
      this.c1SlideOpen = 'nav';
    },

    c1SelectPanel(panel, sub) {
      // Nav items always navigate forward — never close on click.
      // Closing is done only via X button or backdrop.
      if (panel === 'live') {
        this.c1SlideOpen = 'live';
        return;
      }
      if (panel === 'filter') {
        this.c1FilterTab = sub || 'status';
        this.c1SlideOpen = 'filters';
        return;
      }
      if (panel === 'charts') {
        this.c1ChartsTab = 'overview';
        this.c1SwitchSection(sub || 'overview');
        this.c1SlideOpen = 'charts';
        return;
      }
      if (panel === 'games') {
        this.c1ChartsTab = 'game';
        this.c1SlideOpen = 'charts';
        return;
      }
      if (panel === 'viki') {
        this.c1VikiOpenSections = [sub];
        this.c1SlideOpen = 'viki';
        return;
      }
    },

    c1OpenSlide(name) {
      this.c1SlideOpen = this.c1SlideOpen === name ? null : name;
    },

    c1OpenFiltersInCharts() {
      if (this.c1SlideOpen === 'charts' && this.c1IsSectionOpen('filters')) {
        this.c1SlideOpen = null;
      } else {
        this.c1SlideOpen = 'charts';
        this.c1ChartOpenSections = ['filters'];
        this.$nextTick(() => {
          const body = this.$el && this.$el.querySelector('.c1-panel-charts .c1-sl-body');
          if (body) body.scrollTop = 0;
        });
      }
    },

    c1CloseSlides() {
      this.c1SlideOpen = null;
    },

    c1CalPrevMonth() {
      if (this.c1Cal.month === 0) { this.c1Cal.month = 11; this.c1Cal.year--; }
      else this.c1Cal.month--;
    },
    c1CalNextMonth() {
      if (this.c1Cal.month === 11) { this.c1Cal.month = 0; this.c1Cal.year++; }
      else this.c1Cal.month++;
    },
    c1CalClick(dateStr) {
      if (!this.c1Cal.start || this.c1Cal.end) {
        this.c1Cal.start = dateStr;
        this.c1Cal.end = null;
        this.c1DateFilter = 'custom';
        this.filters.registered_on_from = dateStr;
        this.filters.registered_on_to = dateStr;
        this.pagination.currentPage = 1;
        this.debouncedClientsQuery();
      } else {
        if (dateStr >= this.c1Cal.start) {
          this.c1Cal.end = dateStr;
        } else {
          this.c1Cal.end = this.c1Cal.start;
          this.c1Cal.start = dateStr;
        }
        this.c1DateFilter = 'custom';
        this.filters.registered_on_from = this.c1Cal.start;
        this.filters.registered_on_to = this.c1Cal.end;
        this.pagination.currentPage = 1;
        this.debouncedClientsQuery();
      }
    },
    c1SetHours(preset) {
      this.c1Cal.hPreset = preset;
    },

    c1ClientFlag(client) {
      if (!client.country) return '';
      const name = (client.country.name || '').trim();
      const map = {
        'United Kingdom': '🇬🇧', 'UK': '🇬🇧', 'France': '🇫🇷', 'Germany': '🇩🇪',
        'Italy': '🇮🇹', 'Spain': '🇪🇸', 'Australia': '🇦🇺', 'Israel': '🇮🇱',
        'India': '🇮🇳', 'United States': '🇺🇸', 'USA': '🇺🇸', 'Netherlands': '🇳🇱',
        'Belgium': '🇧🇪', 'Portugal': '🇵🇹', 'Switzerland': '🇨🇭', 'Austria': '🇦🇹',
        'Sweden': '🇸🇪', 'Norway': '🇳🇴', 'Denmark': '🇩🇰', 'Finland': '🇫🇮',
        'Poland': '🇵🇱', 'Russia': '🇷🇺', 'Ukraine': '🇺🇦', 'Canada': '🇨🇦',
        'Mexico': '🇲🇽', 'Brazil': '🇧🇷', 'Japan': '🇯🇵', 'China': '🇨🇳',
        'South Korea': '🇰🇷', 'Singapore': '🇸🇬', 'Thailand': '🇹🇭',
        'New Zealand': '🇳🇿', 'South Africa': '🇿🇦', 'Cyprus': '🇨🇾',
        'Malta': '🇲🇹', 'Turkey': '🇹🇷', 'Romania': '🇷🇴', 'Hungary': '🇭🇺',
        'Czech Republic': '🇨🇿', 'Greece': '🇬🇷', 'Ireland': '🇮🇪', 'Nigeria': '🇳🇬'
      };
      return map[name] || '';
    },

    c1CountryTz(countryName) {
      const map = {
        'United Kingdom': 'Europe/London', 'UK': 'Europe/London',
        'France': 'Europe/Paris', 'Germany': 'Europe/Berlin', 'Italy': 'Europe/Rome',
        'Spain': 'Europe/Madrid', 'Australia': 'Australia/Sydney', 'Israel': 'Asia/Jerusalem',
        'India': 'Asia/Kolkata', 'United States': 'America/New_York', 'USA': 'America/New_York',
        'Netherlands': 'Europe/Amsterdam', 'Belgium': 'Europe/Brussels', 'Portugal': 'Europe/Lisbon',
        'Switzerland': 'Europe/Zurich', 'Austria': 'Europe/Vienna', 'Sweden': 'Europe/Stockholm',
        'Norway': 'Europe/Oslo', 'Denmark': 'Europe/Copenhagen', 'Finland': 'Europe/Helsinki',
        'Poland': 'Europe/Warsaw', 'Russia': 'Europe/Moscow', 'Ukraine': 'Europe/Kiev',
        'Canada': 'America/Toronto', 'Japan': 'Asia/Tokyo', 'China': 'Asia/Shanghai',
        'Singapore': 'Asia/Singapore', 'Cyprus': 'Asia/Nicosia', 'Turkey': 'Europe/Istanbul',
        'Greece': 'Europe/Athens', 'Ireland': 'Europe/Dublin', 'Romania': 'Europe/Bucharest',
        'Hungary': 'Europe/Budapest', 'Czech Republic': 'Europe/Prague', 'South Korea': 'Asia/Seoul'
      };
      return map[countryName] || null;
    },

    c1ClientTod(client) {
      if (!client.country) return null;
      const tz = this.c1CountryTz(client.country.name || '');
      if (!tz) return null;
      try {
        const hourStr = new Date().toLocaleString('en-US', { timeZone: tz, hour: 'numeric', hour12: false });
        const h = parseInt(hourStr);
        if (h >= 5 && h < 9)  return { label: 'Morning', cls: 'c1-tod-morning' };
        if (h >= 9 && h < 14) return { label: 'Day', cls: 'c1-tod-day' };
        if (h >= 14 && h < 18) return { label: 'Afternoon', cls: 'c1-tod-afternoon' };
        if (h >= 18 && h < 22) return { label: 'Evening', cls: 'c1-tod-evening' };
        return { label: 'Night', cls: 'c1-tod-night' };
      } catch(e) { return null; }
    },

    c1ClientLocalTime(client) {
      if (!client.country) return '';
      const tz = this.c1CountryTz(client.country.name || '');
      if (!tz) return '';
      try {
        return new Date().toLocaleString('en-GB', { timeZone: tz, hour: '2-digit', minute: '2-digit', hour12: false });
      } catch(e) { return ''; }
    },

    c1CityGmt(client) {
      if (!client.country) return null;
      const tz = this.c1CountryTz(client.country.name || '');
      if (!tz) return null;
      try {
        const fmt = new Intl.DateTimeFormat('en', { timeZone: tz, timeZoneName: 'short' });
        const parts = fmt.formatToParts(new Date());
        const tzPart = parts.find(p => p.type === 'timeZoneName');
        return tzPart ? tzPart.value : null;
      } catch(e) { return null; }
    },

    c1CityLangs(client) {
      if (!client.country) return null;
      const name = (client.country.name || '').trim();
      const map = {
        'United Kingdom': 'English', 'UK': 'English', 'USA': 'English', 'United States': 'English',
        'Canada': 'English, French', 'Australia': 'English', 'New Zealand': 'English', 'Ireland': 'English, Irish',
        'Germany': 'German', 'Austria': 'German', 'Switzerland': 'German, French, Italian',
        'France': 'French', 'Belgium': 'Dutch, French, German',
        'Spain': 'Spanish', 'Mexico': 'Spanish', 'Brazil': 'Portuguese', 'Portugal': 'Portuguese',
        'Italy': 'Italian', 'Netherlands': 'Dutch', 'Poland': 'Polish',
        'Russia': 'Russian', 'Ukraine': 'Ukrainian', 'Romania': 'Romanian',
        'Hungary': 'Hungarian', 'Czech Republic': 'Czech', 'Greece': 'Greek',
        'Turkey': 'Turkish', 'Israel': 'Hebrew, Arabic', 'Cyprus': 'Greek, Turkish, English',
        'Sweden': 'Swedish', 'Norway': 'Norwegian', 'Denmark': 'Danish', 'Finland': 'Finnish, Swedish',
        'India': 'Hindi, English', 'Japan': 'Japanese', 'China': 'Mandarin',
        'South Korea': 'Korean', 'Singapore': 'English, Mandarin, Malay, Tamil',
        'Thailand': 'Thai', 'South Africa': 'Zulu, Xhosa, Afrikaans, English',
        'Nigeria': 'Yoruba, Hausa, Igbo, English', 'Malta': 'Maltese, English',
      };
      return map[name] || null;
    },

    c1CityTips(client) {
      if (!client.country) return ['Research local market conditions before calling.', 'Match local time of day to the client\'s energy level.'];
      const name = (client.country.name || '').trim();
      const city = (client.location || '').trim();
      // City-level overrides for major financial hubs
      const cityTips = {
        'Munich': ['Munich is Bavaria\'s <strong>financial capital</strong> — BMW, Siemens, MAN HQ here. Status and prestige sell.', 'Bavarians are proud of local identity. Reference Bavaria, not just Germany.', 'Oktoberfest culture = social and warm but businesslike. Don\'t be too casual.'],
        'Berlin': ['Berlin is <strong>startup and tech-forward</strong> — innovation and disruption angle works well.', 'More casual and international than Munich. English widely spoken.', 'Growth-focused mindset — emphasise upside and innovation, not tradition.'],
        'Frankfurt': ['Frankfurt is Germany\'s <strong>banking capital</strong> — home to ECB and Deutsche Bank. Very finance-literate audience.', 'Highly professional. Get to the numbers fast — no small talk.', 'Reference EUR/USD and European financial stability as hooks.'],
        'Hamburg': ['Hamburg is Germany\'s <strong>trade and port city</strong> — international, merchant mindset.', 'Hamburgians are reserved but fair. Honesty builds trust fast.', 'Reference global markets and trade volatility as relevant hooks.'],
        'London': ['London is a <strong>global financial hub</strong> — sophisticated, FCA-aware clients. Lead with regulation and credentials.', 'Busy schedule — be concise, respect their time, offer a callback.', 'Reference FTSE, GBP/USD moves, and UK market conditions specifically.'],
        'Tel Aviv': ['Tel Aviv is <strong>Israel\'s startup capital</strong> — high-energy, tech-savvy, ambitious clients.', 'Israelis are fast decision-makers. Skip the pleasantries, lead with ROI.', 'Reference the shekel/dollar pair and TA Stock Exchange volatility as context.'],
        'Kyiv': ['Kyiv clients are <strong>resilience-focused</strong> — stability and capital preservation resonate strongly.', 'Many have moved assets abroad — international platforms preferred.', 'Be empathetic to current context without dwelling on it. Focus on opportunity.'],
        'Amsterdam': ['Amsterdam is the <strong>Netherlands\' finance and tech capital</strong>. Very international, progressive mindset.', 'Dutch directness applies here too — facts over emotion, numbers over story.', 'Reference European green economy and fintech innovation as talking angles.'],
        'Warsaw': ['Warsaw is Central Europe\'s <strong>fastest-growing financial centre</strong>. Ambitious, growth-oriented clients.', 'Young, educated population — digital-first approach works well.', 'Reference PLN volatility vs EUR as a natural hook for diversification.'],
        'Limassol': ['Limassol is Cyprus\'s <strong>offshore finance hub</strong> — many clients are international investors and HNW individuals.', 'Very finance-sophisticated. Reference CySEC and EU regulation as trust signals.', 'Warm climate + international community = relaxed but businesslike tone.'],
        'Nicosia': ['Nicosia is Cyprus\'s <strong>capital and legal/financial centre</strong>. Bilingual Greek/English.', 'Government and institutional clients. Formal opener, then build rapport.', 'Reference EU membership and CySEC licensing to establish credibility.'],
        'Valletta': ['Valletta is Malta\'s capital and an <strong>EU financial services hub</strong>. Very international.', 'MGA regulation is strong — reference it as a trust signal.', 'Small, connected community — reputation matters enormously.'],
        'Athens': ['Athens clients value <strong>long-term relationships</strong> over transactional calls. Invest in rapport first.', 'Greek economic history makes clients cautious — emphasise stability and protection.', 'Reference EUR and Mediterranean market dynamics as familiar anchors.'],
        'Istanbul': ['Istanbul bridges <strong>East and West</strong> — mention global reach and access as key value props.', 'High entrepreneurial energy. Reference TRY volatility as motivation for diversification.', 'Relationship-building is cultural. Multiple calls before the close is normal.'],
        'Dubai': ['Dubai clients are <strong>HNW international investors</strong>. Lead with exclusivity and global access.', 'Reference DIFC regulation and USD-pegged stability as trust anchors.', 'Formal opener. Avoid calls during prayer times and Ramadan evenings.'],
        'São Paulo': ['São Paulo is Brazil\'s <strong>financial capital</strong> — investment-forward, ambitious clientele.', 'Brazilians are warm — match their energy and enthusiasm. Don\'t be stiff.', 'Reference BRL volatility and inflation as a natural hedge conversation.'],
        'Singapore': ['Singapore clients are <strong>extremely sophisticated</strong> — they research everything before a call.', 'MAS regulation and compliance credentials are essential trust signals.', 'Refer to SGD stability and APAC market access as selling points.'],
        'Sydney': ['Sydney is Australia\'s <strong>financial centre</strong> — ASX-aware, investment-literate clients.', 'Australians appreciate informality and humour — don\'t be overly corporate.', 'Reference AUD volatility and commodity market exposure as natural hooks.'],
        'Johannesburg': ['Johannesburg is South Africa\'s <strong>financial hub</strong> — ZAR volatility makes clients receptive to alternatives.', 'Reference JSE and rand depreciation as motivation for portfolio diversification.', 'English works well. Formal opener then shift to a collaborative tone.'],
      };
      if (cityTips[city]) return cityTips[city];
      const tips = {
        'Germany': ['Germans value <strong>punctuality and directness</strong> — get to the value fast.', 'Avoid small talk. Lead with facts and performance data.', 'Quality and reliability outperform price as selling points.'],
        'United Kingdom': ['British understatement — <strong>don\'t oversell</strong>, let the product speak.', 'Light humour works as an icebreaker. Then pivot to business.', 'Reference FCA-regulated credentials if relevant.'],
        'UK': ['British understatement — <strong>don\'t oversell</strong>, let the product speak.', 'Light humour works as an icebreaker. Then pivot to business.', 'Reference FCA-regulated credentials if relevant.'],
        'France': ['French clients value <strong>sophistication and exclusivity</strong>. Lead with prestige.', 'Don\'t rush — allow space for deliberation. Never appear pushy.', 'Afternoon 14:00–17:00 local performs best. Avoid lunch.'],
        'Spain': ['<strong>Warm, relationship-first</strong> opener — ask how their day is.', 'Spanish clients respond strongly to social proof and success stories.', 'Evening calls after 17:00 outperform morning calls.'],
        'Italy': ['<strong>Personal connection</strong> matters before business. Match their energy.', 'Italians respect passion and expertise. Show genuine enthusiasm.', 'Midweek afternoons are optimal — avoid Monday mornings.'],
        'Israel': ['Israelis are <strong>direct and high-energy</strong> — match their pace immediately.', 'Lead with value and ROI. No filler, no fluff.', 'Hebrew or English both work. Reference TA Stock Exchange conditions.'],
        'Russia': ['Use formal address first — <strong>full name</strong>. Build authority before pitching.', 'Russians respond to concrete numbers and verifiable proof.', 'Patience required — decisions take multiple calls.'],
        'Ukraine': ['<strong>English or Russian</strong> both understood. Avoid political topics entirely.', 'Ukrainian market is recovery-focused — emphasise stability and security.', 'Afternoon calls 14:00–18:00 work best.'],
        'Turkey': ['<strong>Warm opener</strong> — Turkish clients enjoy conversation before business.', 'Trust builds gradually, across multiple calls. Don\'t rush the close.', 'Reference Istanbul\'s position as a bridge between East and West.'],
        'Poland': ['Polish clients are <strong>analytical</strong> — have data and comparisons ready.', 'Emphasise security, regulation, and downside protection.', 'Afternoon calls 13:00–17:00 perform best.'],
        'Netherlands': ['Dutch are <strong>extremely direct</strong> — no fluff, go straight to the numbers.', 'Transparency and honesty are non-negotiable values.', 'Sustainability and efficiency resonate strongly.'],
        'Brazil': ['Brazilians are <strong>warm and conversational</strong> — match their energy.', 'Build rapport fully before pitching. Rushing kills conversions.', 'Portuguese preferred. Energy peaks midday.'],
        'South Africa': ['South Africans are <strong>informal and friendly</strong>. Match casual energy.', 'Morning calls 09:00–11:00 local time perform well.', 'Reference rand/USD volatility as a relevant hook.'],
        'Australia': ['Australians are <strong>informal and direct</strong>. Skip corporate formality.', 'Emphasise simplicity and proven results over complexity.', 'Morning Sydney time 09:00–11:00 is peak performance window.'],
        'Canada': ['Canadians are <strong>polite and methodical</strong>. Never pressure.', 'Build rapport with genuine interest. Facts matter more than emotion.', 'English and French both in use — match their language.'],
        'India': ['<strong>Respect is key</strong> — address formally before getting to business.', 'Indian clients respond to detailed explanations and trust signals.', 'Afternoon 15:00–18:00 IST avoids peak distraction hours.'],
        'Singapore': ['Singapore clients are <strong>sophisticated and metrics-driven</strong>.', 'Lead with performance data and regulatory compliance.', 'English works perfectly. Punctuality signals professionalism.'],
        'Greece': ['Greek clients value <strong>personal rapport</strong> before any business discussion.', 'Emphasise Mediterranean market conditions and EUR stability.', 'Avoid calling 13:00–15:00 local — midday breaks are respected.'],
        'Cyprus': ['Cyprus is an <strong>international finance hub</strong> — many clients are sophisticated investors.', 'English and Greek both work. Reference CySEC regulation positively.', 'Morning calls before midday perform best.'],
        'Malta': ['Malta is <strong>English-speaking and finance-forward</strong>. Very international mindset.', 'Reference MGA regulation and EU membership as trust signals.', 'Morning calls are most effective.'],
        'Romania': ['Romanian clients are <strong>price-sensitive but ambitious</strong>. Lead with upside.', 'Emphasise reliability and proven performance records.', 'Afternoon 14:00–17:00 local works well.'],
        'Hungary': ['<strong>Formal opener</strong> required — titles matter. Build respect before pitching.', 'Hungarians are methodical and research things before deciding.', 'Midweek afternoon calls perform best.'],
        'Sweden': ['Swedes value <strong>equality and consensus</strong> — never be aggressive.', 'Sustainability and long-term thinking resonate strongly.', 'Morning calls before 10:00 are effective. Avoid Friday afternoons.'],
      };
      return tips[name] || [
        (city ? '<strong>' + city + '</strong> — research local economic conditions before the call.' : 'Research local market conditions before calling.'),
        'Match the local time of day to the client\'s energy level.',
        'Reference something relevant to their country\'s current economic conditions.',
      ];
    },

    c1CityMapUrl(client) {
      const parts = [client.location, client.country && (client.country.name || client.country.country_name)].filter(Boolean);
      return 'https://www.google.com/maps/search/' + encodeURIComponent(parts.join(', '));
    },

    c1ScIsLate(client) {
      if (!client.scheduled_calls || !client.scheduled_calls.length) return false;
      const sc = client.scheduled_calls[0];
      const t = sc.scheduled_on || sc.call_at;
      return t && new Date(t) < new Date() && !sc.ended;
    },

    c1LeadAgents(leads) {
      const names = (leads || []).map(l => {
        if (!l.user) return null;
        return l.user.full_name || ((l.user.first_name || '') + ' ' + (l.user.last_name || '')).trim() || null;
      }).filter(Boolean);
      const unique = [];
      names.forEach(n => { if (!unique.includes(n)) unique.push(n); });
      return unique.join(', ') || '—';
    },

    c1StartEdit(cid, field, currentVal) {
      this.$set(this.c1ContactEdit, cid + '-' + field, { val: currentVal, prev: currentVal });
    },

    c1ApiHeaders() {
      const token = localStorage.getItem('user-token');
      return { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', 'Accept': 'application/json' };
    },

    async c1SaveContact(client, field) {
      const key = client.id + '-' + field;
      const entry = this.c1ContactEdit[key];
      if (!entry) return;
      const newVal = (entry.val || '').trim();
      const prevVal = entry.prev;
      if (newVal === prevVal) { this.$delete(this.c1ContactEdit, key); return; }

      // Optimistic UI update
      if (field === 'name') {
        const parts = newVal.split(' ');
        client.first_name = parts[0] || '';
        client.last_name = parts.slice(1).join(' ') || '';
      } else if (field === 'phone' && client.phones && client.phones[0]) {
        client.phones[0].contact_value = newVal;
      } else if (field === 'email' && client.emails && client.emails[0]) {
        client.emails[0].contact_value = newVal;
      } else if (field === 'location') {
        client.location = newVal;
      }

      this.c1LogEdit(client.id, field, prevVal, newVal);
      this.$delete(this.c1ContactEdit, key);

      // Persist to API
      try {
        const h = this.c1ApiHeaders();
        if (field === 'name') {
          const parts = newVal.split(' ');
          await fetch('/api/client/' + client.id, {
            method: 'PUT',
            headers: h,
            body: JSON.stringify({ first_name: parts[0] || '', last_name: parts.slice(1).join(' ') || '', birth_date: client.birth_date || null })
          });
        } else if (field === 'phone' && client.phones && client.phones[0]) {
          await fetch('/api/client/phones', {
            method: 'PUT',
            headers: h,
            body: JSON.stringify({ phones: [{ id: client.phones[0].id, contact_value: newVal, is_primary: client.phones[0].is_primary || 0 }] })
          });
        } else if (field === 'email' && client.emails && client.emails[0]) {
          await fetch('/api/client/emails', {
            method: 'PUT',
            headers: h,
            body: JSON.stringify({ emails: [{ id: client.emails[0].id, contact_value: newVal, is_primary: client.emails[0].is_primary || 0, deposit_email: client.emails[0].deposit_email || 0 }] })
          });
        }
      } catch (e) {
        console.warn('[c1SaveContact] API error:', e);
      }
    },

    c1LogEdit(cid, field, oldVal, newVal) {
      if (!this.c1EditLog[cid]) this.$set(this.c1EditLog, cid, []);
      const u = this.auth && this.auth.user;
      const who = u ? (u.full_name || ((u.first_name || '') + ' ' + (u.last_name || '')).trim() || u.username || 'You') : 'You';
      this.c1EditLog[cid].push({ field, oldVal, newVal, at: new Date(), who });
    },

    async c1SaveLocation(client) {
      const cityKey = client.id + '-location';
      const countryKey = client.id + '-country-val';
      const newCity = (this.c1ContactEdit[cityKey] && this.c1ContactEdit[cityKey].val) || '';
      const newCountry = this.c1ContactEdit[countryKey] || null;
      const prevCity = this.c1ContactEdit[cityKey] && this.c1ContactEdit[cityKey].prev;

      // Optimistic UI update + log
      if (newCity && newCity !== prevCity) {
        client.location = newCity;
        this.c1LogEdit(client.id, 'city', prevCity, newCity);
      }
      if (newCountry) {
        const prevCountry = client.country ? (typeof client.country === 'object' ? client.country.name : client.country) : '—';
        client.country = newCountry;
        this.c1LogEdit(client.id, 'country', prevCountry, newCountry.name);
      }

      // Persist country to API
      if (newCountry && newCountry.id) {
        try {
          await fetch('/api/client/country/' + client.id, {
            method: 'PUT',
            headers: this.c1ApiHeaders(),
            body: JSON.stringify({ country_id: newCountry.id })
          });
        } catch (e) {
          console.warn('[c1SaveLocation] country API error:', e);
        }
      }

      this.c1CancelLocation(client);
    },

    c1CancelLocation(client) {
      this.$delete(this.c1ContactEdit, client.id + '-location');
      this.$delete(this.c1ContactEdit, client.id + '-country-val');
      this.$delete(this.c1ContactEdit, client.id + '-country-search');
    },

    c1OnPlaceChanged(client, place) {
      if (!place || !place.address_components) return;
      let city = '', country = null;
      place.address_components.forEach(comp => {
        if (comp.types.includes('locality')) city = comp.long_name;
        if (comp.types.includes('administrative_level_1') && !city) city = comp.long_name;
        if (comp.types.includes('country')) {
          const found = (this.dictionaries && this.dictionaries.general && this.dictionaries.general.countries || []).find(c => c.iso === comp.short_name || c.name === comp.long_name);
          country = found || { name: comp.long_name };
        }
      });
      if (city) this.$set(this.c1ContactEdit, client.id + '-location', { val: city, prev: this.c1ContactEdit[client.id + '-location'] && this.c1ContactEdit[client.id + '-location'].prev });
      if (country) this.$set(this.c1ContactEdit, client.id + '-country-val', country);
      this.$delete(this.c1ContactEdit, client.id + '-country-search');
    },

    c1FilteredCountries(search) {
      const list = (this.dictionaries && this.dictionaries.general && this.dictionaries.general.countries) || [];
      if (!search) return list.slice(0, 8);
      const s = search.toLowerCase();
      return list.filter(c => c.name && c.name.toLowerCase().includes(s)).slice(0, 10);
    },

    c1SelectCountry(client, country) {
      this.$set(this.c1ContactEdit, client.id + '-country-val', country);
      this.$delete(this.c1ContactEdit, client.id + '-country-search');
    },

    c1OsmSearch(client) {
      const q = this.c1ContactEdit[client.id + '-osm-q'];
      if (!q || q.length < 2) {
        this.$set(this.c1ContactEdit, client.id + '-osm-results', []);
        return;
      }
      clearTimeout(this._osmTimer);
      this._osmTimer = setTimeout(() => {
        fetch('https://nominatim.openstreetmap.org/search?q=' + encodeURIComponent(q) + '&format=json&limit=6&addressdetails=1')
          .then(r => r.json())
          .then(data => { this.$set(this.c1ContactEdit, client.id + '-osm-results', data); })
          .catch(() => {});
      }, 400);
    },

    c1OsmSelect(client, r) {
      const addr = r.address || {};
      const city = addr.city || addr.town || addr.village || addr.county || r.display_name.split(',')[0];
      const countryName = (addr.country || '').toLowerCase();
      const list = (this.dictionaries && this.dictionaries.general && this.dictionaries.general.countries) || [];
      const matched = list.find(c => c.name && c.name.toLowerCase() === countryName);
      const prevEntry = this.c1ContactEdit[client.id + '-location'];
      this.$set(this.c1ContactEdit, client.id + '-location', { val: city, prev: prevEntry ? prevEntry.prev : '' });
      if (matched) this.$set(this.c1ContactEdit, client.id + '-country-val', matched);
      this.$set(this.c1ContactEdit, client.id + '-osm-results', []);
      this.$delete(this.c1ContactEdit, client.id + '-osm-q');
    },

    c1FullActivityLog(client) {
      const events = [];
      const addUser = u => u ? (u.full_name || ((u.first_name || '') + ' ' + (u.last_name || '')).trim()) : null;

      (client.leads || []).forEach(e => events.push({ t: new Date(e.created_at), type: 'LD', label: e.campaign ? e.campaign.name : (e.campaign_id ? 'Broker #' + e.campaign_id : 'Lead'), color: '#D4A017', agent: addUser(e.user), date: this.fmtShort(e.created_at), ago: this.c1TimeAgo(e.created_at) }));
      (client.na || []).forEach(e => events.push({ t: new Date(e.created_at), type: 'NA', label: e.is_vm ? 'Voicemail' : 'No Answer', color: '#E05A3A', agent: addUser(e.user), date: this.fmtShort(e.created_at), ago: this.c1TimeAgo(e.created_at) }));
      (client.deposits || []).forEach(e => events.push({ t: new Date(e.created_at), type: 'DP', label: (e.amount || 'Deposit') + (e.payment_method ? ' · ' + e.payment_method : ''), color: '#7C5CFC', agent: null, date: this.fmtShort(e.created_at), ago: this.c1TimeAgo(e.created_at) }));
      (client.scheduled_calls || []).forEach(e => events.push({ t: new Date(e.scheduled_on || e.call_at), type: 'SC', label: e.ended ? 'Ended' : (e.is_missed ? 'Missed' : 'Scheduled') + (e.status ? ' · ' + e.status.name : ''), color: '#E8891C', agent: addUser(e.user), date: this.fmtShort(e.scheduled_on || e.call_at), ago: this.c1TimeAgo(e.scheduled_on || e.call_at) }));
      (client.referrals || []).forEach(e => events.push({ t: new Date(e.created_at), type: 'RF', label: 'Referral', color: '#C75450', agent: addUser(e.user), date: this.fmtShort(e.created_at), ago: this.c1TimeAgo(e.created_at) }));
      (client.bn || []).forEach(e => events.push({ t: new Date(e.created_at), type: 'BN', label: 'Bad Number', color: '#7A7069', agent: addUser(e.user), date: this.fmtShort(e.created_at), ago: this.c1TimeAgo(e.created_at) }));
      // Local edits made this session
      (this.c1EditLog[client.id] || []).forEach(e => {
        const fieldLabel = { name: 'Name', phone: 'Phone', email: 'Email', location: 'City', city: 'City', country: 'Country' }[e.field] || e.field;
        const timeStr = e.at.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
        events.push({ t: e.at, type: 'EDIT', label: fieldLabel + ': ' + (e.oldVal || '—') + ' → ' + e.newVal, color: '#64748b', agent: (e.who || 'You') + ' · ' + timeStr, date: this.fmtShort(e.at), ago: this.c1TimeAgo(e.at) });
      });

      events.sort((a, b) => b.t - a.t);

      // Add gap labels between entries
      return events.map((ev, i) => {
        if (i === 0) return { ...ev, gap: null };
        const prev = events[i - 1];
        const diffMs = prev.t - ev.t;
        const diffH = Math.floor(diffMs / 3600000);
        const diffD = Math.floor(diffMs / 86400000);
        let gap = null;
        if (diffD >= 1) gap = diffD + 'd gap';
        else if (diffH >= 1) gap = diffH + 'h gap';
        return { ...ev, gap };
      });
    },

    c1LeadImpLabel(client) {
      const score = parseInt(client.is_leading) || 0;
      const days = client.created_at ? Math.floor((Date.now() - new Date(client.created_at)) / 86400000) : 99;
      const calls = Array.isArray(client.na) ? client.na.length : 0;
      if (score >= 10 || (days <= 1 && calls === 0)) return '🔥 HOT';
      if (score >= 1 || days <= 3) return 'WARM';
      if (days <= 7) return 'COOL';
      return 'COLD';
    },

    c1LeadImpClass(client) {
      const lbl = this.c1LeadImpLabel(client);
      if (lbl === '🔥 HOT') return 'c1-imp-hot';
      if (lbl === 'WARM') return 'c1-imp-warm';
      if (lbl === 'COOL') return 'c1-imp-cool';
      return 'c1-imp-cold';
    },

    c1EmailDraftSet(cid, field, val) {
      if (!this.c1EmailDraft[cid]) this.$set(this.c1EmailDraft, cid, { subject: '', body: '', files: [] });
      this.$set(this.c1EmailDraft[cid], field, val);
    },

    c1EmailAttach(cid, event) {
      if (!this.c1EmailDraft[cid]) this.$set(this.c1EmailDraft, cid, { subject: '', body: '', files: [] });
      const existing = this.c1EmailDraft[cid].files || [];
      this.$set(this.c1EmailDraft[cid], 'files', [...existing, ...Array.from(event.target.files)]);
    },

    c1EmailRemoveFile(cid, idx) {
      const files = [...(this.c1EmailDraft[cid] && this.c1EmailDraft[cid].files || [])];
      files.splice(idx, 1);
      this.$set(this.c1EmailDraft[cid], 'files', files);
    },

    c1SendEmail(client) {
      const draft = this.c1EmailDraft[client.id] || {};
      if (!draft.subject && !draft.body) return;
      // TODO: POST to /api/email/send with client.id, to, subject, body, files
      alert('Email queued: ' + (draft.subject || '(no subject)'));
    },

    // Returns client local time at a specific timestamp (for NA history)
    c1NaClientTimeAt(ts, client) {
      if (!client.country || !ts) return '';
      const tz = this.c1CountryTz(client.country.name || '');
      if (!tz) return '';
      try {
        return new Date(ts).toLocaleString('en-GB', { timeZone: tz, hour: '2-digit', minute: '2-digit', hour12: false });
      } catch(e) { return ''; }
    },

    // Returns time-of-day label for client at a specific timestamp
    c1NaTodAt(ts, client) {
      if (!client.country || !ts) return null;
      const tz = this.c1CountryTz(client.country.name || '');
      if (!tz) return null;
      try {
        const hourStr = new Date(ts).toLocaleString('en-US', { timeZone: tz, hour: 'numeric', hour12: false });
        const h = parseInt(hourStr);
        if (h >= 5 && h < 9)  return { label: 'Morning',   cls: 'c1-tod-morning',   icon: '🌅' };
        if (h >= 9 && h < 14) return { label: 'Day',       cls: 'c1-tod-day',       icon: '☀️' };
        if (h >= 14 && h < 18)return { label: 'Afternoon', cls: 'c1-tod-afternoon', icon: '🌤️' };
        if (h >= 18 && h < 22)return { label: 'Evening',   cls: 'c1-tod-evening',   icon: '🌆' };
        return { label: 'Night', cls: 'c1-tod-night', icon: '🌙' };
      } catch(e) { return null; }
    },

    // Gap label between naList[idx] and naList[idx+1] (array is newest-first)
    c1NaGapLabel(naList, idx) {
      if (idx >= naList.length - 1) return null;
      const curr = new Date(naList[idx].created_at).getTime();
      const older = new Date(naList[idx + 1].created_at).getTime();
      const diff = curr - older;
      if (diff <= 0) return null;
      const m = Math.round(diff / 60000);
      if (m < 60) return '+' + m + 'min';
      const h = Math.floor(m / 60);
      const rm = m % 60;
      return '+' + h + 'h' + (rm ? ' ' + rm + 'm' : '');
    },

    // Summary stats for the NA panel
    c1NaStats(naList, client) {
      if (!naList || !naList.length) return null;
      const lastAgo = this.c1TimeAgo(naList[0].created_at);
      let avgGap = null;
      if (naList.length > 1) {
        const newest = new Date(naList[0].created_at).getTime();
        const oldest = new Date(naList[naList.length - 1].created_at).getTime();
        const avgMs = (newest - oldest) / (naList.length - 1);
        const m = Math.round(avgMs / 60000);
        if (m < 60) avgGap = m + 'min';
        else {
          const h = Math.floor(m / 60);
          const rm = m % 60;
          avgGap = h + 'h' + (rm ? ' ' + rm + 'm' : '');
        }
      }
      const agentNames = [...new Set(naList.map(na => {
        if (!na.user) return null;
        return na.user.full_name || (na.user.first_name + ' ' + na.user.last_name);
      }).filter(Boolean))];
      return { lastAgo, avgGap, agentNames };
    },

    c1OpenNewSlide(client) {
      this.c1CardSelected = client.id;
      this.c1OpenTag = { cid: client.id, type: 'new', idx: 0 };
    },

    c1ApplyDateFilter(preset) {
      this.c1DateFilter = preset;
      const today = moment().format("YYYY-MM-DD");
      const weekStart = moment().startOf("isoWeek").format("YYYY-MM-DD");
      const monthStart = moment().startOf("month").format("YYYY-MM-DD");
      // Clear existing reg date filters
      this.filters.registered_on_from = null;
      this.filters.registered_on_to = null;
      let s = null, e = null;
      if (preset === "today") {
        s = today; e = today;
      } else if (preset === "week") {
        s = weekStart; e = today;
      } else if (preset === "month") {
        s = monthStart; e = today;
      } else if (preset === "lastmonth") {
        s = moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD");
        e = moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD");
      }
      if (s) { this.filters.registered_on_from = s; this.filters.registered_on_to = e; }
      this.c1Cal.start = s; this.c1Cal.end = e;
      if (s) {
        // Navigate calendar to the start month
        const m = moment(s);
        this.c1Cal.year = m.year();
        this.c1Cal.month = m.month();
      }
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
    },

    c1SetActive(active) {
      this.resetAllFilters();
      if (!active) {
        this.filters.active = false;
        this.filters.ended = true;
      }
      this.debouncedClientsQuery();
    },

    async c1LoadSector(key) {
      const cfg = this.c1SectorCfg[key];
      if (!cfg || this.c1SectorLoading[key]) return;
      this.$set(this.c1SectorLoading, key, true);
      try {
        const params = { ...(this.getQueryParamsToMs || {}) };
        // Strip this sector's own filter keys — otherwise API returns empty when sector already filtered
        (cfg.strip || []).forEach(k => delete params[k]);
        const res = await apiClientCreator(cfg.endpoint).get("", { params });
        this.$set(this.c1SectorData, key, res.data || []);
      } catch(e) {
        this.$set(this.c1SectorData, key, []);
      } finally {
        this.$set(this.c1SectorLoading, key, false);
      }
    },

    c1SectorInitials(item) {
      const n = item.title || item.name || item.alias || '?';
      const parts = n.trim().split(/\s+/);
      return (parts[0][0] || '').toUpperCase() + (parts[1] ? parts[1][0].toUpperCase() : '');
    },

    c1SectorToggle(key, id) {
      const cur = this.c1SectorSelected[key];
      if (cur.includes(id)) {
        this.$set(this.c1SectorSelected, key, cur.filter(x => x !== id));
      } else {
        this.$set(this.c1SectorSelected, key, [...cur, id]);
      }
    },

    c1SectorApply(key) {
      const val = this.c1SectorSelected[key].map(id => ({ id }));
      switch (key) {
        case 'dp': this.depositUserFilter(val);        this.applyDpMs(); break;
        case 'ld': this.leadsCampaignUsersFilter(val); this.applyLdMs(); break;
        case 'na': this.naUsersMsFilter(val);          this.applyNaMs(); break;
        case 'rf': this.referralUsersFilter(val);      this.applyRfMs(); break;
        case 'sc': this.caMsUsers(val);                this.applyScMs(); break;
        case 'tr': this.transByFilter(val);            this.applyTrMs(); break;
      }
    },

    c1SectorReset(key) {
      this.$set(this.c1SectorSelected, key, []);
      this.$set(this.c1SectorData, key, null);
      switch (key) {
        case 'dp': this.resetDpMs(); break;
        case 'ld': this.resetLdMs(); break;
        case 'na': this.resetNaMs(); break;
        case 'rf': this.resetRfMs(); break;
        case 'sc': this.resetScMs(); break;
        case 'tr': this.resetTrMs(); break;
      }
      this.c1LoadSector(key);
    },

    c1PillMs(key) {
      const isSame = this.c1SlideOpen === 'filters' && this.c1FilterTab === key;
      if (isSame) {
        this.c1SlideOpen = null;
        this.c1FilterTab = 'status';
      } else {
        this.c1SlideOpen = 'filters';
        this.c1FilterTab = key;
      }
    },

    c1CloseAllMs() {
      this.c1SlideOpen = null;
      this.c1FilterTab = 'status';
      this.debouncedClientsQuery();
    },

    // MS apply wrappers — mark sector as having active filters, then query
    applyDpMs() { this.msApplied.dp = true; this.debouncedClientsQuery(); },
    applyLdMs() { this.msApplied.ld = true; this.debouncedClientsQuery(); },
    applyNaMs() { this.msApplied.na = true; this.debouncedClientsQuery(); },
    applyRfMs() { this.msApplied.rf = true; this.debouncedClientsQuery(); },
    applyScMs() { this.msApplied.sc = true; this.debouncedClientsQuery(); },
    applyTrMs() { this.msApplied.tr = true; this.debouncedClientsQuery(); },
    // MS reset wrappers — clear applied flag, then call base reset
    resetDpMs() { this.msApplied.dp = false; this.resetDPSelectors(); },
    resetLdMs() { this.msApplied.ld = false; this.resetLDselector(); },
    resetNaMs() { this.msApplied.na = false; this.resetNAselectors(); },
    resetRfMs() { this.msApplied.rf = false; this.resetRFSelectors(); },
    resetScMs() { this.msApplied.sc = false; this.resetCAselectors(); },
    resetTrMs() { this.msApplied.tr = false; this.resetTRselector(); },

    // Override mixin click-outside handlers — they fire on fixed bottom-sheet clicks
    // which are technically outside .c1-bb-pill; use backdrop overlay instead
    depOutClose() {},
    leadOutClose() {},
    naOutClose() {},
    refOutClose() {},
    caOutClose() {},
    transOutClose() {},

    c1SetGlobalDR(preset) {
      this.c1GlobalDR = preset;
      ['dep', 'ld', 'na', 'sc', 'rf', 'overview'].forEach(k => this.$set(this.c1ChartDR, k, preset));
      const open = this.c1ChartOpenSections;
      if (open.includes('overview')) this.c1LoadTodayChart();
      if (open.includes('deposits')) this.c1LoadChartDeposits();
      if (open.includes('leads')) this.c1LoadChartLeads();
      if (open.includes('na')) this.c1LoadChartNA();
      if (open.includes('sc')) this.c1LoadChartSC();
      if (open.includes('rf')) this.c1LoadChartRF();
      if (open.includes('akg')) this.c1LoadChartAKG();
      if (open.includes('timeline')) this.c1LoadTimeline();
    },

    c1ToggleVikiSection(key) {
      const i = this.c1VikiOpenSections.indexOf(key);
      if (i >= 0) this.c1VikiOpenSections.splice(i, 1);
      else this.c1VikiOpenSections.push(key);
    },
    c1IsVikiSection(key) {
      return this.c1VikiOpenSections.includes(key);
    },
    c1VikiCoffee() {
      this.c1VikiCoffeeOrdered = true;
      setTimeout(() => { this.c1VikiCoffeeOrdered = false; }, 4000);
    },
    c1VikiMotivate() {
      this.c1VikiMotivated = true;
      setTimeout(() => { this.c1VikiMotivated = false; }, 4000);
    },

    // ---- Real Chart Data Loaders ----

    c1GetQueryParams() {
      const p = {};
      p.special_req = true;
      return p;
    },

    // Compute from/to dates for a given preset alias
    c1PresetDates(preset) {
      const fmt = d => this.$moment ? this.$moment(d).format('YYYY-MM-DD') : new Date(d).toISOString().slice(0, 10);
      const today = new Date(); today.setHours(0,0,0,0);
      const fy = d => { const n = new Date(d); return n.getFullYear()+'-'+String(n.getMonth()+1).padStart(2,'0')+'-'+String(n.getDate()).padStart(2,'0'); };
      const todayStr = fy(today);
      if (preset === 'TODAY')     return { from: todayStr, to: todayStr };
      if (preset === 'YESTERDAY') { const y = new Date(today); y.setDate(y.getDate()-1); const ys = fy(y); return { from: ys, to: ys }; }
      if (preset === 'WEEK')      { const s = new Date(today); s.setDate(s.getDate() - ((s.getDay()+6)%7)); return { from: fy(s), to: todayStr }; }
      if (preset === 'MONTH')     { const s = new Date(today.getFullYear(), today.getMonth(), 1); return { from: fy(s), to: todayStr }; }
      if (preset === 'FUTURE')    { const e = new Date(today); e.setMonth(e.getMonth()+3); return { from: todayStr, to: fy(e) }; }
      return { from: '2000-01-01', to: todayStr }; // ALL — wide range forces live query
    },

    c1SetDR(section, preset) {
      this.$set(this.c1ChartDR, section, preset);
      if (section === 'dep') this.c1LoadChartDeposits();
      else if (section === 'ld') this.c1LoadChartLeads();
      else if (section === 'na') this.c1LoadChartNA();
      else if (section === 'sc') this.c1LoadChartSC();
      else if (section === 'rf') this.c1LoadChartRF();
      else if (section === 'overview') this.c1LoadTodayChart();
    },

    c1LoadChartDeposits() {
      const sub = this.c1DepSubTab || 'users';
      this.c1ChartLoading = { ...this.c1ChartLoading, dep: true };
      const params = this.c1GetQueryParams();
      const dr = this.c1PresetDates(this.c1ChartDR.dep);
      if (dr.from) { params.deposit_at_from = dr.from; params.deposit_at_to = dr.to; }
      apiClientCreator(`client/stats/tag/dep/${sub}/0`).get('', { params }).then(res => {
        const raw = Array.isArray(res.data) ? res.data : (res.data.data || []);
        this.c1ChartDeps = raw
          .filter(r => (r.overall_count || 0) > 0)
          .sort((a, b) => b.overall_count - a.overall_count)
          .slice(0, 20)
          .map(r => ({
            id: r.id || r.broker_id,
            name: sub === 'users'
              ? (r.title && (r.title.full_name || r.title.username) || '—')
              : (r.broker && (r.broker.name || r.broker.full_name) || '—'),
            count: r.overall_count || 0,
            ccCount: r.overall_cc || 0
          }));
        this.c1ChartLoading = { ...this.c1ChartLoading, dep: false };
      }).catch(() => { this.c1ChartLoading = { ...this.c1ChartLoading, dep: false }; });
    },

    c1LoadChartLeads() {
      this.c1ChartLoading = { ...this.c1ChartLoading, ld: true };
      const params = this.c1GetQueryParams();
      const dr = this.c1PresetDates(this.c1ChartDR.ld);
      if (dr.from) { params.deposit_at_from = dr.from; params.deposit_at_to = dr.to; }
      apiClientCreator('client/stats/tag/ld_chart').get('', { params }).then(res => {
        const raw = Array.isArray(res.data) ? res.data : (res.data.data || []);
        this.c1ChartLeads = raw
          .filter(r => (r.count || 0) > 0)
          .sort((a, b) => b.count - a.count)
          .slice(0, 20)
          .map(r => ({ id: r.user_id, name: r.full_name || '—', count: r.count }));
        this.c1ChartLoading = { ...this.c1ChartLoading, ld: false };
      }).catch(() => { this.c1ChartLoading = { ...this.c1ChartLoading, ld: false }; });
    },

    c1LoadChartNA() {
      this.c1ChartLoading = { ...this.c1ChartLoading, na: true };
      const params = this.c1GetQueryParams();
      const dr = this.c1PresetDates(this.c1ChartDR.na);
      if (dr.from) { params.deposit_at_from = dr.from; params.deposit_at_to = dr.to; }
      apiClientCreator('client/stats/tag/na/0').get('', { params }).then(res => {
        const raw = Array.isArray(res.data) ? res.data : (res.data.data || []);
        this.c1ChartNA = raw
          .filter(r => (r.count || 0) > 0)
          .sort((a, b) => b.count - a.count)
          .slice(0, 20)
          .map(r => ({ id: r.user_id, name: r.full_name || '—', count: r.count }));
        this.c1ChartLoading = { ...this.c1ChartLoading, na: false };
      }).catch(() => { this.c1ChartLoading = { ...this.c1ChartLoading, na: false }; });
    },

    c1LoadChartSC() {
      this.c1ChartLoading = { ...this.c1ChartLoading, sc: true };
      const params = this.c1GetQueryParams();
      const dr = this.c1PresetDates(this.c1ChartDR.sc);
      if (dr.from) {
        if (this.c1ChartDR.sc === 'FUTURE') {
          params.scheduled_call_to_from = dr.from;
          params.scheduled_call_to_to = dr.to;
        } else {
          params.deposit_at_from = dr.from;
          params.deposit_at_to = dr.to;
        }
      }
      apiClientCreator('client/stats/tag/ca/user/0').get('', { params }).then(res => {
        const raw = Array.isArray(res.data) ? res.data : (res.data.data || []);
        this.c1ChartSC = raw
          .filter(r => (r.count || 0) > 0)
          .sort((a, b) => b.count - a.count)
          .slice(0, 20)
          .map(r => ({ id: r.user_id, name: (r.user && r.user.full_name) || r.full_name || '—', count: r.count }));
        this.c1ChartLoading = { ...this.c1ChartLoading, sc: false };
      }).catch(() => { this.c1ChartLoading = { ...this.c1ChartLoading, sc: false }; });
    },

    // ---- Chart Click Handlers (set filters + query) ----

    c1ClickDepChart(item) {
      const alreadyActive = this.c1ChartActiveId.dep === item.id;
      if (alreadyActive) {
        this.c1ClearChartFilter();
        return;
      }
      this.c1ChartActiveId = { ...this.c1ChartActiveId, dep: item.id };
      this.c1ChartActiveFilter = 'dep';
      this.filters.deposit = true;
      if (this.c1DepSubTab === 'users') {
        this.filters.deposit_users = [{ id: item.id }];
        this.filters.deposit_brokers = [];
      } else {
        this.filters.deposit_brokers = [{ id: item.id }];
        this.filters.deposit_users = [];
      }
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
    },

    c1ClickLdChart(item) {
      const alreadyActive = this.c1ChartActiveId.ld === item.id;
      if (alreadyActive) {
        this.c1ClearChartFilter();
        return;
      }
      this.c1ChartActiveId = { ...this.c1ChartActiveId, ld: item.id };
      this.c1ChartActiveFilter = 'ld';
      this.filters.leads = true;
      this.filters.lead_campaigns = [{ id: item.id }];
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
    },

    c1ClickNAChart(item) {
      const alreadyActive = this.c1ChartActiveId.na === item.id;
      if (alreadyActive) {
        this.c1ClearChartFilter();
        return;
      }
      this.c1ChartActiveId = { ...this.c1ChartActiveId, na: item.id };
      this.c1ChartActiveFilter = 'na';
      this.filters.na = true;
      this.filters.na_users = [{ id: item.id }];
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
    },

    c1ClickSCChart(item) {
      const alreadyActive = this.c1ChartActiveId.sc === item.id;
      if (alreadyActive) {
        this.c1ClearChartFilter();
        return;
      }
      this.c1ChartActiveId = { ...this.c1ChartActiveId, sc: item.id };
      this.c1ChartActiveFilter = 'sc';
      this.filters.scheduled_calls = true;
      this.filters.ca_users = [{ id: item.id }];
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
    },

    c1ClickTimelinePoint(pt) {
      const alreadyActive = this.c1ChartActiveId.tl === pt.label;
      if (alreadyActive) {
        this.c1ClearChartFilter();
        return;
      }
      this.c1ChartActiveId = { ...this.c1ChartActiveId, tl: pt.label };
      this.c1ChartActiveFilter = 'tl';
      this.filters.deposit = true;
      this.filters.deposit_at_from = pt.label;
      this.filters.deposit_at_to = pt.label;
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
    },

    c1ClearChartFilter() {
      this.c1ChartActiveFilter = null;
      this.c1ChartActiveId = { dep: null, ld: null, na: null, sc: null, tl: null };
      this.filters.deposit = false;
      this.filters.deposit_users = [];
      this.filters.deposit_brokers = [];
      this.filters.leads = false;
      this.filters.lead_campaigns = [];
      this.filters.na = false;
      this.filters.na_users = [];
      this.filters.scheduled_calls = false;
      this.filters.ca_users = [];
      delete this.filters.deposit_at_from;
      delete this.filters.deposit_at_to;
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
    },

    // ---- Chart helpers ----

    c1BarPct(item, list) {
      const max = Math.max(1, ...list.map(r => r.count));
      return Math.round((item.count / max) * 100);
    },

    c1BarPct2(item, list) {
      const max = Math.max(1, ...list.map(r => r.count));
      return Math.round(((item.ccCount || 0) / max) * 100);
    },

    c1BarPctVal(val, list) {
      const max = Math.max(1, ...list.map(p => p.val));
      return Math.round((val / max) * 100);
    },

    c1ShortName(name) {
      if (!name) return '—';
      const parts = name.trim().split(' ');
      if (parts.length >= 2) return parts[0] + ' ' + parts[1][0] + '.';
      return name.substring(0, 16);
    },

    c1TlX(i) {
      const pts = this.c1TimelinePoints;
      if (pts.length < 2) return 0;
      const W = 300, pad = 4;
      return ((i / (pts.length - 1)) * (W - 2 * pad) + pad).toFixed(1);
    },

    c1LbBarPct(agent) {
      const board = this.c1AgentLeaderboard;
      if (!board.length) return 0;
      const max = Math.max(1, board[0].dp_count || 0);
      return Math.round(((agent.dp_count || 0) / max) * 100);
    },

    c1TlY(val) {
      const pts = this.c1TimelinePoints;
      const max = Math.max(1, ...pts.map(p => p.val));
      const H = 80, pad = 4;
      return (H - pad - ((val / max) * (H - 2 * pad))).toFixed(1);
    },

    c1TlBuildLine(area) {
      const pts = this.c1TimelinePoints;
      if (pts.length < 2) return '';
      const W = 300, H = 80, pad = 4;
      const max = Math.max(1, ...pts.map(p => p.val));
      const coords = pts.map((p, i) => {
        const x = ((i / (pts.length - 1)) * (W - 2 * pad) + pad).toFixed(1);
        const y = (H - pad - ((p.val / max) * (H - 2 * pad))).toFixed(1);
        return x + ',' + y;
      });
      if (!area) return coords.join(' ');
      return coords.join(' ') + ` ${(W - pad).toFixed(1)},${H} ${pad},${H}`;
    },

    c1AgentPct(agent) {
      const board = this.c1AgentLeaderboard;
      if (!board.length) return 0;
      const max = Math.max(1, board[0].dp_count || 0);
      return Math.round(((agent.dp_count || 0) / max) * 100);
    },

    c1LoadTimeline() {
      this.c1ChartLoading = { ...this.c1ChartLoading, tl: true };
      const params = this.c1GetQueryParams();
      apiClientCreator("client/stats/deposits/volatility").get("", { params }).then(res => {
        const arr = Array.isArray(res.data) ? res.data : (res.data.data || []);
        if (arr.length) {
          this.c1TimelinePoints = arr.map((item, i) => ({
            val: item.count || item.value || item.total || 0,
            label: item.date || item.start || item.label || String(i)
          }));
        }
        this.c1ChartLoading = { ...this.c1ChartLoading, tl: false };
      }).catch(() => { this.c1ChartLoading = { ...this.c1ChartLoading, tl: false }; });
    },

    c1LoadLiveLeaderboard() {
      const dr = this.c1PresetDates(this.c1ChartDR.overview || 'MONTH');
      const params = { deposit_at_from: dr.from, deposit_at_to: dr.to };
      apiClientCreator('client/stats/multiselect/deposits/users').get('', { params }).then(res => {
        const raw = Array.isArray(res.data) ? res.data : (res.data && res.data.data) || [];
        const items = raw
          .filter(r => (Array.isArray(r.count) ? r.count[0] : r.count || 0) > 0)
          .sort((a, b) => (Array.isArray(b.count) ? b.count[0] : b.count || 0) - (Array.isArray(a.count) ? a.count[0] : a.count || 0))
          .slice(0, 10)
          .map(r => {
            const fullName = r.title || '—';
            const parts = fullName.split(' ');
            return {
              id: r.id,
              first_name: parts[0] || '?',
              last_name: parts.slice(1).join(' ') || '',
              dp_count: Array.isArray(r.count) ? r.count[0] : (r.count || 0)
            };
          });
        if (items.length) {
          this.c1AgentLeaderboard = items;
        } else {
          this.c1BuildLeaderboard();
        }
      }).catch(() => {
        this.c1BuildLeaderboard();
      });
    },

    c1BuildLeaderboard() {
      const agents = this.$store.state.clients.salesPersonList || [];
      if (!agents.length) return;
      this.c1AgentLeaderboard = agents
        .filter(a => (a.client_assignments_count || 0) > 0)
        .sort((a, b) => (b.client_assignments_count || 0) - (a.client_assignments_count || 0))
        .slice(0, 10)
        .map(a => ({ ...a, dp_count: a.client_assignments_count || 0 }));
    },

    // ---- FEATURE: Purple NA Time ----

    c1IsPurpleTime(client) {
      if (!this.c1PurpleTimeActive) return false;
      const regDate = client.registered_on || client.created_at;
      if (!regDate) return false;
      const regHour = new Date(regDate).getHours();
      const currentHour = new Date().getHours();
      return Math.abs(regHour - currentHour) <= 1;
    },

    c1TogglePurpleTime() {
      this.c1PurpleTimeActive = !this.c1PurpleTimeActive;
      this.$set(this.filters, 'purple_time', this.c1PurpleTimeActive ? 1 : null);
      this.pagination.currentPage = 1;
      this.debouncedClientsQuery();
    },

    // ---- FEATURE: History Channel ----

    addToHistory(client, statusOverride) {
      if (!client) return;
      const name = (client.first_name || '') + ' ' + (client.last_name || '');
      const status = statusOverride || this.clientStatus(client).c;
      let history = JSON.parse(localStorage.getItem('c1_history') || '[]');
      history = history.filter(h => h.id !== client.id);
      history.unshift({ id: client.id, name: name.trim(), status });
      history = history.slice(0, 10);
      localStorage.setItem('c1_history', JSON.stringify(history));
      this.historyChannel = history;
    },

    jumpToClient(clientId) {
      // Reset all filters silently (no query), then fire exactly ONE query for this client
      this.c1JumpTarget = clientId;
      Object.keys(this.filters).forEach(k => {
        const v = this.filters[k];
        if (typeof v === 'boolean') this.filters[k] = false;
        else if (Array.isArray(v)) this.filters[k] = [];
        else if (v !== null && typeof v === 'object') { /* skip */ }
        else if (typeof v === 'string') this.filters[k] = '';
        else this.filters[k] = null;
      });
      this.pagination.currentPage = 1;
      this.filters.client = '#' + clientId; // active stays false — finds assigned clients too
      this.debouncedClientsQuery();
    },

    c1HistoryTagColor(status) {
      const map = {
        DP: '#7C5CFC', LD: '#D4A017', NA: '#E05A3A', 'No Answer': '#E05A3A',
        SC: '#E8891C', 'Scheduled Call': '#E8891C', RF: '#C75450',
        BN: '#7A7067', NI: '#9A6F00', NEW: '#2D9D5E', ACT: '#2D9D5E'
      };
      return map[status] || '#A09E98';
    },

    // ---- FEATURE: Mark & Freeze (Pin to top) ----

    freezeClient(client) {
      if (this.frozenClients.length >= 2) {
        this.c1ShowToast('Max 2 pinned clients', '#E05A3A');
        return;
      }
      const name = (client.first_name || '') + ' ' + (client.last_name || '');
      this.frozenClients.push({ id: client.id, name: name.trim() });
      localStorage.setItem('c1_frozen', JSON.stringify(this.frozenClients));
      this.c1ShowToast('Pinned: ' + name.trim());
    },

    unfreeze(clientId) {
      this.frozenClients = this.frozenClients.filter(c => c.id !== clientId);
      localStorage.setItem('c1_frozen', JSON.stringify(this.frozenClients));
    },

    // ---- FEATURE: Right-click context menu ----

    c1OpenContext(event, client) {
      this.c1ContextMenu = {
        show: true,
        x: Math.min(event.clientX, window.innerWidth - 160),
        y: Math.min(event.clientY, window.innerHeight - 100),
        client
      };
    },

    c1HideContext() {
      if (this.c1ContextMenu.show) this.c1ContextMenu.show = false;
    },

    c1PinFromContext() {
      if (this.c1ContextMenu.client) this.freezeClient(this.c1ContextMenu.client);
      this.c1ContextMenu.show = false;
    },

    // ---- FEATURE: Mini Game ----

    c1SelectMiniGame(game) {
      this.c1MiniActiveGame = game;
      this.c1MiniCurrentScore = 0;
    },

    c1MiniStopGame() {
      this.c1MiniHandleGameOver(this.c1MiniCurrentScore);
    },

    c1MiniHandleGameOver(score) {
      if (score > 0) {
        apiClientCreator('games/score').post('', {
          game_id: this.c1MiniActiveGame.id,
          score: score,
          mode: 'mini',
          during_call: this.c1CallActive
        }).then(res => {
          if (res.data && res.data.credits != null) {
            this.c1MiniGameCredits = res.data.credits;
          }
        }).catch(() => { /* silent */ });
      }
      this.c1MiniActiveGame = null;
      this.c1MiniCurrentScore = 0;
    },

    c1CopyFromContext(type) {
      const client = this.c1ContextMenu.client;
      if (!client) return;
      let val = '';
      if (type === 'name') val = (client.first_name || '') + ' ' + (client.last_name || '');
      if (type === 'id') val = String(client.id);
      if (navigator.clipboard && val) navigator.clipboard.writeText(val.trim()).catch(() => {});
      this.c1ShowToast('Copied: ' + val.trim());
      this.c1ContextMenu.show = false;
    },

    // ---- FEATURE: Live AI Coach ----

    async c1LoadCoach(clientId) {
      if (!clientId) return;
      this.c1CoachLoading = true;
      this.c1CoachData = null;
      this.c1CoachClientId = clientId;
      const t0 = performance.now();
      try {
        const r = await fetch('/api/admin/viopa/client-coach/' + clientId, {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') }
        });
        const d = await r.json();
        this.c1LastApiMs = Math.round(performance.now() - t0);
        if (d.success) this.c1CoachData = d.data;
      } catch(e) {
        console.error('Coach load failed', e);
      }
      this.c1CoachLoading = false;
    },

    c1CopyScript() {
      if (!this.c1CoachData || !this.c1CoachData.suggested_reply) return;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.c1CoachData.suggested_reply).catch(() => {});
      }
      this.c1ShowToast('Script copied to clipboard');
    },

    c1CoachTakeAction() {
      if (!this.c1CoachData) return;
      const action = this.c1CoachData.next_action;
      if (action.type === 'call_now' || action.type === 'schedule') {
        const client = (this.clients || []).find(c => c.id === this.c1CardSelected);
        if (action.type === 'call_now' && client && client.phones && client.phones[0]) {
          window.open('tel:' + client.phones[0].contact_value);
        } else if (action.type === 'schedule' && this.c1CardSelected) {
          this.c1TagPicker = { cid: this.c1CardSelected, type: 'sc', loading: false };
        }
      }
    },

    // ---- FEATURE: VIOPA AI Agent Suggestion ----

    c1LoadViopaScore: function() {
      var self = this;
      var client = self.c1DrawerClient || (self.clients || []).find(function(c) { return c.id === self.c1CardSelected; });
      if (!client) return;
      self.c1ViopaLoading = true;
      self.c1ViopaSuggestions = [];
      var country = client.country || client.country_id || '';
      var campaignId = client.campaign_id || 1;
      var keyword = client.keyword || '';
      var url = '/api/admin/viopa/score?country=' + encodeURIComponent(country) + '&campaign_id=' + campaignId + '&keyword=' + encodeURIComponent(keyword);
      fetch(url, { headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } })
        .then(function(r) { return r.json(); })
        .then(function(d) {
          self.c1ViopaSuggestions = (d.top || []).slice(0, 3);
          self.c1ViopaLoading = false;
        })
        .catch(function() { self.c1ViopaLoading = false; });
    },

    c1SelectViopaAgent: function(agent) {
      this.c1ViopaSuggestions = [];
      // Set the agent in the transfer form or trigger assignment
      if (this.c1PickerForm && this.c1PickerForm.tr) this.c1PickerForm.tr.to = agent.agent_id;
      // If assign slide is open, assign directly
      if (this.c1AssignSlide && this.c1AssignSlide.open) {
        this.c1AssignFromSlide({ id: agent.agent_id, full_name: agent.name || agent.agent_name || '' });
      }
    },

    // ---- FEATURE: CSV Export ----

    async c1ExportCSV() {
      this.c1ExportLoading = true;
      try {
        const params = { ...this.getQueryParams(), per_page: 5000, page: 1 };
        const res = await apiClientCreator('client/filter-list').get('', { params });
        const clients = res.data.data || res.data || [];
        const headers = ['ID','First Name','Last Name','Phone','Email','Country','Call Status','Last Scheduled','Assigned To','Created'];
        const rows = clients.map(c => [
          c.id,
          c.first_name || '',
          c.last_name || '',
          (c.phones && c.phones[0]) ? c.phones[0].contact_value : '',
          (c.emails && c.emails[0]) ? c.emails[0].contact_value : '',
          c.country ? c.country.name : '',
          c.call_status || '',
          c.last_scheduled_on || '',
          (c.assignment && c.assignment.assigned_to) ? c.assignment.assigned_to.full_name : '',
          c.created_at ? c.created_at.slice(0,10) : ''
        ]);
        const csv = [headers, ...rows].map(r => r.map(v => `"${String(v).replace(/"/g,'""')}"`).join(',')).join('\n');
        const blob = new Blob([csv], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a'); a.href = url;
        a.download = `clients-${new Date().toISOString().slice(0,10)}.csv`;
        a.click(); URL.revokeObjectURL(url);
      } catch(e) { console.error('Export failed', e); }
      this.c1ExportLoading = false;
    },

    async c1ExportXLS() {
      this.c1ExportLoading = true;
      try {
        const params = { ...this.getQueryParams(), per_page: 5000, page: 1 };
        const res = await apiClientCreator('client/filter-list').get('', { params });
        const clients = res.data.data || res.data || [];
        const headers = ['ID','First Name','Last Name','Phone','Email','Country','Call Status','Last Scheduled','Assigned To','Created'];
        const rows = clients.map(c => [
          c.id,
          c.first_name || '',
          c.last_name || '',
          (c.phones && c.phones[0]) ? c.phones[0].contact_value : '',
          (c.emails && c.emails[0]) ? c.emails[0].contact_value : '',
          c.country ? c.country.name : '',
          c.call_status || '',
          c.last_scheduled_on || '',
          (c.assignment && c.assignment.assigned_to) ? c.assignment.assigned_to.full_name : '',
          c.created_at ? c.created_at.slice(0,10) : ''
        ]);
        const esc = v => String(v).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
        const tableHtml = `<table><tr>${headers.map(h=>`<th><b>${esc(h)}</b></th>`).join('')}</tr>${rows.map(r=>`<tr>${r.map(v=>`<td>${esc(v)}</td>`).join('')}</tr>`).join('')}</table>`;
        const xlsContent = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Clients</x:Name></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta charset="UTF-8"></head><body>${tableHtml}</body></html>`;
        const blob = new Blob([xlsContent], { type: 'application/vnd.ms-excel' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a'); a.href = url;
        a.download = `clients-${new Date().toISOString().slice(0,10)}.xls`;
        a.click(); URL.revokeObjectURL(url);
      } catch(e) { console.error('Export XLS failed', e); }
      this.c1ExportLoading = false;
    },

    // ---- FEATURE: SMS Quick-Send ----

    c1OpenSms(client) {
      this.c1SmsModal = client;
      this.c1SmsText = '';
    },
    async c1SendSms() {
      if (!this.c1SmsModal || !this.c1SmsText.trim()) return;
      this.c1SmsSending = true;
      try {
        await apiClientCreator('client/sms/sendCostumeSms').post('', {
          client_id: this.c1SmsModal.id,
          message: this.c1SmsText
        });
        this.c1SmsModal = null;
        this.c1SmsText = '';
      } catch(e) { console.error('SMS failed', e); }
      this.c1SmsSending = false;
    },

    // ---- FEATURE: Survey / Questions in Drawer ----
    async c1LoadSurvey(clientId) {
      this.c1DrawerSurveyLoading = true;
      try {
        const r = await apiClientCreator("client/questions/" + clientId).get("");
        this.c1DrawerSurvey = r.data || null;
      } catch(e) {
        this.c1DrawerSurvey = null;
      }
      this.c1DrawerSurveyLoading = false;
    },

    // ---- FEATURE: CMS Platform Actions ----

    async c1ResetPlatformPassword(client) {
      if (!client || !confirm(`Reset platform password for ${client.full_name || client.first_name}?`)) return;
      this.c1CmsLoading = true; this.c1CmsMsg = null;
      try {
        await apiClientCreator(`client/cms/password/${client.id}`).post('');
        this.c1CmsMsg = { ok: true, text: 'Password reset sent to client' };
      } catch(e) { this.c1CmsMsg = { ok: false, text: 'Failed: ' + ((e.response && e.response.data && e.response.data.message) || 'Error') }; }
      this.c1CmsLoading = false;
    },
    async c1ChangePlatformPlan(client) {
      if (!client || !this.c1CmsPlan) return;
      this.c1CmsLoading = true; this.c1CmsMsg = null;
      try {
        await apiClientCreator(`client/cms/plan/${client.id}`).post('', { plan: this.c1CmsPlan });
        this.c1CmsMsg = { ok: true, text: `Plan changed to ${this.c1CmsPlan}` };
      } catch(e) { this.c1CmsMsg = { ok: false, text: 'Failed: ' + ((e.response && e.response.data && e.response.data.message) || 'Error') }; }
      this.c1CmsLoading = false;
    },

    // ---- FEATURE: Keyboard shortcuts ----

    handleKeyShortcut(e) {
      if (!e.altKey) return;
      const selectedClient = (this.clients || []).find(c => c.id === this.c1CardSelected);
      if (!selectedClient) return;
      const shortcuts = { '1': 'na', '2': 'sc', '3': 'rf', '4': 'bn', '5': 'ni' };
      const tagType = shortcuts[e.key];
      if (!tagType) return;
      e.preventDefault();
      // Open the tag picker on the selected client with the appropriate tag type
      this.c1TagPicker = { cid: selectedClient.id, type: tagType, loading: false };
      const labels = { na: 'No Answer', sc: 'Scheduled Call', rf: 'Referral', bn: 'Bad Number', ni: 'Not Interested' };
      this.c1ShowToast('Alt+' + e.key + ' — ' + labels[tagType] + ' picker opened');
    },

    // ---- FEATURE: Admin Suggestions in Viki panel ----
    async c1LoadSuggestions() {
      this.c1SuggestLoading = true;
      const suggestions = [];
      try {
        const ni = await apiClientCreator('admin/suggestions/ni-analysis').get('').catch(() => null);
        if (ni && ni.data) {
          const count = Array.isArray(ni.data) ? ni.data.length : (ni.data.count || 0);
          if (count > 0) suggestions.push({
            icon: '🔄', label: 'NI clients ready to retry', sub: 'Not-interested leads worth contacting', count,
            action: () => { this.resetAllFilters(); this.filters.not_interested = true; this.debouncedClientsQuery(); }
          });
        }
      } catch(e) {}
      try {
        const daily = await apiClientCreator('admin/suggestions/daily-report').get('').catch(() => null);
        if (daily && daily.data) {
          const items = Array.isArray(daily.data) ? daily.data : [];
          items.forEach(item => suggestions.push({ icon: '📋', label: item.label || item.title || 'Action item', sub: item.description || '' }));
        }
      } catch(e) {}
      // Always add static suggestions based on current data
      if (this.pagination && this.pagination.total) {
        suggestions.push({ icon: '📊', label: `${this.pagination.total} active leads`, sub: 'Current filtered pool', count: null });
      }
      this.c1Suggestions = suggestions;
      this.c1SuggestLoading = false;
    }
  }
};
</script>

<style>
/* c1-design CSS loaded globally via src/assets/css/c1-design.css */

/* ---- FEATURE: Purple NA Time ---- */
.c1-row--purple-time {
  border-left: 3px solid #9c27b0 !important;
  background: rgba(156, 39, 176, 0.06) !important;
}
.c1-row--purple-time .c1-box-nm {
  color: #ce93d8;
}

/* ---- FEATURE: History Channel ---- */
.c1-history-strip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: rgba(99, 102, 241, 0.04);
  border-top: 1px solid var(--c1-brd, #E4E3DF);
  overflow-x: auto;
  scrollbar-width: none;
  flex-shrink: 0;
  position: sticky;
  bottom: 40px;
  z-index: 10;
}
.c1-history-strip::-webkit-scrollbar { display: none; }
.c1-history-lbl {
  font-size: 10px;
  color: var(--c1-t3, #A09E98);
  white-space: nowrap;
  flex-shrink: 0;
}
.c1-history-item {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  background: var(--c1-card, #fff);
  border: 1px solid var(--c1-brd, #E4E3DF);
  border-radius: 12px;
  cursor: pointer;
  font-size: 11px;
  white-space: nowrap;
  transition: border-color 0.2s;
  flex-shrink: 0;
}
.c1-history-item:hover { border-color: #7C5CFC; }
.c1-history-name { color: var(--c1-t1, #1A1A1A); font-weight: 500; }
.c1-history-tag {
  font-size: 9px;
  color: #fff;
  padding: 1px 5px;
  border-radius: 8px;
  font-weight: 700;
}

/* ---- FEATURE: Frozen/Pinned ---- */
.c1-frozen-strip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  background: rgba(124, 92, 252, 0.05);
  border-top: 1px solid rgba(124, 92, 252, 0.15);
  overflow-x: auto;
  scrollbar-width: none;
  flex-shrink: 0;
}
.c1-frozen-strip::-webkit-scrollbar { display: none; }
.c1-frozen-lbl {
  font-size: 10px;
  color: var(--c1-t3, #A09E98);
  white-space: nowrap;
  flex-shrink: 0;
}
.c1-frozen-item {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  background: rgba(124, 92, 252, 0.08);
  border: 1px solid rgba(124, 92, 252, 0.25);
  border-radius: 12px;
  cursor: pointer;
  font-size: 11px;
  white-space: nowrap;
  color: #6c3fb5;
}
.c1-frozen-x {
  background: none;
  border: none;
  color: #6c3fb5;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  padding: 0 2px;
  opacity: 0.7;
}
.c1-frozen-x:hover { opacity: 1; }

/* ---- FEATURE: Keyboard shortcut bar ---- */
.c1-kb-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 3px 12px;
  background: var(--c1-bg, #F4F3F0);
  border-top: 1px solid var(--c1-brd, #E4E3DF);
  font-size: 9px;
  color: var(--c1-t4, #6B6762);
  flex-shrink: 0;
  position: sticky;
  bottom: 0;
  z-index: 10;
}
.c1-kb-hint { font-weight: 500; letter-spacing: 0.02em; }
.c1-kb-sep { opacity: 0.4; }

/* ---- FEATURE: Right-click context menu ---- */
.c1-ctx-menu {
  position: fixed;
  z-index: 9999;
  background: var(--c1-surface, #1C1B19);
  border: 1px solid var(--c1-border, rgba(255,255,255,0.12));
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.4);
  min-width: 148px;
  overflow: hidden;
}
.c1-ctx-item {
  padding: 9px 14px;
  font-size: 12px;
  color: var(--c1-t1, #EDE8E3);
  cursor: pointer;
  transition: background 0.15s;
}
.c1-ctx-item:hover { background: rgba(124, 92, 252, 0.12); color: #ce93d8; }

/* ---- FEATURE: Charts Panel Tab Bar ---- */
.c1-charts-tab-bar {
  display: flex;
  gap: 4px;
  padding: 8px 12px 0;
  border-bottom: 1px solid var(--c1-border, rgba(255,255,255,0.08));
  flex-shrink: 0;
}
.c1-charts-tab-btn {
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 6px 12px 7px;
  font-size: .78rem;
  color: var(--c1-muted, #6B6762);
  cursor: pointer;
  font-family: inherit;
  transition: color .2s, border-color .2s;
  margin-bottom: -1px;
}
.c1-charts-tab-btn.active,
.c1-charts-tab-btn:hover {
  color: var(--c1-text, #EDE8E3);
  border-bottom-color: var(--c1-accent, #7C5CFC);
}
.c1-charts-tab-game { margin-left: auto; font-size: .85rem; padding: 6px 8px 7px; opacity: .5; }
.c1-charts-tab-game:hover, .c1-charts-tab-game.active { opacity: 1; }

/* ---- FEATURE: Mini Game ---- */
.c1-mini-game-section { padding: 12px; }
.c1-mini-game-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; }
.c1-mini-label { font-size: .8rem; color: var(--c1-muted, #6B6762); }
.c1-mini-credits { font-size: .8rem; color: #f59e0b; font-weight: 600; }
.c1-mini-game-selector { display: flex; gap: 6px; flex-wrap: wrap; margin-bottom: 12px; }
.c1-mini-game-btn { background: var(--c1-surface, #1C1B19); border: 1px solid var(--c1-border, rgba(255,255,255,0.08)); border-radius: 20px; padding: 4px 10px; font-size: .75rem; color: var(--c1-muted, #6B6762); cursor: pointer; transition: all .2s; }
.c1-mini-game-btn.active, .c1-mini-game-btn:hover { border-color: var(--c1-accent, #7C5CFC); color: var(--c1-text, #EDE8E3); }
.c1-mini-canvas-wrap { background: var(--c1-surface, #1C1B19); border: 1px solid var(--c1-border, rgba(255,255,255,0.08)); border-radius: 8px; overflow: hidden; }
.c1-mini-score-bar { display: flex; justify-content: space-between; padding: 6px 12px; border-bottom: 1px solid var(--c1-border, rgba(255,255,255,0.08)); font-size: .8rem; }
.c1-mini-stop { background: none; border: 1px solid var(--c1-border, rgba(255,255,255,0.08)); border-radius: 4px; padding: 2px 8px; font-size: .75rem; cursor: pointer; color: var(--c1-muted, #6B6762); }
.c1-mini-iframe-wrap { width: 100%; max-height: 340px; overflow: hidden; display: flex; justify-content: center; }
.c1-mini-placeholder { display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 24px; text-align: center; }
.c1-mini-empty { text-align: center; padding: 24px; color: var(--c1-muted, #6B6762); font-size: .85rem; }

/* ---- FEATURE: VIOPA AI Agent Suggestion ---- */
.c1-ai-suggest-btn { background: rgba(99,102,241,.15); border: 1px solid rgba(99,102,241,.4); border-radius: 6px; padding: 4px 12px; font-size: .8rem; color: #6366f1; cursor: pointer; margin-top: 6px; }
.c1-ai-suggest-btn:hover { background: rgba(99,102,241,.25); }
.c1-ai-suggest-btn:disabled { opacity: .5; cursor: not-allowed; }
.c1-viopa-results { margin-top: 8px; display: flex; flex-direction: column; gap: 4px; }
.c1-viopa-agent { background: var(--c1-surface, #1C1B19); border: 1px solid var(--c1-border, rgba(255,255,255,0.08)); border-radius: 6px; padding: 6px 10px; display: flex; justify-content: space-between; cursor: pointer; font-size: .8rem; }
.c1-viopa-agent:hover { border-color: var(--c1-accent, #7C5CFC); }
.c1-viopa-score.golden { color: #f59e0b; }

/* ---- FEATURE: Panel Recent History ---- */
/* ---- Nav Snake ---- */
.c1-nav-snake-wrap { background: #0f172a; border-radius: 8px; margin: 4px 8px 8px; padding: 4px; display: flex; justify-content: center; }

/* ---- Overview DR bar ---- */
.c1-ov-dr-bar { display: flex; gap: 4px; padding: 8px 12px 4px; }
.c1-ov-dr-btn { flex: 1; background: var(--c1-bg); border: 1px solid var(--c1-brd); color: var(--c1-t2); border-radius: 5px; padding: 3px 0; font-size: 10px; font-weight: 600; cursor: pointer; transition: all .12s; }
.c1-ov-dr-btn:hover { border-color: var(--c1-dp); color: var(--c1-dp); }
.c1-ov-dr-btn.on { background: var(--c1-dp); border-color: var(--c1-dp); color: #fff; }

.c1-panel-history-row { display: flex; align-items: center; gap: 8px; padding: 7px 16px; cursor: pointer; transition: background .12s; }
.c1-panel-history-row:hover { background: var(--c1-act); }
.c1-ph-av { width: 26px; height: 26px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 9px; font-weight: 800; color: #fff; flex-shrink: 0; opacity: .9; }
.c1-ph-info { flex: 1; display: flex; align-items: center; gap: 5px; min-width: 0; }
.c1-ph-name { font-size: 11px; font-weight: 600; color: var(--c1-t1); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.c1-ph-tag { font-size: 9px; font-weight: 700; color: #fff; padding: 1px 5px; border-radius: 4px; white-space: nowrap; flex-shrink: 0; opacity: .9; }

/* ---- FEATURE: Activity Timeline ---- */
.c1-timeline { display: flex; flex-direction: column; padding: 0 4px; }
.c1-tl-row { display: flex; gap: 10px; min-height: 40px; }
.c1-tl-left { display: flex; flex-direction: column; align-items: center; width: 16px; flex-shrink: 0; padding-top: 4px; }
.c1-tl-dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; box-shadow: 0 0 6px currentColor; }
.c1-tl-line { width: 2px; flex: 1; background: var(--c1-brd); margin: 3px 0; border-radius: 2px; }
.c1-tl-body { flex: 1; padding-bottom: 14px; }
.c1-tl-hdr { display: flex; align-items: center; gap: 6px; margin-bottom: 2px; }
.c1-tl-badge { font-size: 9px; font-weight: 800; padding: 1px 6px; border-radius: 4px; letter-spacing: .3px; flex-shrink: 0; }
.c1-tl-title { font-size: 12px; font-weight: 600; color: var(--c1-t1); }
.c1-tl-sub { font-size: 11px; color: var(--c1-t2); margin-bottom: 2px; }
.c1-tl-date { font-size: 10px; color: var(--c1-t3); }
.c1-tl-empty { font-size: 11px; color: var(--c1-t3); text-align: center; padding: 12px 0; }

/* ---- FEATURE: CSV Export Button ---- */
.c1-tib-icon-btn { background: none; border: 1px solid rgba(255,255,255,.15); border-radius: 6px; padding: 5px 7px; cursor: pointer; color: inherit; display: flex; align-items: center; transition: background .15s; }
.c1-tib-icon-btn:hover { background: rgba(255,255,255,.08); }
.c1-tib-icon-btn.loading { opacity: .5; pointer-events: none; }
.c1-tib-icon-btn.c1-detail-mode-on { background: rgba(255,255,255,.15); border-color: rgba(255,255,255,.4); color: #fff; }

/* ---- FEATURE: SMS Quick-Send ---- */
.c1-modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,.55); z-index: 9000; display: flex; align-items: center; justify-content: center; }
.c1-modal-box { background: var(--c1-bg, #1a1d2e); border-radius: 12px; width: 380px; max-width: 95vw; border: 1px solid rgba(255,255,255,.1); }
.c1-modal-hdr { display: flex; justify-content: space-between; align-items: center; padding: 14px 16px; border-bottom: 1px solid rgba(255,255,255,.08); font-weight: 600; font-size: 14px; }
.c1-modal-body { padding: 16px; }
.c1-modal-ftr { display: flex; gap: 8px; justify-content: flex-end; padding: 12px 16px; border-top: 1px solid rgba(255,255,255,.08); }
.c1-sms-textarea { width: 100%; background: rgba(255,255,255,.06); border: 1px solid rgba(255,255,255,.12); border-radius: 8px; color: inherit; padding: 10px 12px; font-size: 13px; resize: none; font-family: inherit; box-sizing: border-box; }
.c1-sms-counter { text-align: right; font-size: 11px; opacity: .5; margin-top: 4px; }
.c1-sms-presets { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 10px; }
.c1-sms-preset { background: rgba(255,255,255,.07); border: 1px solid rgba(255,255,255,.1); border-radius: 20px; padding: 4px 10px; font-size: 11px; cursor: pointer; }
.c1-sms-preset:hover { background: rgba(255,255,255,.13); }
.c1-row-sms-btn { background: none; border: none; cursor: pointer; padding: 3px; opacity: .6; color: inherit; border-radius: 4px; }
.c1-row-sms-btn:hover { opacity: 1; background: rgba(255,255,255,.08); }
.c1-btn { padding: 7px 16px; border-radius: 6px; font-size: 13px; cursor: pointer; border: 1px solid transparent; font-weight: 500; }
.c1-btn-ghost { background: rgba(255,255,255,.06); border-color: rgba(255,255,255,.12); color: inherit; }
.c1-btn-primary { background: var(--blue, #0057ff); border-color: var(--blue, #0057ff); color: #fff; }
.c1-btn-primary:disabled { opacity: .4; cursor: not-allowed; }

/* ---- FEATURE: Call Log in Drawer ---- */
.c1-exp-lbl-tog { cursor: pointer; display: flex; align-items: center; }
.c1-exp-lbl-tog:hover { opacity: .8; }
.c1-call-status-badge { padding: 5px 10px; border-radius: 6px; font-size: 12px; font-weight: 600; margin-bottom: 8px; }
.c1-call-status-badge.active { background: rgba(0,200,100,.15); color: #00c864; }
.c1-call-status-badge.idle { background: rgba(255,255,255,.05); opacity: .6; }
.c1-exp-empty { opacity: .4; font-size: 12px; padding: 4px 0; }

/* ---- FEATURE: CMS Platform Actions ---- */
.c1-cms-btn { background: rgba(255,255,255,.08); border: 1px solid rgba(255,255,255,.12); border-radius: 6px; padding: 7px 12px; font-size: 12px; cursor: pointer; color: inherit; width: 100%; text-align: left; transition: background .15s; }
.c1-cms-btn:hover:not(:disabled) { background: rgba(255,255,255,.14); }
.c1-cms-btn:disabled { opacity: .4; cursor: not-allowed; }
.c1-cms-select { flex: 1; background: rgba(255,255,255,.06); border: 1px solid rgba(255,255,255,.12); border-radius: 6px; padding: 7px 10px; font-size: 12px; color: inherit; }
.c1-cms-msg { font-size: 12px; padding: 6px 10px; border-radius: 6px; margin-top: 4px; }
.c1-cms-msg.ok { background: rgba(0,200,100,.12); color: #00c864; }
.c1-cms-msg.err { background: rgba(255,80,80,.12); color: #ff6060; }

/* ---- FEATURE: Duplicate Client Badge ---- */
.c1-dup-badge { background: rgba(255,165,0,.2); color: #ffa500; border: 1px solid rgba(255,165,0,.3); border-radius: 4px; font-size: 9px; font-weight: 700; padding: 1px 5px; letter-spacing: .5px; }

/* ---- FEATURE: Admin Suggestions in Viki panel ---- */
.c1-viki-section { padding: 10px 0 4px; border-top: 1px solid rgba(255,255,255,.06); margin-top: 6px; }
.c1-viki-section-title { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .6px; opacity: .6; padding: 4px 0 8px; display: flex; align-items: center; }
.c1-viki-sub { font-size: 12px; padding: 6px 0; }
.c1-suggest-card { display: flex; align-items: center; gap: 10px; padding: 8px 10px; border-radius: 8px; background: rgba(255,255,255,.04); margin-bottom: 6px; cursor: pointer; transition: background .15s; }
.c1-suggest-card:hover { background: rgba(255,255,255,.08); }
.c1-suggest-icon { font-size: 16px; width: 24px; text-align: center; flex-shrink: 0; }
.c1-suggest-content { flex: 1; min-width: 0; }
.c1-suggest-label { font-size: 12px; font-weight: 600; }
.c1-suggest-sub { font-size: 11px; opacity: .5; margin-top: 1px; }
.c1-suggest-count { background: rgba(0,87,255,.2); color: var(--blue, #0057ff); border-radius: 12px; padding: 2px 8px; font-size: 11px; font-weight: 700; flex-shrink: 0; }

/* ---- FEATURE: Survey / Questions in Drawer ---- */
.c1-survey-row { padding: 6px 0; border-bottom: 1px solid #f1f5f9; }
.c1-survey-row:last-child { border-bottom: none; }
.c1-survey-q { font-size: 11px; color: #64748b; margin-bottom: 2px; }
.c1-survey-a { font-size: 13px; color: #1e293b; font-weight: 500; }

/* ---- FEATURE: Speed Badge (Moat 1) ---- */
.c1-speed-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: .4px;
  text-transform: uppercase;
  background: rgba(232,104,64,.08);
  border: 1px solid rgba(232,104,64,.2);
  color: var(--c1-viki, #e86840);
  white-space: nowrap;
  cursor: default;
  transition: background .3s;
}
.c1-speed-badge--live {
  background: rgba(45,157,94,.1);
  border-color: rgba(45,157,94,.25);
  color: var(--c1-ac, #2d9d5e);
}

/* ---- HEADER: World Clocks + Shift Time ---- */
.c1-tib-center { flex-direction: column; gap: 1px; justify-content: center; overflow: hidden; }
.c1-tib-clocks {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 10px;
  font-weight: 600;
  color: var(--c1-t2);
  white-space: nowrap;
  letter-spacing: .1px;
}
.c1-tib-tz-item { font-variant-numeric: tabular-nums; }
.c1-tib-tz-sep { color: var(--c1-t3); opacity: .4; font-size: 9px; }
/* .c1-tib-shift-pill defined below in SHIFT PILL section */

/* ---- GAME ROW in client row ---- */
.c1-cr-ic-game { background: rgba(34,197,94,.12); color: #22c55e; }
.c1-acc-game { padding: 0; overflow: hidden; border-radius: 0 0 8px 8px; }
.c1-cr-ic-viki { background: rgba(139,92,246,.12); color: #8b5cf6; }
.c1-cr-viki-hint { font-size: 9px; color: var(--c1-t3); margin-left: 6px; opacity: .7; }

/* ---- HAMBURGER BUTTON ---- */
.c1-ham-wrap { position: relative; }
.c1-ham-btn {
  display: flex; align-items: center; justify-content: center;
  width: 36px; height: 36px;
  background: none; border: none; cursor: pointer;
  color: var(--c1-t1); border-radius: 8px;
  transition: background .15s;
}
.c1-ham-btn:hover, .c1-ham-btn.open { background: var(--c1-act); }
.c1-ham-fade-enter-active, .c1-ham-fade-leave-active { transition: opacity .12s, transform .12s; }
.c1-ham-fade-enter, .c1-ham-fade-leave-to { opacity: 0; transform: translateY(-4px); }

/* ---- SHIFT PILL ---- */
.c1-shift-wrap { position: relative; }
.c1-tib-shift-pill {
  cursor: pointer;
  display: inline-flex; align-items: center; gap: 3px;
  padding: 4px 9px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  color: var(--c1-t2);
  background: rgba(255,255,255,.06);
  border: 1px solid rgba(255,255,255,.1);
  transition: background .15s;
  white-space: nowrap;
  user-select: none;
}
.c1-tib-shift-pill:hover, .c1-tib-shift-pill.open { background: var(--c1-act); }

/* ---- TOP ACCORDION DRAWERS — in-flow inside sticky wrapper, truly push content ---- */
.c1-top-drawer {
  /* NOT fixed — flows inside .c1-sticky-top */
  overflow: hidden;
  max-height: 0;
  transition: max-height .35s cubic-bezier(.4,0,.2,1);
  background: var(--c1-card);
  border-bottom: 1px solid var(--c1-brd);
}
.c1-top-drawer.open { max-height: 500px; }

.c1-td-inner { padding: 12px 14px; }

/* Shift drawer layout */
.c1-td-section-lbl { font-size: 9px; font-weight: 700; color: var(--c1-t3); text-transform: uppercase; letter-spacing: .8px; margin-bottom: 8px; }
.c1-td-status-row { display: grid; grid-template-columns: repeat(4,1fr); gap: 8px; margin-bottom: 10px; }
.c1-td-stat { background: rgba(0,0,0,.03); border: 1px solid var(--c1-brd-l); border-radius: 8px; padding: 7px 8px; text-align: center; }
.c1-td-stat-val { font-size: 14px; font-weight: 800; color: var(--c1-t1); font-variant-numeric: tabular-nums; }
.c1-td-stat-lbl { font-size: 9px; color: var(--c1-t3); margin-top: 2px; }
.c1-td-btn-row { display: flex; gap: 6px; flex-wrap: wrap; }
.c1-td-btn {
  flex: 1; min-width: 70px;
  padding: 8px 10px;
  border: 1px solid var(--c1-brd);
  border-radius: 8px;
  background: var(--c1-card);
  font-size: 11px; font-weight: 600; color: var(--c1-t1);
  cursor: pointer; transition: background .15s, border-color .15s;
}
.c1-td-btn:hover { background: var(--c1-act); }
.c1-td-btn.active, .c1-td-btn-shift.active { background: var(--c1-dp); color: #fff; border-color: var(--c1-dp); }
.c1-td-btn-bathroom:hover, .c1-td-btn-bathroom.active { background: rgba(59,130,246,.1); border-color: #3b82f6; color: #3b82f6; }
.c1-td-btn-coffee:hover,   .c1-td-btn-coffee.active   { background: rgba(245,158,11,.1); border-color: #f59e0b; color: #f59e0b; }
.c1-td-btn-break:hover,    .c1-td-btn-break.active     { background: rgba(107,114,128,.1); border-color: #6b7280; color: #6b7280; }
.c1-td-btn-lunch:hover,    .c1-td-btn-lunch.active     { background: rgba(34,197,94,.1); border-color: #22c55e; color: #22c55e; }
.c1-td-btn-end:hover  { background: rgba(239,68,68,.1); border-color: #ef4444; color: #ef4444; }

/* Nav drawer grid */
.c1-td-nav-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); gap: 4px; padding: 10px 12px; }
.c1-td-nav-item {
  display: flex; align-items: center; gap: 8px;
  padding: 9px 10px;
  border-radius: 8px;
  font-size: 12px; font-weight: 500;
  color: var(--c1-t1); text-decoration: none;
  transition: background .12s;
}
.c1-td-nav-item:hover { background: var(--c1-act); }
.c1-td-nav-item.on { background: var(--c1-act); font-weight: 700; }
.c1-td-nav-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }

/* ---- ASSIGN PANEL BACKDROP ---- */
.c1-assign-backdrop {
  position: fixed;
  top: 44px; left: 0; right: 0; bottom: 0;
  z-index: 9998;
  cursor: pointer;
}

/* ---- FEATURE: Live AI Coach (Moat 2) ---- */
.c1-coach-empty {
  padding: 12px 0;
  font-size: 12px;
  color: var(--c1-t3, #a09e98);
  text-align: center;
  line-height: 1.5;
}
.c1-coach-body { display: flex; flex-direction: column; gap: 8px; padding-bottom: 4px; }

/* Readiness gauge */
.c1-coach-gauge-row { display: flex; align-items: center; gap: 10px; padding: 6px 0 2px; }
.c1-coach-gauge-wrap { flex: 1; display: flex; flex-direction: column; gap: 4px; }
.c1-coach-gauge-track { height: 6px; border-radius: 3px; background: rgba(255,255,255,.1); overflow: hidden; }
.c1-coach-gauge-fill { height: 100%; border-radius: 3px; transition: width .5s ease; }
.c1-coach-fill--red    { background: #ef4444; color: #ef4444; }
.c1-coach-fill--orange { background: #f97316; color: #f97316; }
.c1-coach-fill--yellow { background: #eab308; color: #eab308; }
.c1-coach-fill--blue   { background: #60a5fa; color: #60a5fa; }
.c1-coach-gauge-num { font-size: 20px; font-weight: 800; line-height: 1; }
.c1-coach-gauge-info { flex-shrink: 0; }
.c1-coach-gauge-label { font-size: 12px; font-weight: 700; }
.c1-coach-gauge-sub { font-size: 11px; color: var(--c1-t3, #a09e98); margin-top: 2px; }

/* Next action */
.c1-coach-action {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  transition: opacity .15s;
  flex-wrap: wrap;
  line-height: 1.3;
}
.c1-coach-action:hover { opacity: .85; }
.c1-coach-action--call_now { background: rgba(45,157,94,.15); color: var(--c1-ac, #2d9d5e); }
.c1-coach-action--schedule { background: rgba(232,104,64,.12); color: var(--c1-viki, #e86840); }
.c1-coach-action--hold { background: rgba(160,158,152,.1); color: var(--c1-t3, #a09e98); }
.c1-coach-action-lbl { flex-shrink: 0; }
.c1-coach-action-reason { font-size: 10px; font-weight: 400; opacity: .7; width: 100%; margin-left: 18px; }

/* Script */
.c1-coach-script-hdr { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--c1-t3, #a09e98); margin-top: 2px; }
.c1-coach-script {
  background: rgba(255,255,255,.04);
  border: 1px solid rgba(255,255,255,.08);
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 11px;
  line-height: 1.55;
  color: inherit;
  position: relative;
}
.c1-coach-script-text { padding-right: 48px; }
.c1-coach-copy-btn {
  position: absolute;
  right: 8px;
  bottom: 8px;
  background: rgba(255,255,255,.1);
  border: 1px solid rgba(255,255,255,.15);
  border-radius: 5px;
  padding: 3px 8px;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
  color: inherit;
  transition: background .15s;
}
.c1-coach-copy-btn:hover { background: rgba(255,255,255,.18); }

/* Stats rows */
.c1-coach-rows { display: flex; flex-direction: column; gap: 0; }
.c1-coach-row { display: flex; align-items: center; justify-content: space-between; padding: 5px 0; border-bottom: 1px solid rgba(255,255,255,.05); font-size: 12px; }
.c1-coach-row:last-child { border-bottom: none; }
.c1-coach-row-lbl { color: var(--c1-t3, #a09e98); font-size: 11px; }
.c1-coach-row-val { font-weight: 600; text-align: right; }
.c1-coach-profit-badge { background: rgba(45,157,94,.15); color: var(--c1-ac, #2d9d5e); border-radius: 10px; padding: 1px 6px; font-size: 10px; font-weight: 700; margin-left: 5px; }
.c1-coach-dp-val { color: var(--c1-dp, #7c5cfc); }

/* ── Team Filter ──────────────────────────────────────────────────── */
.c1-team-active-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 20px;
  border: 1px solid transparent;
  cursor: pointer;
  letter-spacing: .2px;
  transition: opacity .15s;
}
.c1-team-active-chip:hover { opacity: .75; }
.c1-team-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* ── Shift Start Modal ── */
.c1-shift-modal-overlay {
  position: fixed; inset: 0; z-index: 9000;
  background: rgba(10,12,20,.85);
  backdrop-filter: blur(6px);
  display: flex; align-items: center; justify-content: center;
}
.c1-shift-modal-card {
  background: #1a1d2e;
  border: 1px solid rgba(255,255,255,.1);
  border-radius: 20px;
  padding: 40px 48px;
  text-align: center;
  max-width: 380px;
  width: 90%;
  box-shadow: 0 32px 64px rgba(0,0,0,.6);
}
.c1-shift-modal-icon { font-size: 48px; margin-bottom: 16px; }
.c1-shift-modal-title { font-size: 22px; font-weight: 800; color: #fff; letter-spacing: -.5px; margin-bottom: 8px; }
.c1-shift-modal-sub { font-size: 13px; color: rgba(255,255,255,.5); margin-bottom: 4px; }
.c1-shift-modal-time { font-size: 36px; font-weight: 800; color: #6366f1; letter-spacing: -1px; margin: 12px 0; font-variant-numeric: tabular-nums; }
.c1-shift-modal-hint { font-size: 12px; color: rgba(255,255,255,.35); margin-bottom: 28px; line-height: 1.5; }
.c1-shift-modal-btn {
  width: 100%; padding: 14px 0; background: #6366f1;
  color: #fff; border: none; border-radius: 12px;
  font-size: 15px; font-weight: 700; cursor: pointer;
  transition: background .15s, transform .1s;
  letter-spacing: .3px;
}
.c1-shift-modal-btn:hover { background: #4f46e5; }
.c1-shift-modal-btn:active { transform: scale(.98); }
.c1-shift-modal-fade-enter-active, .c1-shift-modal-fade-leave-active { transition: opacity .25s; }
.c1-shift-modal-fade-enter, .c1-shift-modal-fade-leave-to { opacity: 0; }
</style>
